import { GENDER } from '../../../../../resources/utilities'

// BMI

    // BOYS

const bmiBoysThree = [
  {x: 0, y: 11.213},
  {x: 1, y: 12.13},
  {x: 2, y: 13.21},
  {x: 3, y: 13.753},
  {x: 4, y: 14.051},
  {x: 5, y: 14.22},
  {x: 6, y: 14.3},
  {x: 7, y: 14.311},
  {x: 8, y: 14.272},
  {x: 9, y: 14.2},
  {x: 10, y: 14.108},
  {x: 11, y: 14.008},
  {x: 12, y: 13.908},
  {x: 13, y: 13.812},
  {x: 14, y: 13.722},
  {x: 15, y: 13.638},
  {x: 16, y: 13.561},
  {x: 17, y: 13.492},
  {x: 18, y: 13.43},
  {x: 19, y: 13.375},
  {x: 20, y: 13.327},
  {x: 21, y: 13.286},
  {x: 22, y: 13.253},
  {x: 23, y: 13.226},
  {x: 24, y: 13.462},
  {x: 25, y: 13.437},
  {x: 26, y: 13.414},
  {x: 27, y: 13.391},
  {x: 29, y: 13.369},
  {x: 30, y: 13.347},
  {x: 31, y: 13.325},
  {x: 32, y: 13.303},
  {x: 33, y: 13.281},
  {x: 34, y: 13.258},
  {x: 35, y: 13.235},
  {x: 36, y: 13.212},
  {x: 37, y: 13.189},
  {x: 38, y: 13.166},
  {x: 39, y: 13.143},
  {x: 40, y: 13.12},
  {x: 41, y: 13.097},
  {x: 42, y: 13.074},
  {x: 43, y: 13.051},
  {x: 44, y: 13.028},
  {x: 45, y: 13.007},
  {x: 46, y: 12.986},
  {x: 47, y: 12.966},
  {x: 48, y: 12.948},
  {x: 49, y: 12.93},
  {x: 50, y: 12.914},
  {x: 51, y: 12.899},
  {x: 52, y: 12.885},
  {x: 53, y: 12.873},
  {x: 54, y: 12.862},
  {x: 55, y: 12.853},
  {x: 56, y: 12.844},
  {x: 57, y: 12.837},
  {x: 58, y: 12.83},
  {x: 59, y: 12.825},
  {x: 60, y: 12.821},
  {x: 61, y: 13.148},
  {x: 62, y: 13.144},
  {x: 63, y: 13.14},
  {x: 64, y: 13.138},
  {x: 65, y: 13.137},
  {x: 66, y: 13.137},
  {x: 67, y: 13.138},
  {x: 68, y: 13.14},
  {x: 69, y: 13.143},
  {x: 70, y: 13.146},
  {x: 71, y: 13.151},
  {x: 72, y: 13.157},
  {x: 73, y: 13.163},
  {x: 74, y: 13.17},
  {x: 75, y: 13.177},
  {x: 76, y: 13.185},
  {x: 77, y: 13.193},
  {x: 78, y: 13.202},
  {x: 79, y: 13.212},
  {x: 80, y: 13.222},
  {x: 81, y: 13.232},
  {x: 82, y: 13.242},
  {x: 83, y: 13.253},
  {x: 84, y: 13.265},
  {x: 85, y: 13.276},
  {x: 86, y: 13.288},
  {x: 87, y: 13.301},
  {x: 88, y: 13.313},
  {x: 89, y: 13.326},
  {x: 90, y: 13.339},
  {x: 91, y: 13.352},
  {x: 92, y: 13.365},
  {x: 93, y: 13.379},
  {x: 94, y: 13.393},
  {x: 95, y: 13.407},
  {x: 96, y: 13.422},
  {x: 97, y: 13.436},
  {x: 98, y: 13.451},
  {x: 99, y: 13.466},
  {x: 100, y: 13.482},
  {x: 101, y: 13.497},
  {x: 102, y: 13.513},
  {x: 103, y: 13.529},
  {x: 104, y: 13.545},
  {x: 105, y: 13.562},
  {x: 106, y: 13.579},
  {x: 107, y: 13.596},
  {x: 108, y: 13.614},
  {x: 109, y: 13.632},
  {x: 110, y: 13.65},
  {x: 111, y: 13.669},
  {x: 112, y: 13.689},
  {x: 113, y: 13.708},
  {x: 114, y: 13.729},
  {x: 115, y: 13.75},
  {x: 116, y: 13.771},
  {x: 117, y: 13.794},
  {x: 118, y: 13.816},
  {x: 119, y: 13.84},
  {x: 120, y: 13.863},
  {x: 121, y: 13.888},
  {x: 122, y: 13.913},
  {x: 123, y: 13.938},
  {x: 124, y: 13.964},
  {x: 125, y: 13.99},
  {x: 126, y: 14.017},
  {x: 127, y: 14.045},
  {x: 128, y: 14.073},
  {x: 129, y: 14.102},
  {x: 130, y: 14.131},
  {x: 131, y: 14.161},
  {x: 132, y: 14.191},
  {x: 133, y: 14.222},
  {x: 134, y: 14.253},
  {x: 135, y: 14.285},
  {x: 136, y: 14.317},
  {x: 137, y: 14.35},
  {x: 138, y: 14.383},
  {x: 139, y: 14.417},
  {x: 140, y: 14.452},
  {x: 141, y: 14.487},
  {x: 142, y: 14.523},
  {x: 143, y: 14.559},
  {x: 144, y: 14.596},
  {x: 145, y: 14.634},
  {x: 146, y: 14.672},
  {x: 147, y: 14.711},
  {x: 148, y: 14.751},
  {x: 149, y: 14.791},
  {x: 150, y: 14.831},
  {x: 151, y: 14.873},
  {x: 152, y: 14.915},
  {x: 153, y: 14.957},
  {x: 154, y: 15},
  {x: 155, y: 15.044},
  {x: 156, y: 15.087},
  {x: 157, y: 15.132},
  {x: 158, y: 15.177},
  {x: 159, y: 15.222},
  {x: 160, y: 15.268},
  {x: 161, y: 15.313},
  {x: 162, y: 15.36},
  {x: 163, y: 15.406},
  {x: 164, y: 15.452},
  {x: 165, y: 15.499},
  {x: 166, y: 15.545},
  {x: 167, y: 15.592},
  {x: 168, y: 15.639},
  {x: 169, y: 15.685},
  {x: 170, y: 15.731},
  {x: 171, y: 15.778},
  {x: 172, y: 15.824},
  {x: 173, y: 15.87},
  {x: 174, y: 15.916},
  {x: 175, y: 15.961},
  {x: 176, y: 16.007},
  {x: 177, y: 16.052},
  {x: 178, y: 16.097},
  {x: 179, y: 16.142},
  {x: 180, y: 16.186},
  {x: 181, y: 16.23},
  {x: 182, y: 16.274},
  {x: 183, y: 16.318},
  {x: 184, y: 16.361},
  {x: 185, y: 16.404},
  {x: 186, y: 16.446},
  {x: 187, y: 16.488},
  {x: 188, y: 16.53},
  {x: 189, y: 16.571},
  {x: 190, y: 16.612},
  {x: 191, y: 16.652},
  {x: 192, y: 16.692},
  {x: 193, y: 16.732},
  {x: 194, y: 16.77},
  {x: 195, y: 16.809},
  {x: 196, y: 16.847},
  {x: 197, y: 16.884},
  {x: 198, y: 16.921},
  {x: 199, y: 16.958},
  {x: 200, y: 16.994},
  {x: 201, y: 17.029},
  {x: 202, y: 17.064},
  {x: 203, y: 17.098},
  {x: 204, y: 17.132},
  {x: 205, y: 17.165},
  {x: 206, y: 17.198},
  {x: 207, y: 17.231},
  {x: 208, y: 17.262},
  {x: 209, y: 17.293},
  {x: 210, y: 17.324},
  {x: 211, y: 17.354},
  {x: 212, y: 17.383},
  {x: 213, y: 17.412},
  {x: 214, y: 17.441},
  {x: 215, y: 17.469},
  {x: 216, y: 17.496},
  {x: 217, y: 17.523},
  {x: 218, y: 17.549},
  {x: 219, y: 17.575},
  {x: 220, y: 17.6},
  {x: 221, y: 17.624},
  {x: 222, y: 17.648},
  {x: 223, y: 17.671},
  {x: 224, y: 17.694},
  {x: 225, y: 17.716},
  {x: 226, y: 17.738},
  {x: 227, y: 17.759},
  {x: 228, y: 17.779}
]

const bmiBoysFiftheen = [
  {x: 0, y: 12.118},
  {x: 1, y: 13.202},
  {x: 2, y: 14.324},
  {x: 3, y: 14.879},
  {x: 4, y: 15.177},
  {x: 5, y: 15.34},
  {x: 6, y: 15.41},
  {x: 7, y: 15.408},
  {x: 8, y: 15.355},
  {x: 9, y: 15.267},
  {x: 10, y: 15.159},
  {x: 11, y: 15.044},
  {x: 12, y: 14.929},
  {x: 13, y: 14.819},
  {x: 14, y: 14.716},
  {x: 15, y: 14.621},
  {x: 16, y: 14.534},
  {x: 17, y: 14.455},
  {x: 18, y: 14.384},
  {x: 19, y: 14.32},
  {x: 20, y: 14.265},
  {x: 21, y: 14.218},
  {x: 22, y: 14.178},
  {x: 23, y: 14.146},
  {x: 24, y: 14.391},
  {x: 25, y: 14.364},
  {x: 26, y: 14.339},
  {x: 27, y: 14.314},
  {x: 29, y: 14.29},
  {x: 30, y: 14.267},
  {x: 31, y: 14.244},
  {x: 32, y: 14.221},
  {x: 33, y: 14.198},
  {x: 34, y: 14.175},
  {x: 35, y: 14.153},
  {x: 36, y: 14.131},
  {x: 37, y: 14.11},
  {x: 38, y: 14.089},
  {x: 39, y: 14.069},
  {x: 40, y: 14.05},
  {x: 41, y: 14.03},
  {x: 42, y: 14.011},
  {x: 43, y: 13.993},
  {x: 44, y: 13.975},
  {x: 45, y: 13.958},
  {x: 46, y: 13.942},
  {x: 47, y: 13.927},
  {x: 48, y: 13.913},
  {x: 49, y: 13.9},
  {x: 50, y: 13.889},
  {x: 51, y: 13.879},
  {x: 52, y: 13.87},
  {x: 53, y: 13.863},
  {x: 54, y: 13.857},
  {x: 55, y: 13.852},
  {x: 56, y: 13.848},
  {x: 57, y: 13.844},
  {x: 58, y: 13.842},
  {x: 59, y: 13.841},
  {x: 60, y: 13.84},
  {x: 61, y: 14.03},
  {x: 62, y: 14.026},
  {x: 63, y: 14.023},
  {x: 64, y: 14.02},
  {x: 65, y: 14.019},
  {x: 66, y: 14.019},
  {x: 67, y: 14.02},
  {x: 68, y: 14.023},
  {x: 69, y: 14.026},
  {x: 70, y: 14.031},
  {x: 71, y: 14.036},
  {x: 72, y: 14.042},
  {x: 73, y: 14.049},
  {x: 74, y: 14.057},
  {x: 75, y: 14.065},
  {x: 76, y: 14.075},
  {x: 77, y: 14.084},
  {x: 78, y: 14.095},
  {x: 79, y: 14.105},
  {x: 80, y: 14.117},
  {x: 81, y: 14.128},
  {x: 82, y: 14.141},
  {x: 83, y: 14.153},
  {x: 84, y: 14.166},
  {x: 85, y: 14.18},
  {x: 86, y: 14.194},
  {x: 87, y: 14.208},
  {x: 88, y: 14.223},
  {x: 89, y: 14.238},
  {x: 90, y: 14.253},
  {x: 91, y: 14.268},
  {x: 92, y: 14.284},
  {x: 93, y: 14.3},
  {x: 94, y: 14.317},
  {x: 95, y: 14.333},
  {x: 96, y: 14.35},
  {x: 97, y: 14.368},
  {x: 98, y: 14.385},
  {x: 99, y: 14.403},
  {x: 100, y: 14.421},
  {x: 101, y: 14.44},
  {x: 102, y: 14.459},
  {x: 103, y: 14.478},
  {x: 104, y: 14.497},
  {x: 105, y: 14.517},
  {x: 106, y: 14.537},
  {x: 107, y: 14.558},
  {x: 108, y: 14.579},
  {x: 109, y: 14.6},
  {x: 110, y: 14.622},
  {x: 111, y: 14.645},
  {x: 112, y: 14.668},
  {x: 113, y: 14.691},
  {x: 114, y: 14.716},
  {x: 115, y: 14.741},
  {x: 116, y: 14.766},
  {x: 117, y: 14.793},
  {x: 118, y: 14.82},
  {x: 119, y: 14.847},
  {x: 120, y: 14.875},
  {x: 121, y: 14.904},
  {x: 122, y: 14.933},
  {x: 123, y: 14.963},
  {x: 124, y: 14.994},
  {x: 125, y: 15.025},
  {x: 126, y: 15.056},
  {x: 127, y: 15.089},
  {x: 128, y: 15.122},
  {x: 129, y: 15.156},
  {x: 130, y: 15.19},
  {x: 131, y: 15.225},
  {x: 132, y: 15.26},
  {x: 133, y: 15.296},
  {x: 134, y: 15.333},
  {x: 135, y: 15.37},
  {x: 136, y: 15.408},
  {x: 137, y: 15.447},
  {x: 138, y: 15.486},
  {x: 139, y: 15.525},
  {x: 140, y: 15.566},
  {x: 141, y: 15.607},
  {x: 142, y: 15.648},
  {x: 143, y: 15.691},
  {x: 144, y: 15.734},
  {x: 145, y: 15.778},
  {x: 146, y: 15.822},
  {x: 147, y: 15.867},
  {x: 148, y: 15.913},
  {x: 149, y: 15.96},
  {x: 150, y: 16.007},
  {x: 151, y: 16.055},
  {x: 152, y: 16.103},
  {x: 153, y: 16.153},
  {x: 154, y: 16.202},
  {x: 155, y: 16.253},
  {x: 156, y: 16.303},
  {x: 157, y: 16.355},
  {x: 158, y: 16.407},
  {x: 159, y: 16.459},
  {x: 160, y: 16.512},
  {x: 161, y: 16.565},
  {x: 162, y: 16.618},
  {x: 163, y: 16.672},
  {x: 164, y: 16.726},
  {x: 165, y: 16.779},
  {x: 166, y: 16.833},
  {x: 167, y: 16.887},
  {x: 168, y: 16.941},
  {x: 169, y: 16.995},
  {x: 170, y: 17.049},
  {x: 171, y: 17.103},
  {x: 172, y: 17.157},
  {x: 173, y: 17.21},
  {x: 174, y: 17.264},
  {x: 175, y: 17.317},
  {x: 176, y: 17.37},
  {x: 177, y: 17.423},
  {x: 178, y: 17.475},
  {x: 179, y: 17.528},
  {x: 180, y: 17.58},
  {x: 181, y: 17.631},
  {x: 182, y: 17.683},
  {x: 183, y: 17.734},
  {x: 184, y: 17.784},
  {x: 185, y: 17.835},
  {x: 186, y: 17.885},
  {x: 187, y: 17.935},
  {x: 188, y: 17.984},
  {x: 189, y: 18.032},
  {x: 190, y: 18.081},
  {x: 191, y: 18.129},
  {x: 192, y: 18.176},
  {x: 193, y: 18.223},
  {x: 194, y: 18.27},
  {x: 195, y: 18.316},
  {x: 196, y: 18.361},
  {x: 197, y: 18.406},
  {x: 198, y: 18.451},
  {x: 199, y: 18.495},
  {x: 200, y: 18.538},
  {x: 201, y: 18.581},
  {x: 202, y: 18.624},
  {x: 203, y: 18.666},
  {x: 204, y: 18.707},
  {x: 205, y: 18.748},
  {x: 206, y: 18.788},
  {x: 207, y: 18.828},
  {x: 208, y: 18.868},
  {x: 209, y: 18.906},
  {x: 210, y: 18.944},
  {x: 211, y: 18.982},
  {x: 212, y: 19.019},
  {x: 213, y: 19.056},
  {x: 214, y: 19.092},
  {x: 215, y: 19.128},
  {x: 216, y: 19.163},
  {x: 217, y: 19.197},
  {x: 218, y: 19.231},
  {x: 219, y: 19.264},
  {x: 220, y: 19.297},
  {x: 221, y: 19.329},
  {x: 222, y: 19.361},
  {x: 223, y: 19.392},
  {x: 224, y: 19.422},
  {x: 225, y: 19.452},
  {x: 226, y: 19.482},
  {x: 227, y: 19.511},
  {x: 228, y: 19.539}
]

const bmiBoysFifthy = [
  {x: 0, y: 13.336},
  {x: 1, y: 14.6},
  {x: 2, y: 15.798},
  {x: 3, y: 16.38},
  {x: 4, y: 16.687},
  {x: 5, y: 16.849},
  {x: 6, y: 16.911},
  {x: 7, y: 16.897},
  {x: 8, y: 16.828},
  {x: 9, y: 16.721},
  {x: 10, y: 16.595},
  {x: 11, y: 16.461},
  {x: 12, y: 16.328},
  {x: 13, y: 16.202},
  {x: 14, y: 16.084},
  {x: 15, y: 15.974},
  {x: 16, y: 15.874},
  {x: 17, y: 15.783},
  {x: 18, y: 15.701},
  {x: 19, y: 15.628},
  {x: 20, y: 15.563},
  {x: 21, y: 15.508},
  {x: 22, y: 15.461},
  {x: 23, y: 15.423},
  {x: 24, y: 15.675},
  {x: 25, y: 15.646},
  {x: 26, y: 15.618},
  {x: 27, y: 15.591},
  {x: 29, y: 15.565},
  {x: 30, y: 15.539},
  {x: 31, y: 15.514},
  {x: 32, y: 15.49},
  {x: 33, y: 15.466},
  {x: 34, y: 15.444},
  {x: 35, y: 15.423},
  {x: 36, y: 15.403},
  {x: 37, y: 15.385},
  {x: 38, y: 15.369},
  {x: 39, y: 15.354},
  {x: 40, y: 15.34},
  {x: 41, y: 15.327},
  {x: 42, y: 15.314},
  {x: 43, y: 15.303},
  {x: 44, y: 15.293},
  {x: 45, y: 15.283},
  {x: 46, y: 15.275},
  {x: 47, y: 15.267},
  {x: 48, y: 15.261},
  {x: 49, y: 15.256},
  {x: 50, y: 15.253},
  {x: 51, y: 15.25},
  {x: 52, y: 15.25},
  {x: 53, y: 15.25},
  {x: 54, y: 15.252},
  {x: 55, y: 15.254},
  {x: 56, y: 15.258},
  {x: 57, y: 15.261},
  {x: 58, y: 15.266},
  {x: 59, y: 15.27},
  {x: 60, y: 15.275},
  {x: 61, y: 15.264},
  {x: 62, y: 15.262},
  {x: 63, y: 15.26},
  {x: 64, y: 15.26},
  {x: 65, y: 15.262},
  {x: 66, y: 15.264},
  {x: 67, y: 15.268},
  {x: 68, y: 15.274},
  {x: 69, y: 15.28},
  {x: 70, y: 15.288},
  {x: 71, y: 15.296},
  {x: 72, y: 15.306},
  {x: 73, y: 15.317},
  {x: 74, y: 15.328},
  {x: 75, y: 15.341},
  {x: 76, y: 15.354},
  {x: 77, y: 15.368},
  {x: 78, y: 15.382},
  {x: 79, y: 15.398},
  {x: 80, y: 15.414},
  {x: 81, y: 15.43},
  {x: 82, y: 15.447},
  {x: 83, y: 15.465},
  {x: 84, y: 15.483},
  {x: 85, y: 15.502},
  {x: 86, y: 15.521},
  {x: 87, y: 15.541},
  {x: 88, y: 15.561},
  {x: 89, y: 15.581},
  {x: 90, y: 15.602},
  {x: 91, y: 15.624},
  {x: 92, y: 15.646},
  {x: 93, y: 15.668},
  {x: 94, y: 15.69},
  {x: 95, y: 15.713},
  {x: 96, y: 15.737},
  {x: 97, y: 15.761},
  {x: 98, y: 15.785},
  {x: 99, y: 15.809},
  {x: 100, y: 15.834},
  {x: 101, y: 15.86},
  {x: 102, y: 15.886},
  {x: 103, y: 15.912},
  {x: 104, y: 15.938},
  {x: 105, y: 15.965},
  {x: 106, y: 15.992},
  {x: 107, y: 16.02},
  {x: 108, y: 16.049},
  {x: 109, y: 16.078},
  {x: 110, y: 16.108},
  {x: 111, y: 16.138},
  {x: 112, y: 16.169},
  {x: 113, y: 16.201},
  {x: 114, y: 16.233},
  {x: 115, y: 16.266},
  {x: 116, y: 16.3},
  {x: 117, y: 16.335},
  {x: 118, y: 16.37},
  {x: 119, y: 16.406},
  {x: 120, y: 16.443},
  {x: 121, y: 16.481},
  {x: 122, y: 16.519},
  {x: 123, y: 16.558},
  {x: 124, y: 16.597},
  {x: 125, y: 16.638},
  {x: 126, y: 16.679},
  {x: 127, y: 16.72},
  {x: 128, y: 16.763},
  {x: 129, y: 16.806},
  {x: 130, y: 16.85},
  {x: 131, y: 16.894},
  {x: 132, y: 16.939},
  {x: 133, y: 16.985},
  {x: 134, y: 17.031},
  {x: 135, y: 17.078},
  {x: 136, y: 17.126},
  {x: 137, y: 17.175},
  {x: 138, y: 17.224},
  {x: 139, y: 17.273},
  {x: 140, y: 17.324},
  {x: 141, y: 17.375},
  {x: 142, y: 17.427},
  {x: 143, y: 17.48},
  {x: 144, y: 17.533},
  {x: 145, y: 17.588},
  {x: 146, y: 17.643},
  {x: 147, y: 17.698},
  {x: 148, y: 17.755},
  {x: 149, y: 17.812},
  {x: 150, y: 17.87},
  {x: 151, y: 17.929},
  {x: 152, y: 17.989},
  {x: 153, y: 18.049},
  {x: 154, y: 18.11},
  {x: 155, y: 18.171},
  {x: 156, y: 18.233},
  {x: 157, y: 18.296},
  {x: 158, y: 18.359},
  {x: 159, y: 18.422},
  {x: 160, y: 18.486},
  {x: 161, y: 18.55},
  {x: 162, y: 18.615},
  {x: 163, y: 18.68},
  {x: 164, y: 18.744},
  {x: 165, y: 18.81},
  {x: 166, y: 18.875},
  {x: 167, y: 18.94},
  {x: 168, y: 19.005},
  {x: 169, y: 19.07},
  {x: 170, y: 19.135},
  {x: 171, y: 19.2},
  {x: 172, y: 19.265},
  {x: 173, y: 19.329},
  {x: 174, y: 19.394},
  {x: 175, y: 19.458},
  {x: 176, y: 19.522},
  {x: 177, y: 19.585},
  {x: 178, y: 19.649},
  {x: 179, y: 19.712},
  {x: 180, y: 19.774},
  {x: 181, y: 19.837},
  {x: 182, y: 19.899},
  {x: 183, y: 19.96},
  {x: 184, y: 20.022},
  {x: 185, y: 20.082},
  {x: 186, y: 20.143},
  {x: 187, y: 20.203},
  {x: 188, y: 20.262},
  {x: 189, y: 20.321},
  {x: 190, y: 20.38},
  {x: 191, y: 20.438},
  {x: 192, y: 20.495},
  {x: 193, y: 20.552},
  {x: 194, y: 20.608},
  {x: 195, y: 20.664},
  {x: 196, y: 20.72},
  {x: 197, y: 20.774},
  {x: 198, y: 20.829},
  {x: 199, y: 20.882},
  {x: 200, y: 20.936},
  {x: 201, y: 20.988},
  {x: 202, y: 21.04},
  {x: 203, y: 21.091},
  {x: 204, y: 21.142},
  {x: 205, y: 21.192},
  {x: 206, y: 21.242},
  {x: 207, y: 21.291},
  {x: 208, y: 21.34},
  {x: 209, y: 21.388},
  {x: 210, y: 21.435},
  {x: 211, y: 21.482},
  {x: 212, y: 21.528},
  {x: 213, y: 21.574},
  {x: 214, y: 21.619},
  {x: 215, y: 21.664},
  {x: 216, y: 21.708},
  {x: 217, y: 21.751},
  {x: 218, y: 21.794},
  {x: 219, y: 21.836},
  {x: 220, y: 21.877},
  {x: 221, y: 21.918},
  {x: 222, y: 21.958},
  {x: 223, y: 21.998},
  {x: 224, y: 22.037},
  {x: 225, y: 22.076},
  {x: 226, y: 22.114},
  {x: 227, y: 22.151},
  {x: 228, y: 22.188}
]

const bmiBoysEightyFive = [
  {x: 0, y: 14.686},
  {x: 1, y: 16.093},
  {x: 2, y: 17.394},
  {x: 3, y: 18.023},
  {x: 4, y: 18.351},
  {x: 5, y: 18.521},
  {x: 6, y: 18.582},
  {x: 7, y: 18.56},
  {x: 8, y: 18.479},
  {x: 9, y: 18.358},
  {x: 10, y: 18.214},
  {x: 11, y: 18.063},
  {x: 12, y: 17.914},
  {x: 13, y: 17.772},
  {x: 14, y: 17.639},
  {x: 15, y: 17.516},
  {x: 16, y: 17.403},
  {x: 17, y: 17.3},
  {x: 18, y: 17.208},
  {x: 19, y: 17.126},
  {x: 20, y: 17.053},
  {x: 21, y: 16.99},
  {x: 22, y: 16.937},
  {x: 23, y: 16.893},
  {x: 24, y: 17.149},
  {x: 25, y: 17.117},
  {x: 26, y: 17.085},
  {x: 27, y: 17.055},
  {x: 29, y: 17.026},
  {x: 30, y: 16.998},
  {x: 31, y: 16.972},
  {x: 32, y: 16.946},
  {x: 33, y: 16.922},
  {x: 34, y: 16.9},
  {x: 35, y: 16.881},
  {x: 36, y: 16.865},
  {x: 37, y: 16.851},
  {x: 38, y: 16.84},
  {x: 39, y: 16.831},
  {x: 40, y: 16.825},
  {x: 41, y: 16.821},
  {x: 42, y: 16.818},
  {x: 43, y: 16.816},
  {x: 44, y: 16.816},
  {x: 45, y: 16.817},
  {x: 46, y: 16.818},
  {x: 47, y: 16.821},
  {x: 48, y: 16.826},
  {x: 49, y: 16.831},
  {x: 50, y: 16.838},
  {x: 51, y: 16.847},
  {x: 52, y: 16.857},
  {x: 53, y: 16.869},
  {x: 54, y: 16.881},
  {x: 55, y: 16.893},
  {x: 56, y: 16.906},
  {x: 57, y: 16.92},
  {x: 58, y: 16.933},
  {x: 59, y: 16.946},
  {x: 60, y: 16.958},
  {x: 61, y: 16.7},
  {x: 62, y: 16.703},
  {x: 63, y: 16.708},
  {x: 64, y: 16.714},
  {x: 65, y: 16.722},
  {x: 66, y: 16.732},
  {x: 67, y: 16.743},
  {x: 68, y: 16.755},
  {x: 69, y: 16.769},
  {x: 70, y: 16.784},
  {x: 71, y: 16.801},
  {x: 72, y: 16.819},
  {x: 73, y: 16.838},
  {x: 74, y: 16.858},
  {x: 75, y: 16.879},
  {x: 76, y: 16.902},
  {x: 77, y: 16.925},
  {x: 78, y: 16.949},
  {x: 79, y: 16.974},
  {x: 80, y: 17.0},
  {x: 81, y: 17.026},
  {x: 82, y: 17.054},
  {x: 83, y: 17.082},
  {x: 84, y: 17.111},
  {x: 85, y: 17.14},
  {x: 86, y: 17.17},
  {x: 87, y: 17.202},
  {x: 88, y: 17.233},
  {x: 89, y: 17.265},
  {x: 90, y: 17.298},
  {x: 91, y: 17.332},
  {x: 92, y: 17.366},
  {x: 93, y: 17.4},
  {x: 94, y: 17.435},
  {x: 95, y: 17.471},
  {x: 96, y: 17.508},
  {x: 97, y: 17.544},
  {x: 98, y: 17.582},
  {x: 99, y: 17.62},
  {x: 100, y: 17.659},
  {x: 101, y: 17.698},
  {x: 102, y: 17.738},
  {x: 103, y: 17.778},
  {x: 104, y: 17.818},
  {x: 105, y: 17.86},
  {x: 106, y: 17.902},
  {x: 107, y: 17.944},
  {x: 108, y: 17.987},
  {x: 109, y: 18.031},
  {x: 110, y: 18.076},
  {x: 111, y: 18.121},
  {x: 112, y: 18.168},
  {x: 113, y: 18.215},
  {x: 114, y: 18.263},
  {x: 115, y: 18.311},
  {x: 116, y: 18.361},
  {x: 117, y: 18.412},
  {x: 118, y: 18.462},
  {x: 119, y: 18.515},
  {x: 120, y: 18.568},
  {x: 121, y: 18.621},
  {x: 122, y: 18.675},
  {x: 123, y: 18.73},
  {x: 124, y: 18.786},
  {x: 125, y: 18.843},
  {x: 126, y: 18.9},
  {x: 127, y: 18.958},
  {x: 128, y: 19.017},
  {x: 129, y: 19.077},
  {x: 130, y: 19.137},
  {x: 131, y: 19.198},
  {x: 132, y: 19.26},
  {x: 133, y: 19.322},
  {x: 134, y: 19.385},
  {x: 135, y: 19.449},
  {x: 136, y: 19.513},
  {x: 137, y: 19.578},
  {x: 138, y: 19.643},
  {x: 139, y: 19.71},
  {x: 140, y: 19.777},
  {x: 141, y: 19.844},
  {x: 142, y: 19.913},
  {x: 143, y: 19.982},
  {x: 144, y: 20.052},
  {x: 145, y: 20.122},
  {x: 146, y: 20.193},
  {x: 147, y: 20.265},
  {x: 148, y: 20.338},
  {x: 149, y: 20.411},
  {x: 150, y: 20.486},
  {x: 151, y: 20.56},
  {x: 152, y: 20.636},
  {x: 153, y: 20.711},
  {x: 154, y: 20.788},
  {x: 155, y: 20.865},
  {x: 156, y: 20.943},
  {x: 157, y: 21.021},
  {x: 158, y: 21.099},
  {x: 159, y: 21.178},
  {x: 160, y: 21.257},
  {x: 161, y: 21.336},
  {x: 162, y: 21.416},
  {x: 163, y: 21.495},
  {x: 164, y: 21.574},
  {x: 165, y: 21.654},
  {x: 166, y: 21.733},
  {x: 167, y: 21.812},
  {x: 168, y: 21.891},
  {x: 169, y: 21.97},
  {x: 170, y: 22.049},
  {x: 171, y: 22.127},
  {x: 172, y: 22.204},
  {x: 173, y: 22.282},
  {x: 174, y: 22.359},
  {x: 175, y: 22.436},
  {x: 176, y: 22.512},
  {x: 177, y: 22.587},
  {x: 178, y: 22.663},
  {x: 179, y: 22.737},
  {x: 180, y: 22.812},
  {x: 181, y: 22.885},
  {x: 182, y: 22.958},
  {x: 183, y: 23.031},
  {x: 184, y: 23.103},
  {x: 185, y: 23.174},
  {x: 186, y: 23.245},
  {x: 187, y: 23.315},
  {x: 188, y: 23.385},
  {x: 189, y: 23.453},
  {x: 190, y: 23.522},
  {x: 191, y: 23.589},
  {x: 192, y: 23.656},
  {x: 193, y: 23.722},
  {x: 194, y: 23.787},
  {x: 195, y: 23.852},
  {x: 196, y: 23.916},
  {x: 197, y: 23.979},
  {x: 198, y: 24.042},
  {x: 199, y: 24.104},
  {x: 200, y: 24.165},
  {x: 201, y: 24.226},
  {x: 202, y: 24.285},
  {x: 203, y: 24.344},
  {x: 204, y: 24.402},
  {x: 205, y: 24.46},
  {x: 206, y: 24.517},
  {x: 207, y: 24.573},
  {x: 208, y: 24.628},
  {x: 209, y: 24.683},
  {x: 210, y: 24.737},
  {x: 211, y: 24.79},
  {x: 212, y: 24.843},
  {x: 213, y: 24.895},
  {x: 214, y: 24.946},
  {x: 215, y: 24.996},
  {x: 216, y: 25.046},
  {x: 217, y: 25.094},
  {x: 218, y: 25.143},
  {x: 219, y: 25.19},
  {x: 220, y: 25.237},
  {x: 221, y: 25.282},
  {x: 222, y: 25.328},
  {x: 223, y: 25.372},
  {x: 224, y: 25.416},
  {x: 225, y: 25.459},
  {x: 226, y: 25.501},
  {x: 227, y: 25.543},
  {x: 228, y: 25.584}
]

const bmiBoysNintySeven = [
  {x: 0, y: 15.892},
  {x: 1, y: 17.381},
  {x: 2, y: 18.792},
  {x: 3, y: 19.475},
  {x: 4, y: 19.832},
  {x: 5, y: 20.017},
  {x: 6, y: 20.085},
  {x: 7, y: 20.063},
  {x: 8, y: 19.975},
  {x: 9, y: 19.845},
  {x: 10, y: 19.69},
  {x: 11, y: 19.527},
  {x: 12, y: 19.366},
  {x: 13, y: 19.213},
  {x: 14, y: 19.069},
  {x: 15, y: 18.936},
  {x: 16, y: 18.814},
  {x: 17, y: 18.703},
  {x: 18, y: 18.604},
  {x: 19, y: 18.515},
  {x: 20, y: 18.436},
  {x: 21, y: 18.368},
  {x: 22, y: 18.311},
  {x: 23, y: 18.263},
  {x: 24, y: 18.518},
  {x: 25, y: 18.482},
  {x: 26, y: 18.447},
  {x: 27, y: 18.414},
  {x: 29, y: 18.383},
  {x: 30, y: 18.353},
  {x: 31, y: 18.324},
  {x: 32, y: 18.298},
  {x: 33, y: 18.274},
  {x: 34, y: 18.253},
  {x: 35, y: 18.236},
  {x: 36, y: 18.223},
  {x: 37, y: 18.214},
  {x: 38, y: 18.209},
  {x: 39, y: 18.208},
  {x: 40, y: 18.21},
  {x: 41, y: 18.215},
  {x: 42, y: 18.221},
  {x: 43, y: 18.23},
  {x: 44, y: 18.241},
  {x: 45, y: 18.253},
  {x: 46, y: 18.266},
  {x: 47, y: 18.28},
  {x: 48, y: 18.295},
  {x: 49, y: 18.312},
  {x: 50, y: 18.331},
  {x: 51, y: 18.351},
  {x: 52, y: 18.373},
  {x: 53, y: 18.396},
  {x: 54, y: 18.419},
  {x: 55, y: 18.443},
  {x: 56, y: 18.467},
  {x: 57, y: 18.49},
  {x: 58, y: 18.512},
  {x: 59, y: 18.534},
  {x: 60, y: 18.556},
  {x: 61, y: 18.052},
  {x: 62, y: 18.065},
  {x: 63, y: 18.08},
  {x: 64, y: 18.096},
  {x: 65, y: 18.114},
  {x: 66, y: 18.134},
  {x: 67, y: 18.156},
  {x: 68, y: 18.18},
  {x: 69, y: 18.205},
  {x: 70, y: 18.232},
  {x: 71, y: 18.261},
  {x: 72, y: 18.291},
  {x: 73, y: 18.323},
  {x: 74, y: 18.356},
  {x: 75, y: 18.39},
  {x: 76, y: 18.426},
  {x: 77, y: 18.463},
  {x: 78, y: 18.501},
  {x: 79, y: 18.541},
  {x: 80, y: 18.582},
  {x: 81, y: 18.623},
  {x: 82, y: 18.666},
  {x: 83, y: 18.71},
  {x: 84, y: 18.756},
  {x: 85, y: 18.801},
  {x: 86, y: 18.848},
  {x: 87, y: 18.897},
  {x: 88, y: 18.945},
  {x: 89, y: 18.996},
  {x: 90, y: 19.047},
  {x: 91, y: 19.098},
  {x: 92, y: 19.151},
  {x: 93, y: 19.205},
  {x: 94, y: 19.259},
  {x: 95, y: 19.315},
  {x: 96, y: 19.371},
  {x: 97, y: 19.428},
  {x: 98, y: 19.486},
  {x: 99, y: 19.545},
  {x: 100, y: 19.605},
  {x: 101, y: 19.666},
  {x: 102, y: 19.727},
  {x: 103, y: 19.789},
  {x: 104, y: 19.852},
  {x: 105, y: 19.916},
  {x: 106, y: 19.981},
  {x: 107, y: 20.046},
  {x: 108, y: 20.112},
  {x: 109, y: 20.18},
  {x: 110, y: 20.248},
  {x: 111, y: 20.317},
  {x: 112, y: 20.388},
  {x: 113, y: 20.459},
  {x: 114, y: 20.531},
  {x: 115, y: 20.605},
  {x: 116, y: 20.679},
  {x: 117, y: 20.754},
  {x: 118, y: 20.83},
  {x: 119, y: 20.907},
  {x: 120, y: 20.985},
  {x: 121, y: 21.063},
  {x: 122, y: 21.142},
  {x: 123, y: 21.223},
  {x: 124, y: 21.304},
  {x: 125, y: 21.385},
  {x: 126, y: 21.468},
  {x: 127, y: 21.551},
  {x: 128, y: 21.635},
  {x: 129, y: 21.72},
  {x: 130, y: 21.805},
  {x: 131, y: 21.891},
  {x: 132, y: 21.977},
  {x: 133, y: 22.064},
  {x: 134, y: 22.151},
  {x: 135, y: 22.239},
  {x: 136, y: 22.327},
  {x: 137, y: 22.416},
  {x: 138, y: 22.505},
  {x: 139, y: 22.595},
  {x: 140, y: 22.685},
  {x: 141, y: 22.775},
  {x: 142, y: 22.866},
  {x: 143, y: 22.958},
  {x: 144, y: 23.05},
  {x: 145, y: 23.142},
  {x: 146, y: 23.235},
  {x: 147, y: 23.328},
  {x: 148, y: 23.422},
  {x: 149, y: 23.516},
  {x: 150, y: 23.61},
  {x: 151, y: 23.705},
  {x: 152, y: 23.8},
  {x: 153, y: 23.895},
  {x: 154, y: 23.991},
  {x: 155, y: 24.086},
  {x: 156, y: 24.182},
  {x: 157, y: 24.278},
  {x: 158, y: 24.373},
  {x: 159, y: 24.47},
  {x: 160, y: 24.565},
  {x: 161, y: 24.66},
  {x: 162, y: 24.755},
  {x: 163, y: 24.85},
  {x: 164, y: 24.944},
  {x: 165, y: 25.037},
  {x: 166, y: 25.131},
  {x: 167, y: 25.223},
  {x: 168, y: 25.315},
  {x: 169, y: 25.406},
  {x: 170, y: 25.496},
  {x: 171, y: 25.586},
  {x: 172, y: 25.674},
  {x: 173, y: 25.762},
  {x: 174, y: 25.849},
  {x: 175, y: 25.935},
  {x: 176, y: 26.021},
  {x: 177, y: 26.105},
  {x: 178, y: 26.189},
  {x: 179, y: 26.271},
  {x: 180, y: 26.352},
  {x: 181, y: 26.433},
  {x: 182, y: 26.513},
  {x: 183, y: 26.592},
  {x: 184, y: 26.67},
  {x: 185, y: 26.747},
  {x: 186, y: 26.823},
  {x: 187, y: 26.897},
  {x: 188, y: 26.971},
  {x: 189, y: 27.044},
  {x: 190, y: 27.116},
  {x: 191, y: 27.188},
  {x: 192, y: 27.258},
  {x: 193, y: 27.326},
  {x: 194, y: 27.395},
  {x: 195, y: 27.462},
  {x: 196, y: 27.528},
  {x: 197, y: 27.593},
  {x: 198, y: 27.657},
  {x: 199, y: 27.72},
  {x: 200, y: 27.782},
  {x: 201, y: 27.844},
  {x: 202, y: 27.904},
  {x: 203, y: 27.963},
  {x: 204, y: 28.021},
  {x: 205, y: 28.079},
  {x: 206, y: 28.135},
  {x: 207, y: 28.19},
  {x: 208, y: 28.245},
  {x: 209, y: 28.299},
  {x: 210, y: 28.352},
  {x: 211, y: 28.403},
  {x: 212, y: 28.454},
  {x: 213, y: 28.504},
  {x: 214, y: 28.552},
  {x: 215, y: 28.6},
  {x: 216, y: 28.648},
  {x: 217, y: 28.693},
  {x: 218, y: 28.738},
  {x: 219, y: 28.782},
  {x: 220, y: 28.826},
  {x: 221, y: 28.868},
  {x: 222, y: 28.91},
  {x: 223, y: 28.95},
  {x: 224, y: 28.99},
  {x: 225, y: 29.028},
  {x: 226, y: 29.067},
  {x: 227, y: 29.103},
  {x: 228, y: 29.14}
]

    // GIRLS

const bmiGirlsThree = [
  {x: 0, y: 11.254},
  {x: 1, y: 12.595},
  {x: 2, y: 13.871},
  {x: 3, y: 14.422},
  {x: 4, y: 14.684},
  {x: 5, y: 14.827},
  {x: 6, y: 14.891},
  {x: 7, y: 14.895},
  {x: 8, y: 14.853},
  {x: 9, y: 14.779},
  {x: 10, y: 14.689},
  {x: 11, y: 14.591},
  {x: 12, y: 14.493},
  {x: 13, y: 14.395},
  {x: 14, y: 14.301},
  {x: 15, y: 14.211},
  {x: 16, y: 14.127},
  {x: 17, y: 14.048},
  {x: 18, y: 13.974},
  {x: 19, y: 13.908},
  {x: 20, y: 13.847},
  {x: 21, y: 13.794},
  {x: 22, y: 13.747},
  {x: 23, y: 13.706},
  {x: 24, y: 13.685},
  {x: 25, y: 13.865},
  {x: 26, y: 13.825},
  {x: 27, y: 13.785},
  {x: 29, y: 13.746},
  {x: 30, y: 13.708},
  {x: 31, y: 13.67},
  {x: 32, y: 13.633},
  {x: 33, y: 13.597},
  {x: 34, y: 13.562},
  {x: 35, y: 13.527},
  {x: 36, y: 13.494},
  {x: 37, y: 13.461},
  {x: 38, y: 13.43},
  {x: 39, y: 13.4},
  {x: 40, y: 13.372},
  {x: 41, y: 13.344},
  {x: 42, y: 13.319},
  {x: 43, y: 13.295},
  {x: 44, y: 13.272},
  {x: 45, y: 13.25},
  {x: 46, y: 13.229},
  {x: 47, y: 13.209},
  {x: 48, y: 13.189},
  {x: 49, y: 13.171},
  {x: 50, y: 13.153},
  {x: 51, y: 13.135},
  {x: 52, y: 13.119},
  {x: 53, y: 13.103},
  {x: 54, y: 13.088},
  {x: 55, y: 13.073},
  {x: 56, y: 13.059},
  {x: 57, y: 13.045},
  {x: 58, y: 13.032},
  {x: 59, y: 13.02},
  {x: 60, y: 13.009},
  {x: 61, y: 12.874},
  {x: 62, y: 12.868},
  {x: 63, y: 12.861},
  {x: 64, y: 12.855},
  {x: 65, y: 12.85},
  {x: 66, y: 12.845},
  {x: 67, y: 12.841},
  {x: 68, y: 12.837},
  {x: 69, y: 12.834},
  {x: 70, y: 12.831},
  {x: 71, y: 12.829},
  {x: 72, y: 12.828},
  {x: 73, y: 12.827},
  {x: 74, y: 12.826},
  {x: 75, y: 12.827},
  {x: 76, y: 12.828},
  {x: 77, y: 12.83},
  {x: 78, y: 12.832},
  {x: 79, y: 12.836},
  {x: 80, y: 12.84},
  {x: 81, y: 12.845},
  {x: 82, y: 12.851},
  {x: 83, y: 12.857},
  {x: 84, y: 12.865},
  {x: 85, y: 12.873},
  {x: 86, y: 12.882},
  {x: 87, y: 12.892},
  {x: 88, y: 12.903},
  {x: 89, y: 12.915},
  {x: 90, y: 12.927},
  {x: 91, y: 12.94},
  {x: 92, y: 12.954},
  {x: 93, y: 12.969},
  {x: 94, y: 12.984},
  {x: 95, y: 13.001},
  {x: 96, y: 13.018},
  {x: 97, y: 13.036},
  {x: 98, y: 13.055},
  {x: 99, y: 13.075},
  {x: 100, y: 13.095},
  {x: 101, y: 13.116},
  {x: 102, y: 13.137},
  {x: 103, y: 13.159},
  {x: 104, y: 13.182},
  {x: 105, y: 13.206},
  {x: 106, y: 13.23},
  {x: 107, y: 13.254},
  {x: 108, y: 13.279},
  {x: 109, y: 13.305},
  {x: 110, y: 13.331},
  {x: 111, y: 13.357},
  {x: 112, y: 13.384},
  {x: 113, y: 13.411},
  {x: 114, y: 13.439},
  {x: 115, y: 13.467},
  {x: 116, y: 13.496},
  {x: 117, y: 13.525},
  {x: 118, y: 13.555},
  {x: 119, y: 13.585},
  {x: 120, y: 13.616},
  {x: 121, y: 13.648},
  {x: 122, y: 13.681},
  {x: 123, y: 13.714},
  {x: 124, y: 13.747},
  {x: 125, y: 13.782},
  {x: 126, y: 13.817},
  {x: 127, y: 13.852},
  {x: 128, y: 13.889},
  {x: 129, y: 13.926},
  {x: 130, y: 13.964},
  {x: 131, y: 14.002},
  {x: 132, y: 14.041},
  {x: 133, y: 14.081},
  {x: 134, y: 14.122},
  {x: 135, y: 14.163},
  {x: 136, y: 14.205},
  {x: 137, y: 14.247},
  {x: 138, y: 14.29},
  {x: 139, y: 14.333},
  {x: 140, y: 14.377},
  {x: 141, y: 14.422},
  {x: 142, y: 14.467},
  {x: 143, y: 14.512},
  {x: 144, y: 14.558},
  {x: 145, y: 14.604},
  {x: 146, y: 14.65},
  {x: 147, y: 14.696},
  {x: 148, y: 14.743},
  {x: 149, y: 14.79},
  {x: 150, y: 14.836},
  {x: 151, y: 14.883},
  {x: 152, y: 14.93},
  {x: 153, y: 14.976},
  {x: 154, y: 15.023},
  {x: 155, y: 15.069},
  {x: 156, y: 15.115},
  {x: 157, y: 15.161},
  {x: 158, y: 15.207},
  {x: 159, y: 15.252},
  {x: 160, y: 15.297},
  {x: 161, y: 15.341},
  {x: 162, y: 15.386},
  {x: 163, y: 15.429},
  {x: 164, y: 15.472},
  {x: 165, y: 15.515},
  {x: 166, y: 15.557},
  {x: 167, y: 15.599},
  {x: 168, y: 15.64},
  {x: 169, y: 15.68},
  {x: 170, y: 15.72},
  {x: 171, y: 15.759},
  {x: 172, y: 15.797},
  {x: 173, y: 15.834},
  {x: 174, y: 15.871},
  {x: 175, y: 15.907},
  {x: 176, y: 15.942},
  {x: 177, y: 15.976},
  {x: 178, y: 16.01},
  {x: 179, y: 16.042},
  {x: 180, y: 16.074},
  {x: 181, y: 16.105},
  {x: 182, y: 16.135},
  {x: 183, y: 16.164},
  {x: 184, y: 16.192},
  {x: 185, y: 16.219},
  {x: 186, y: 16.245},
  {x: 187, y: 16.27},
  {x: 188, y: 16.295},
  {x: 189, y: 16.319},
  {x: 190, y: 16.342},
  {x: 191, y: 16.363},
  {x: 192, y: 16.384},
  {x: 193, y: 16.405},
  {x: 194, y: 16.424},
  {x: 195, y: 16.443},
  {x: 196, y: 16.461},
  {x: 197, y: 16.478},
  {x: 198, y: 16.494},
  {x: 199, y: 16.509},
  {x: 200, y: 16.524},
  {x: 201, y: 16.538},
  {x: 202, y: 16.551},
  {x: 203, y: 16.564},
  {x: 204, y: 16.576},
  {x: 205, y: 16.587},
  {x: 206, y: 16.597},
  {x: 207, y: 16.607},
  {x: 208, y: 16.617},
  {x: 209, y: 16.626},
  {x: 210, y: 16.635},
  {x: 211, y: 16.643},
  {x: 212, y: 16.65},
  {x: 213, y: 16.658},
  {x: 214, y: 16.665},
  {x: 215, y: 16.671},
  {x: 216, y: 16.678},
  {x: 217, y: 16.683},
  {x: 218, y: 16.689},
  {x: 219, y: 16.694},
  {x: 220, y: 16.7},
  {x: 221, y: 16.705},
  {x: 222, y: 16.709},
  {x: 223, y: 16.714},
  {x: 224, y: 16.718},
  {x: 225, y: 16.722},
  {x: 226, y: 16.726},
  {x: 227, y: 16.73},
  {x: 228, y: 16.734}
]

const bmiGirlsFiftheen = [
  {x: 0, y: 12.16},
  {x: 1, y: 13.629},
  {x: 2, y: 14.94},
  {x: 3, y: 15.494},
  {x: 4, y: 15.749},
  {x: 5, y: 15.884},
  {x: 6, y: 15.937},
  {x: 7, y: 15.929},
  {x: 8, y: 15.873},
  {x: 9, y: 15.785},
  {x: 10, y: 15.68},
  {x: 11, y: 15.569},
  {x: 12, y: 15.457},
  {x: 13, y: 15.347},
  {x: 14, y: 15.241},
  {x: 15, y: 15.14},
  {x: 16, y: 15.046},
  {x: 17, y: 14.957},
  {x: 18, y: 14.875},
  {x: 19, y: 14.8},
  {x: 20, y: 14.732},
  {x: 21, y: 14.672},
  {x: 22, y: 14.619},
  {x: 23, y: 14.571},
  {x: 24, y: 14.547},
  {x: 25, y: 14.75},
  {x: 26, y: 14.711},
  {x: 27, y: 14.673},
  {x: 29, y: 14.636},
  {x: 30, y: 14.599},
  {x: 31, y: 14.563},
  {x: 32, y: 14.528},
  {x: 33, y: 14.493},
  {x: 34, y: 14.459},
  {x: 35, y: 14.426},
  {x: 36, y: 14.394},
  {x: 37, y: 14.362},
  {x: 38, y: 14.332},
  {x: 39, y: 14.303},
  {x: 40, y: 14.276},
  {x: 41, y: 14.249},
  {x: 42, y: 14.224},
  {x: 43, y: 14.201},
  {x: 44, y: 14.178},
  {x: 45, y: 14.157},
  {x: 46, y: 14.137},
  {x: 47, y: 14.117},
  {x: 48, y: 14.098},
  {x: 49, y: 14.08},
  {x: 50, y: 14.063},
  {x: 51, y: 14.045},
  {x: 52, y: 14.029},
  {x: 53, y: 14.013},
  {x: 54, y: 13.998},
  {x: 55, y: 13.983},
  {x: 56, y: 13.969},
  {x: 57, y: 13.955},
  {x: 58, y: 13.942},
  {x: 59, y: 13.93},
  {x: 60, y: 13.918},
  {x: 61, y: 13.846},
  {x: 62, y: 13.84},
  {x: 63, y: 13.835},
  {x: 64, y: 13.831},
  {x: 65, y: 13.827},
  {x: 66, y: 13.824},
  {x: 67, y: 13.821},
  {x: 68, y: 13.819},
  {x: 69, y: 13.817},
  {x: 70, y: 13.816},
  {x: 71, y: 13.816},
  {x: 72, y: 13.816},
  {x: 73, y: 13.817},
  {x: 74, y: 13.818},
  {x: 75, y: 13.821},
  {x: 76, y: 13.824},
  {x: 77, y: 13.828},
  {x: 78, y: 13.832},
  {x: 79, y: 13.838},
  {x: 80, y: 13.844},
  {x: 81, y: 13.851},
  {x: 82, y: 13.86},
  {x: 83, y: 13.869},
  {x: 84, y: 13.879},
  {x: 85, y: 13.89},
  {x: 86, y: 13.902},
  {x: 87, y: 13.914},
  {x: 88, y: 13.928},
  {x: 89, y: 13.943},
  {x: 90, y: 13.958},
  {x: 91, y: 13.974},
  {x: 92, y: 13.992},
  {x: 93, y: 14.01},
  {x: 94, y: 14.029},
  {x: 95, y: 14.049},
  {x: 96, y: 14.07},
  {x: 97, y: 14.091},
  {x: 98, y: 14.114},
  {x: 99, y: 14.137},
  {x: 100, y: 14.162},
  {x: 101, y: 14.187},
  {x: 102, y: 14.213},
  {x: 103, y: 14.239},
  {x: 104, y: 14.266},
  {x: 105, y: 14.294},
  {x: 106, y: 14.323},
  {x: 107, y: 14.352},
  {x: 108, y: 14.382},
  {x: 109, y: 14.412},
  {x: 110, y: 14.443},
  {x: 111, y: 14.474},
  {x: 112, y: 14.506},
  {x: 113, y: 14.538},
  {x: 114, y: 14.571},
  {x: 115, y: 14.605},
  {x: 116, y: 14.639},
  {x: 117, y: 14.674},
  {x: 118, y: 14.709},
  {x: 119, y: 14.745},
  {x: 120, y: 14.782},
  {x: 121, y: 14.819},
  {x: 122, y: 14.858},
  {x: 123, y: 14.897},
  {x: 124, y: 14.937},
  {x: 125, y: 14.977},
  {x: 126, y: 15.019},
  {x: 127, y: 15.061},
  {x: 128, y: 15.104},
  {x: 129, y: 15.147},
  {x: 130, y: 15.192},
  {x: 131, y: 15.237},
  {x: 132, y: 15.283},
  {x: 133, y: 15.33},
  {x: 134, y: 15.378},
  {x: 135, y: 15.426},
  {x: 136, y: 15.475},
  {x: 137, y: 15.525},
  {x: 138, y: 15.575},
  {x: 139, y: 15.626},
  {x: 140, y: 15.678},
  {x: 141, y: 15.73},
  {x: 142, y: 15.782},
  {x: 143, y: 15.836},
  {x: 144, y: 15.889},
  {x: 145, y: 15.943},
  {x: 146, y: 15.997},
  {x: 147, y: 16.052},
  {x: 148, y: 16.106},
  {x: 149, y: 16.161},
  {x: 150, y: 16.216},
  {x: 151, y: 16.271},
  {x: 152, y: 16.325},
  {x: 153, y: 16.38},
  {x: 154, y: 16.435},
  {x: 155, y: 16.489},
  {x: 156, y: 16.544},
  {x: 157, y: 16.598},
  {x: 158, y: 16.651},
  {x: 159, y: 16.705},
  {x: 160, y: 16.758},
  {x: 161, y: 16.81},
  {x: 162, y: 16.862},
  {x: 163, y: 16.914},
  {x: 164, y: 16.965},
  {x: 165, y: 17.016},
  {x: 166, y: 17.066},
  {x: 167, y: 17.115},
  {x: 168, y: 17.164},
  {x: 169, y: 17.212},
  {x: 170, y: 17.259},
  {x: 171, y: 17.306},
  {x: 172, y: 17.352},
  {x: 173, y: 17.397},
  {x: 174, y: 17.441},
  {x: 175, y: 17.484},
  {x: 176, y: 17.527},
  {x: 177, y: 17.568},
  {x: 178, y: 17.609},
  {x: 179, y: 17.648},
  {x: 180, y: 17.687},
  {x: 181, y: 17.724},
  {x: 182, y: 17.761},
  {x: 183, y: 17.796},
  {x: 184, y: 17.831},
  {x: 185, y: 17.864},
  {x: 186, y: 17.897},
  {x: 187, y: 17.928},
  {x: 188, y: 17.959},
  {x: 189, y: 17.989},
  {x: 190, y: 18.018},
  {x: 191, y: 18.045},
  {x: 192, y: 18.072},
  {x: 193, y: 18.098},
  {x: 194, y: 18.123},
  {x: 195, y: 18.148},
  {x: 196, y: 18.171},
  {x: 197, y: 18.193},
  {x: 198, y: 18.215},
  {x: 199, y: 18.235},
  {x: 200, y: 18.255},
  {x: 201, y: 18.274},
  {x: 202, y: 18.292},
  {x: 203, y: 18.31},
  {x: 204, y: 18.327},
  {x: 205, y: 18.343},
  {x: 206, y: 18.358},
  {x: 207, y: 18.373},
  {x: 208, y: 18.388},
  {x: 209, y: 18.401},
  {x: 210, y: 18.414},
  {x: 211, y: 18.427},
  {x: 212, y: 18.439},
  {x: 213, y: 18.451},
  {x: 214, y: 18.463},
  {x: 215, y: 18.474},
  {x: 216, y: 18.485},
  {x: 217, y: 18.495},
  {x: 218, y: 18.505},
  {x: 219, y: 18.515},
  {x: 220, y: 18.524},
  {x: 221, y: 18.534},
  {x: 222, y: 18.543},
  {x: 223, y: 18.552},
  {x: 224, y: 18.56},
  {x: 225, y: 18.569},
  {x: 226, y: 18.577},
  {x: 227, y: 18.585},
  {x: 228, y: 18.593}
]

const bmiGirlsFifthy = [
  {x: 0, y: 13.407},
  {x: 1, y: 14.982},
  {x: 2, y: 16.351},
  {x: 3, y: 16.919},
  {x: 4, y: 17.171},
  {x: 5, y: 17.3},
  {x: 6, y: 17.344},
  {x: 7, y: 17.323},
  {x: 8, y: 17.252},
  {x: 9, y: 17.148},
  {x: 10, y: 17.026},
  {x: 11, y: 16.898},
  {x: 12, y: 16.77},
  {x: 13, y: 16.645},
  {x: 14, y: 16.525},
  {x: 15, y: 16.41},
  {x: 16, y: 16.303},
  {x: 17, y: 16.203},
  {x: 18, y: 16.11},
  {x: 19, y: 16.024},
  {x: 20, y: 15.947},
  {x: 21, y: 15.879},
  {x: 22, y: 15.818},
  {x: 23, y: 15.763},
  {x: 24, y: 15.736},
  {x: 25, y: 15.962},
  {x: 26, y: 15.923},
  {x: 27, y: 15.885},
  {x: 29, y: 15.848},
  {x: 30, y: 15.812},
  {x: 31, y: 15.776},
  {x: 32, y: 15.741},
  {x: 33, y: 15.707},
  {x: 34, y: 15.674},
  {x: 35, y: 15.641},
  {x: 36, y: 15.61},
  {x: 37, y: 15.579},
  {x: 38, y: 15.55},
  {x: 39, y: 15.522},
  {x: 40, y: 15.496},
  {x: 41, y: 15.471},
  {x: 42, y: 15.447},
  {x: 43, y: 15.426},
  {x: 44, y: 15.405},
  {x: 45, y: 15.386},
  {x: 46, y: 15.368},
  {x: 47, y: 15.351},
  {x: 48, y: 15.335},
  {x: 49, y: 15.319},
  {x: 50, y: 15.304},
  {x: 51, y: 15.29},
  {x: 52, y: 15.277},
  {x: 53, y: 15.264},
  {x: 54, y: 15.252},
  {x: 55, y: 15.24},
  {x: 56, y: 15.229},
  {x: 57, y: 15.218},
  {x: 58, y: 15.209},
  {x: 59, y: 15.199},
  {x: 60, y: 15.191},
  {x: 61, y: 15.244},
  {x: 62, y: 15.243},
  {x: 63, y: 15.243},
  {x: 64, y: 15.244},
  {x: 65, y: 15.245},
  {x: 66, y: 15.246},
  {x: 67, y: 15.249},
  {x: 68, y: 15.252},
  {x: 69, y: 15.255},
  {x: 70, y: 15.259},
  {x: 71, y: 15.264},
  {x: 72, y: 15.27},
  {x: 73, y: 15.276},
  {x: 74, y: 15.283},
  {x: 75, y: 15.291},
  {x: 76, y: 15.3},
  {x: 77, y: 15.31},
  {x: 78, y: 15.32},
  {x: 79, y: 15.331},
  {x: 80, y: 15.344},
  {x: 81, y: 15.357},
  {x: 82, y: 15.372},
  {x: 83, y: 15.387},
  {x: 84, y: 15.404},
  {x: 85, y: 15.421},
  {x: 86, y: 15.44},
  {x: 87, y: 15.459},
  {x: 88, y: 15.48},
  {x: 89, y: 15.501},
  {x: 90, y: 15.524},
  {x: 91, y: 15.548},
  {x: 92, y: 15.572},
  {x: 93, y: 15.598},
  {x: 94, y: 15.625},
  {x: 95, y: 15.652},
  {x: 96, y: 15.681},
  {x: 97, y: 15.711},
  {x: 98, y: 15.742},
  {x: 99, y: 15.773},
  {x: 100, y: 15.806},
  {x: 101, y: 15.839},
  {x: 102, y: 15.874},
  {x: 103, y: 15.909},
  {x: 104, y: 15.945},
  {x: 105, y: 15.982},
  {x: 106, y: 16.019},
  {x: 107, y: 16.058},
  {x: 108, y: 16.096},
  {x: 109, y: 16.136},
  {x: 110, y: 16.176},
  {x: 111, y: 16.217},
  {x: 112, y: 16.258},
  {x: 113, y: 16.3},
  {x: 114, y: 16.343},
  {x: 115, y: 16.386},
  {x: 116, y: 16.43},
  {x: 117, y: 16.475},
  {x: 118, y: 16.52},
  {x: 119, y: 16.566},
  {x: 120, y: 16.613},
  {x: 121, y: 16.661},
  {x: 122, y: 16.71},
  {x: 123, y: 16.76},
  {x: 124, y: 16.81},
  {x: 125, y: 16.861},
  {x: 126, y: 16.914},
  {x: 127, y: 16.967},
  {x: 128, y: 17.021},
  {x: 129, y: 17.076},
  {x: 130, y: 17.132},
  {x: 131, y: 17.188},
  {x: 132, y: 17.246},
  {x: 133, y: 17.304},
  {x: 134, y: 17.364},
  {x: 135, y: 17.424},
  {x: 136, y: 17.485},
  {x: 137, y: 17.546},
  {x: 138, y: 17.609},
  {x: 139, y: 17.672},
  {x: 140, y: 17.736},
  {x: 141, y: 17.8},
  {x: 142, y: 17.865},
  {x: 143, y: 17.931},
  {x: 144, y: 17.997},
  {x: 145, y: 18.063},
  {x: 146, y: 18.13},
  {x: 147, y: 18.197},
  {x: 148, y: 18.264},
  {x: 149, y: 18.331},
  {x: 150, y: 18.399},
  {x: 151, y: 18.466},
  {x: 152, y: 18.533},
  {x: 153, y: 18.601},
  {x: 154, y: 18.668},
  {x: 155, y: 18.735},
  {x: 156, y: 18.801},
  {x: 157, y: 18.868},
  {x: 158, y: 18.934},
  {x: 159, y: 18.999},
  {x: 160, y: 19.064},
  {x: 161, y: 19.129},
  {x: 162, y: 19.193},
  {x: 163, y: 19.257},
  {x: 164, y: 19.32},
  {x: 165, y: 19.382},
  {x: 166, y: 19.444},
  {x: 167, y: 19.504},
  {x: 168, y: 19.565},
  {x: 169, y: 19.624},
  {x: 170, y: 19.682},
  {x: 171, y: 19.74},
  {x: 172, y: 19.797},
  {x: 173, y: 19.852},
  {x: 174, y: 19.907},
  {x: 175, y: 19.961},
  {x: 176, y: 20.013},
  {x: 177, y: 20.065},
  {x: 178, y: 20.115},
  {x: 179, y: 20.164},
  {x: 180, y: 20.212},
  {x: 181, y: 20.26},
  {x: 182, y: 20.305},
  {x: 183, y: 20.35},
  {x: 184, y: 20.393},
  {x: 185, y: 20.436},
  {x: 186, y: 20.477},
  {x: 187, y: 20.517},
  {x: 188, y: 20.556},
  {x: 189, y: 20.594},
  {x: 190, y: 20.631},
  {x: 191, y: 20.666},
  {x: 192, y: 20.701},
  {x: 193, y: 20.734},
  {x: 194, y: 20.767},
  {x: 195, y: 20.798},
  {x: 196, y: 20.829},
  {x: 197, y: 20.858},
  {x: 198, y: 20.886},
  {x: 199, y: 20.914},
  {x: 200, y: 20.94},
  {x: 201, y: 20.966},
  {x: 202, y: 20.99},
  {x: 203, y: 21.014},
  {x: 204, y: 21.037},
  {x: 205, y: 21.059},
  {x: 206, y: 21.08},
  {x: 207, y: 21.101},
  {x: 208, y: 21.121},
  {x: 209, y: 21.14},
  {x: 210, y: 21.159},
  {x: 211, y: 21.177},
  {x: 212, y: 21.194},
  {x: 213, y: 21.212},
  {x: 214, y: 21.228},
  {x: 215, y: 21.244},
  {x: 216, y: 21.26},
  {x: 217, y: 21.276},
  {x: 218, y: 21.291},
  {x: 219, y: 21.306},
  {x: 220, y: 21.32},
  {x: 221, y: 21.334},
  {x: 222, y: 21.348},
  {x: 223, y: 21.362},
  {x: 224, y: 21.375},
  {x: 225, y: 21.388},
  {x: 226, y: 21.401},
  {x: 227, y: 21.414},
  {x: 228, y: 21.427}
]

const bmiGirlsEightyFive = [
  {x: 0, y: 14.826},
  {x: 1, y: 16.431},
  {x: 2, y: 17.881},
  {x: 3, y: 18.474},
  {x: 4, y: 18.733},
  {x: 5, y: 18.862},
  {x: 6, y: 18.901},
  {x: 7, y: 18.872},
  {x: 8, y: 18.789},
  {x: 9, y: 18.67},
  {x: 10, y: 18.533},
  {x: 11, y: 18.39},
  {x: 12, y: 18.248},
  {x: 13, y: 18.108},
  {x: 14, y: 17.974},
  {x: 15, y: 17.846},
  {x: 16, y: 17.727},
  {x: 17, y: 17.615},
  {x: 18, y: 17.511},
  {x: 19, y: 17.416},
  {x: 20, y: 17.33},
  {x: 21, y: 17.253},
  {x: 22, y: 17.185},
  {x: 23, y: 17.124},
  {x: 24, y: 17.093},
  {x: 25, y: 17.338},
  {x: 26, y: 17.296},
  {x: 27, y: 17.254},
  {x: 29, y: 17.214},
  {x: 30, y: 17.175},
  {x: 31, y: 17.137},
  {x: 32, y: 17.1},
  {x: 33, y: 17.064},
  {x: 34, y: 17.029},
  {x: 35, y: 16.996},
  {x: 36, y: 16.964},
  {x: 37, y: 16.933},
  {x: 38, y: 16.905},
  {x: 39, y: 16.878},
  {x: 40, y: 16.853},
  {x: 41, y: 16.83},
  {x: 42, y: 16.81},
  {x: 43, y: 16.791},
  {x: 44, y: 16.774},
  {x: 45, y: 16.759},
  {x: 46, y: 16.746},
  {x: 47, y: 16.734},
  {x: 48, y: 16.723},
  {x: 49, y: 16.713},
  {x: 50, y: 16.705},
  {x: 51, y: 16.698},
  {x: 52, y: 16.691},
  {x: 53, y: 16.686},
  {x: 54, y: 16.682},
  {x: 55, y: 16.678},
  {x: 56, y: 16.676},
  {x: 57, y: 16.674},
  {x: 58, y: 16.673},
  {x: 59, y: 16.673},
  {x: 60, y: 16.674},
  {x: 61, y: 16.936},
  {x: 62, y: 16.945},
  {x: 63, y: 16.956},
  {x: 64, y: 16.967},
  {x: 65, y: 16.979},
  {x: 66, y: 16.991},
  {x: 67, y: 17.005},
  {x: 68, y: 17.019},
  {x: 69, y: 17.034},
  {x: 70, y: 17.049},
  {x: 71, y: 17.065},
  {x: 72, y: 17.083},
  {x: 73, y: 17.101},
  {x: 74, y: 17.12},
  {x: 75, y: 17.14},
  {x: 76, y: 17.161},
  {x: 77, y: 17.183},
  {x: 78, y: 17.206},
  {x: 79, y: 17.23},
  {x: 80, y: 17.255},
  {x: 81, y: 17.281},
  {x: 82, y: 17.309},
  {x: 83, y: 17.337},
  {x: 84, y: 17.367},
  {x: 85, y: 17.398},
  {x: 86, y: 17.43},
  {x: 87, y: 17.464},
  {x: 88, y: 17.499},
  {x: 89, y: 17.534},
  {x: 90, y: 17.571},
  {x: 91, y: 17.609},
  {x: 92, y: 17.648},
  {x: 93, y: 17.689},
  {x: 94, y: 17.73},
  {x: 95, y: 17.773},
  {x: 96, y: 17.817},
  {x: 97, y: 17.862},
  {x: 98, y: 17.908},
  {x: 99, y: 17.955},
  {x: 100, y: 18.004},
  {x: 101, y: 18.053},
  {x: 102, y: 18.103},
  {x: 103, y: 18.154},
  {x: 104, y: 18.206},
  {x: 105, y: 18.259},
  {x: 106, y: 18.313},
  {x: 107, y: 18.367},
  {x: 108, y: 18.422},
  {x: 109, y: 18.478},
  {x: 110, y: 18.535},
  {x: 111, y: 18.592},
  {x: 112, y: 18.65},
  {x: 113, y: 18.708},
  {x: 114, y: 18.767},
  {x: 115, y: 18.827},
  {x: 116, y: 18.887},
  {x: 117, y: 18.949},
  {x: 118, y: 19.011},
  {x: 119, y: 19.074},
  {x: 120, y: 19.137},
  {x: 121, y: 19.202},
  {x: 122, y: 19.267},
  {x: 123, y: 19.334},
  {x: 124, y: 19.401},
  {x: 125, y: 19.469},
  {x: 126, y: 19.538},
  {x: 127, y: 19.608},
  {x: 128, y: 19.679},
  {x: 129, y: 19.751},
  {x: 130, y: 19.824},
  {x: 131, y: 19.898},
  {x: 132, y: 19.973},
  {x: 133, y: 20.048},
  {x: 134, y: 20.125},
  {x: 135, y: 20.202},
  {x: 136, y: 20.28},
  {x: 137, y: 20.359},
  {x: 138, y: 20.439},
  {x: 139, y: 20.519},
  {x: 140, y: 20.6},
  {x: 141, y: 20.682},
  {x: 142, y: 20.764},
  {x: 143, y: 20.846},
  {x: 144, y: 20.929},
  {x: 145, y: 21.013},
  {x: 146, y: 21.096},
  {x: 147, y: 21.18},
  {x: 148, y: 21.264},
  {x: 149, y: 21.348},
  {x: 150, y: 21.432},
  {x: 151, y: 21.516},
  {x: 152, y: 21.6},
  {x: 153, y: 21.683},
  {x: 154, y: 21.766},
  {x: 155, y: 21.849},
  {x: 156, y: 21.931},
  {x: 157, y: 22.013},
  {x: 158, y: 22.094},
  {x: 159, y: 22.175},
  {x: 160, y: 22.255},
  {x: 161, y: 22.335},
  {x: 162, y: 22.413},
  {x: 163, y: 22.491},
  {x: 164, y: 22.569},
  {x: 165, y: 22.645},
  {x: 166, y: 22.72},
  {x: 167, y: 22.795},
  {x: 168, y: 22.868},
  {x: 169, y: 22.94},
  {x: 170, y: 23.012},
  {x: 171, y: 23.082},
  {x: 172, y: 23.151},
  {x: 173, y: 23.219},
  {x: 174, y: 23.285},
  {x: 175, y: 23.35},
  {x: 176, y: 23.414},
  {x: 177, y: 23.477},
  {x: 178, y: 23.538},
  {x: 179, y: 23.598},
  {x: 180, y: 23.656},
  {x: 181, y: 23.713},
  {x: 182, y: 23.768},
  {x: 183, y: 23.822},
  {x: 184, y: 23.875},
  {x: 185, y: 23.926},
  {x: 186, y: 23.976},
  {x: 187, y: 24.025},
  {x: 188, y: 24.072},
  {x: 189, y: 24.117},
  {x: 190, y: 24.162},
  {x: 191, y: 24.205},
  {x: 192, y: 24.247},
  {x: 193, y: 24.287},
  {x: 194, y: 24.326},
  {x: 195, y: 24.364},
  {x: 196, y: 24.4},
  {x: 197, y: 24.436},
  {x: 198, y: 24.47},
  {x: 199, y: 24.503},
  {x: 200, y: 24.535},
  {x: 201, y: 24.565},
  {x: 202, y: 24.595},
  {x: 203, y: 24.623},
  {x: 204, y: 24.651},
  {x: 205, y: 24.677},
  {x: 206, y: 24.703},
  {x: 207, y: 24.727},
  {x: 208, y: 24.751},
  {x: 209, y: 24.774},
  {x: 210, y: 24.796},
  {x: 211, y: 24.818},
  {x: 212, y: 24.839},
  {x: 213, y: 24.859},
  {x: 214, y: 24.879},
  {x: 215, y: 24.898},
  {x: 216, y: 24.917},
  {x: 217, y: 24.936},
  {x: 218, y: 24.953},
  {x: 219, y: 24.971},
  {x: 220, y: 24.988},
  {x: 221, y: 25.004},
  {x: 222, y: 25.021},
  {x: 223, y: 25.037},
  {x: 224, y: 25.053},
  {x: 225, y: 25.068},
  {x: 226, y: 25.084},
  {x: 227, y: 25.099},
  {x: 228, y: 25.113}
]

const bmiGirlsNintySeven = [
  {x: 0, y: 16.13},
  {x: 1, y: 17.685},
  {x: 2, y: 19.22},
  {x: 3, y: 19.846},
  {x: 4, y: 20.119},
  {x: 5, y: 20.254},
  {x: 6, y: 20.295},
  {x: 7, y: 20.263},
  {x: 8, y: 20.173},
  {x: 9, y: 20.046},
  {x: 10, y: 19.898},
  {x: 11, y: 19.745},
  {x: 12, y: 19.591},
  {x: 13, y: 19.441},
  {x: 14, y: 19.297},
  {x: 15, y: 19.16},
  {x: 16, y: 19.031},
  {x: 17, y: 18.91},
  {x: 18, y: 18.799},
  {x: 19, y: 18.696},
  {x: 20, y: 18.603},
  {x: 21, y: 18.521},
  {x: 22, y: 18.447},
  {x: 23, y: 18.38},
  {x: 24, y: 18.347},
  {x: 25, y: 18.602},
  {x: 26, y: 18.553},
  {x: 27, y: 18.504},
  {x: 29, y: 18.459},
  {x: 30, y: 18.414},
  {x: 31, y: 18.371},
  {x: 32, y: 18.33},
  {x: 33, y: 18.291},
  {x: 34, y: 18.253},
  {x: 35, y: 18.217},
  {x: 36, y: 18.184},
  {x: 37, y: 18.152},
  {x: 38, y: 18.124},
  {x: 39, y: 18.098},
  {x: 40, y: 18.074},
  {x: 41, y: 18.054},
  {x: 42, y: 18.036},
  {x: 43, y: 18.021},
  {x: 44, y: 18.009},
  {x: 45, y: 17.999},
  {x: 46, y: 17.992},
  {x: 47, y: 17.987},
  {x: 48, y: 17.984},
  {x: 49, y: 17.982},
  {x: 50, y: 17.983},
  {x: 51, y: 17.985},
  {x: 52, y: 17.988},
  {x: 53, y: 17.994},
  {x: 54, y: 18.001},
  {x: 55, y: 18.009},
  {x: 56, y: 18.019},
  {x: 57, y: 18.031},
  {x: 58, y: 18.044},
  {x: 59, y: 18.058},
  {x: 60, y: 18.073},
  {x: 61, y: 18.598},
  {x: 62, y: 18.624},
  {x: 63, y: 18.65},
  {x: 64, y: 18.677},
  {x: 65, y: 18.705},
  {x: 66, y: 18.734},
  {x: 67, y: 18.764},
  {x: 68, y: 18.795},
  {x: 69, y: 18.827},
  {x: 70, y: 18.86},
  {x: 71, y: 18.894},
  {x: 72, y: 18.929},
  {x: 73, y: 18.966},
  {x: 74, y: 19.003},
  {x: 75, y: 19.042},
  {x: 76, y: 19.081},
  {x: 77, y: 19.123},
  {x: 78, y: 19.165},
  {x: 79, y: 19.209},
  {x: 80, y: 19.254},
  {x: 81, y: 19.3},
  {x: 82, y: 19.348},
  {x: 83, y: 19.397},
  {x: 84, y: 19.448},
  {x: 85, y: 19.501},
  {x: 86, y: 19.554},
  {x: 87, y: 19.609},
  {x: 88, y: 19.666},
  {x: 89, y: 19.723},
  {x: 90, y: 19.783},
  {x: 91, y: 19.843},
  {x: 92, y: 19.905},
  {x: 93, y: 19.969},
  {x: 94, y: 20.034},
  {x: 95, y: 20.1},
  {x: 96, y: 20.167},
  {x: 97, y: 20.235},
  {x: 98, y: 20.305},
  {x: 99, y: 20.376},
  {x: 100, y: 20.449},
  {x: 101, y: 20.522},
  {x: 102, y: 20.597},
  {x: 103, y: 20.672},
  {x: 104, y: 20.748},
  {x: 105, y: 20.826},
  {x: 106, y: 20.904},
  {x: 107, y: 20.983},
  {x: 108, y: 21.062},
  {x: 109, y: 21.142},
  {x: 110, y: 21.223},
  {x: 111, y: 21.304},
  {x: 112, y: 21.386},
  {x: 113, y: 21.468},
  {x: 114, y: 21.551},
  {x: 115, y: 21.635},
  {x: 116, y: 21.719},
  {x: 117, y: 21.804},
  {x: 118, y: 21.889},
  {x: 119, y: 21.976},
  {x: 120, y: 22.063},
  {x: 121, y: 22.151},
  {x: 122, y: 22.239},
  {x: 123, y: 22.328},
  {x: 124, y: 22.418},
  {x: 125, y: 22.509},
  {x: 126, y: 22.601},
  {x: 127, y: 22.693},
  {x: 128, y: 22.786},
  {x: 129, y: 22.88},
  {x: 130, y: 22.975},
  {x: 131, y: 23.07},
  {x: 132, y: 23.167},
  {x: 133, y: 23.264},
  {x: 134, y: 23.361},
  {x: 135, y: 23.459},
  {x: 136, y: 23.558},
  {x: 137, y: 23.658},
  {x: 138, y: 23.758},
  {x: 139, y: 23.858},
  {x: 140, y: 23.959},
  {x: 141, y: 24.061},
  {x: 142, y: 24.162},
  {x: 143, y: 24.264},
  {x: 144, y: 24.366},
  {x: 145, y: 24.469},
  {x: 146, y: 24.571},
  {x: 147, y: 24.673},
  {x: 148, y: 24.775},
  {x: 149, y: 24.876},
  {x: 150, y: 24.978},
  {x: 151, y: 25.079},
  {x: 152, y: 25.179},
  {x: 153, y: 25.279},
  {x: 154, y: 25.378},
  {x: 155, y: 25.477},
  {x: 156, y: 25.574},
  {x: 157, y: 25.671},
  {x: 158, y: 25.767},
  {x: 159, y: 25.862},
  {x: 160, y: 25.956},
  {x: 161, y: 26.05},
  {x: 162, y: 26.141},
  {x: 163, y: 26.232},
  {x: 164, y: 26.322},
  {x: 165, y: 26.41},
  {x: 166, y: 26.497},
  {x: 167, y: 26.583},
  {x: 168, y: 26.667},
  {x: 169, y: 26.75},
  {x: 170, y: 26.832},
  {x: 171, y: 26.912},
  {x: 172, y: 26.991},
  {x: 173, y: 27.067},
  {x: 174, y: 27.143},
  {x: 175, y: 27.217},
  {x: 176, y: 27.288},
  {x: 177, y: 27.359},
  {x: 178, y: 27.427},
  {x: 179, y: 27.494},
  {x: 180, y: 27.559},
  {x: 181, y: 27.623},
  {x: 182, y: 27.684},
  {x: 183, y: 27.744},
  {x: 184, y: 27.802},
  {x: 185, y: 27.858},
  {x: 186, y: 27.913},
  {x: 187, y: 27.966},
  {x: 188, y: 28.017},
  {x: 189, y: 28.066},
  {x: 190, y: 28.114},
  {x: 191, y: 28.16},
  {x: 192, y: 28.205},
  {x: 193, y: 28.248},
  {x: 194, y: 28.289},
  {x: 195, y: 28.329},
  {x: 196, y: 28.367},
  {x: 197, y: 28.404},
  {x: 198, y: 28.439},
  {x: 199, y: 28.473},
  {x: 200, y: 28.505},
  {x: 201, y: 28.536},
  {x: 202, y: 28.566},
  {x: 203, y: 28.594},
  {x: 204, y: 28.62},
  {x: 205, y: 28.646},
  {x: 206, y: 28.672},
  {x: 207, y: 28.695},
  {x: 208, y: 28.717},
  {x: 209, y: 28.739},
  {x: 210, y: 28.76},
  {x: 211, y: 28.78},
  {x: 212, y: 28.799},
  {x: 213, y: 28.817},
  {x: 214, y: 28.835},
  {x: 215, y: 28.852},
  {x: 216, y: 28.868},
  {x: 217, y: 28.884},
  {x: 218, y: 28.899},
  {x: 219, y: 28.915},
  {x: 220, y: 28.929},
  {x: 221, y: 28.942},
  {x: 222, y: 28.956},
  {x: 223, y: 28.969},
  {x: 224, y: 28.982},
  {x: 225, y: 28.995},
  {x: 226, y: 29.007},
  {x: 227, y: 29.019},
  {x: 228, y: 29.03}
]

// Height

    // Boys

const heightBoysThree = [
  {x: 0, y: 46.324},
  {x: 1, y: 51.138},
  {x: 2, y: 54.78},
  {x: 3, y: 57.73},
  {x: 4, y: 60.13},
  {x: 5, y: 62.096},
  {x: 6, y: 63.769},
  {x: 7, y: 65.263},
  {x: 8, y: 66.648},
  {x: 9, y: 67.959},
  {x: 10, y: 69.205},
  {x: 11, y: 70.39},
  {x: 12, y: 71.521},
  {x: 13, y: 72.607},
  {x: 14, y: 73.651},
  {x: 15, y: 74.657},
  {x: 16, y: 75.629},
  {x: 17, y: 76.569},
  {x: 18, y: 77.48},
  {x: 19, y: 78.36},
  {x: 20, y: 79.214},
  {x: 21, y: 80.042},
  {x: 22, y: 80.848},
  {x: 23, y: 81.635},
  {x: 24, y: 81.701},
  {x: 25, y: 82.447},
  {x: 26, y: 83.174},
  {x: 27, y: 83.879},
  {x: 29, y: 84.564},
  {x: 30, y: 85.231},
  {x: 31, y: 85.879},
  {x: 32, y: 86.511},
  {x: 33, y: 87.128},
  {x: 34, y: 87.732},
  {x: 35, y: 88.325},
  {x: 36, y: 88.911},
  {x: 37, y: 89.487},
  {x: 38, y: 90.058},
  {x: 39, y: 90.621},
  {x: 40, y: 91.176},
  {x: 41, y: 91.725},
  {x: 42, y: 92.266},
  {x: 43, y: 92.801},
  {x: 44, y: 93.327},
  {x: 45, y: 93.847},
  {x: 46, y: 94.36},
  {x: 47, y: 94.87},
  {x: 48, y: 95.375},
  {x: 49, y: 95.876},
  {x: 50, y: 96.374},
  {x: 51, y: 96.87},
  {x: 52, y: 97.366},
  {x: 53, y: 97.859},
  {x: 54, y: 98.353},
  {x: 55, y: 98.845},
  {x: 56, y: 99.336},
  {x: 57, y: 99.826},
  {x: 58, y: 100.316},
  {x: 59, y: 100.804},
  {x: 60, y: 101.292},
  {x: 61, y: 101.629},
  {x: 62, y: 102.106},
  {x: 63, y: 102.581},
  {x: 64, y: 103.054},
  {x: 65, y: 103.522},
  {x: 66, y: 103.985},
  {x: 67, y: 104.444},
  {x: 68, y: 104.902},
  {x: 69, y: 105.353},
  {x: 70, y: 105.801},
  {x: 71, y: 106.246},
  {x: 72, y: 106.685},
  {x: 73, y: 107.12},
  {x: 74, y: 107.555},
  {x: 75, y: 107.985},
  {x: 76, y: 108.414},
  {x: 77, y: 108.842},
  {x: 78, y: 109.268},
  {x: 79, y: 109.692},
  {x: 80, y: 110.114},
  {x: 81, y: 110.538},
  {x: 82, y: 110.958},
  {x: 83, y: 111.376},
  {x: 84, y: 111.793},
  {x: 85, y: 112.207},
  {x: 86, y: 112.62},
  {x: 87, y: 113.031},
  {x: 88, y: 113.44},
  {x: 89, y: 113.848},
  {x: 90, y: 114.254},
  {x: 91, y: 114.657},
  {x: 92, y: 115.058},
  {x: 93, y: 115.458},
  {x: 94, y: 115.854},
  {x: 95, y: 116.249},
  {x: 96, y: 116.642},
  {x: 97, y: 117.034},
  {x: 98, y: 117.423},
  {x: 99, y: 117.811},
  {x: 100, y: 118.197},
  {x: 101, y: 118.583},
  {x: 102, y: 118.965},
  {x: 103, y: 119.349},
  {x: 104, y: 119.732},
  {x: 105, y: 120.114},
  {x: 106, y: 120.496},
  {x: 107, y: 120.877},
  {x: 108, y: 121.258},
  {x: 109, y: 121.639},
  {x: 110, y: 122.019},
  {x: 111, y: 122.398},
  {x: 112, y: 122.779},
  {x: 113, y: 123.156},
  {x: 114, y: 123.533},
  {x: 115, y: 123.912},
  {x: 116, y: 124.287},
  {x: 117, y: 124.665},
  {x: 118, y: 125.039},
  {x: 119, y: 125.416},
  {x: 120, y: 125.792},
  {x: 121, y: 126.169},
  {x: 122, y: 126.546},
  {x: 123, y: 126.924},
  {x: 124, y: 127.304},
  {x: 125, y: 127.685},
  {x: 126, y: 128.071},
  {x: 127, y: 128.458},
  {x: 128, y: 128.85},
  {x: 129, y: 129.245},
  {x: 130, y: 129.644},
  {x: 131, y: 130.046},
  {x: 132, y: 130.454},
  {x: 133, y: 130.863},
  {x: 134, y: 131.279},
  {x: 135, y: 131.7},
  {x: 136, y: 132.128},
  {x: 137, y: 132.558},
  {x: 138, y: 132.996},
  {x: 139, y: 133.439},
  {x: 140, y: 133.888},
  {x: 141, y: 134.343},
  {x: 142, y: 134.807},
  {x: 143, y: 135.277},
  {x: 144, y: 135.754},
  {x: 145, y: 136.24},
  {x: 146, y: 136.731},
  {x: 147, y: 137.235},
  {x: 148, y: 137.743},
  {x: 149, y: 138.261},
  {x: 150, y: 138.786},
  {x: 151, y: 139.321},
  {x: 152, y: 139.859},
  {x: 153, y: 140.407},
  {x: 154, y: 140.956},
  {x: 155, y: 141.512},
  {x: 156, y: 142.073},
  {x: 157, y: 142.635},
  {x: 158, y: 143.198},
  {x: 159, y: 143.761},
  {x: 160, y: 144.325},
  {x: 161, y: 144.89},
  {x: 162, y: 145.447},
  {x: 163, y: 146.004},
  {x: 164, y: 146.558},
  {x: 165, y: 147.107},
  {x: 166, y: 147.649},
  {x: 167, y: 148.184},
  {x: 168, y: 148.714},
  {x: 169, y: 149.237},
  {x: 170, y: 149.747},
  {x: 171, y: 150.25},
  {x: 172, y: 150.742},
  {x: 173, y: 151.224},
  {x: 174, y: 151.695},
  {x: 175, y: 152.153},
  {x: 176, y: 152.599},
  {x: 177, y: 153.037},
  {x: 178, y: 153.463},
  {x: 179, y: 153.877},
  {x: 180, y: 154.28},
  {x: 181, y: 154.674},
  {x: 182, y: 155.057},
  {x: 183, y: 155.428},
  {x: 184, y: 155.787},
  {x: 185, y: 156.135},
  {x: 186, y: 156.472},
  {x: 187, y: 156.801},
  {x: 188, y: 157.116},
  {x: 189, y: 157.424},
  {x: 190, y: 157.721},
  {x: 191, y: 158.004},
  {x: 192, y: 158.28},
  {x: 193, y: 158.545},
  {x: 194, y: 158.799},
  {x: 195, y: 159.043},
  {x: 196, y: 159.276},
  {x: 197, y: 159.499},
  {x: 198, y: 159.712},
  {x: 199, y: 159.915},
  {x: 200, y: 160.108},
  {x: 201, y: 160.292},
  {x: 202, y: 160.466},
  {x: 203, y: 160.628},
  {x: 204, y: 160.784},
  {x: 205, y: 160.932},
  {x: 206, y: 161.068},
  {x: 207, y: 161.201},
  {x: 208, y: 161.322},
  {x: 209, y: 161.44},
  {x: 210, y: 161.549},
  {x: 211, y: 161.652},
  {x: 212, y: 161.749},
  {x: 213, y: 161.842},
  {x: 214, y: 161.93},
  {x: 215, y: 162.014},
  {x: 216, y: 162.095},
  {x: 217, y: 162.168},
  {x: 218, y: 162.242},
  {x: 219, y: 162.31},
  {x: 220, y: 162.375},
  {x: 221, y: 162.438},
  {x: 222, y: 162.502},
  {x: 223, y: 162.557},
  {x: 224, y: 162.613},
  {x: 225, y: 162.668},
  {x: 226, y: 162.721},
  {x: 227, y: 162.77},
  {x: 228, y: 162.817}
]
const heightBoysFiftheen = [
  {x: 0, y: 47.922},
  {x: 1, y: 52.783},
  {x: 2, y: 56.471},
  {x: 3, y: 59.458},
  {x: 4, y: 61.889},
  {x: 5, y: 63.881},
  {x: 6, y: 65.58},
  {x: 7, y: 67.1},
  {x: 8, y: 68.514},
  {x: 9, y: 69.859},
  {x: 10, y: 71.141},
  {x: 11, y: 72.364},
  {x: 12, y: 73.537},
  {x: 13, y: 74.666},
  {x: 14, y: 75.755},
  {x: 15, y: 76.806},
  {x: 16, y: 77.825},
  {x: 17, y: 78.814},
  {x: 18, y: 79.773},
  {x: 19, y: 80.704},
  {x: 20, y: 81.609},
  {x: 21, y: 82.489},
  {x: 22, y: 83.347},
  {x: 23, y: 84.185},
  {x: 24, y: 84.303},
  {x: 25, y: 85.102},
  {x: 26, y: 85.879},
  {x: 27, y: 86.635},
  {x: 29, y: 87.37},
  {x: 30, y: 88.085},
  {x: 31, y: 88.78},
  {x: 32, y: 89.457},
  {x: 33, y: 90.118},
  {x: 34, y: 90.765},
  {x: 35, y: 91.401},
  {x: 36, y: 92.027},
  {x: 37, y: 92.643},
  {x: 38, y: 93.252},
  {x: 39, y: 93.853},
  {x: 40, y: 94.445},
  {x: 41, y: 95.03},
  {x: 42, y: 95.606},
  {x: 43, y: 96.174},
  {x: 44, y: 96.734},
  {x: 45, y: 97.288},
  {x: 46, y: 97.834},
  {x: 47, y: 98.375},
  {x: 48, y: 98.912},
  {x: 49, y: 99.445},
  {x: 50, y: 99.975},
  {x: 51, y: 100.503},
  {x: 52, y: 101.03},
  {x: 53, y: 101.555},
  {x: 54, y: 102.08},
  {x: 55, y: 102.604},
  {x: 56, y: 103.126},
  {x: 57, y: 103.648},
  {x: 58, y: 104.169},
  {x: 59, y: 104.688},
  {x: 60, y: 105.207},
  {x: 61, y: 105.506},
  {x: 62, y: 106.01},
  {x: 63, y: 106.51},
  {x: 64, y: 107.009},
  {x: 65, y: 107.503},
  {x: 66, y: 107.992},
  {x: 67, y: 108.478},
  {x: 68, y: 108.96},
  {x: 69, y: 109.437},
  {x: 70, y: 109.91},
  {x: 71, y: 110.38},
  {x: 72, y: 110.845},
  {x: 73, y: 111.306},
  {x: 74, y: 111.765},
  {x: 75, y: 112.221},
  {x: 76, y: 112.674},
  {x: 77, y: 113.128},
  {x: 78, y: 113.579},
  {x: 79, y: 114.028},
  {x: 80, y: 114.476},
  {x: 81, y: 114.924},
  {x: 82, y: 115.37},
  {x: 83, y: 115.814},
  {x: 84, y: 116.256},
  {x: 85, y: 116.696},
  {x: 86, y: 117.134},
  {x: 87, y: 117.571},
  {x: 88, y: 118.006},
  {x: 89, y: 118.439},
  {x: 90, y: 118.87},
  {x: 91, y: 119.299},
  {x: 92, y: 119.726},
  {x: 93, y: 120.15},
  {x: 94, y: 120.573},
  {x: 95, y: 120.993},
  {x: 96, y: 121.411},
  {x: 97, y: 121.828},
  {x: 98, y: 122.243},
  {x: 99, y: 122.656},
  {x: 100, y: 123.068},
  {x: 101, y: 123.479},
  {x: 102, y: 123.888},
  {x: 103, y: 124.297},
  {x: 104, y: 124.705},
  {x: 105, y: 125.113},
  {x: 106, y: 125.521},
  {x: 107, y: 125.928},
  {x: 108, y: 126.334},
  {x: 109, y: 126.741},
  {x: 110, y: 127.146},
  {x: 111, y: 127.551},
  {x: 112, y: 127.957},
  {x: 113, y: 128.36},
  {x: 114, y: 128.763},
  {x: 115, y: 129.167},
  {x: 116, y: 129.568},
  {x: 117, y: 129.97},
  {x: 118, y: 130.371},
  {x: 119, y: 130.772},
  {x: 120, y: 131.174},
  {x: 121, y: 131.575},
  {x: 122, y: 131.978},
  {x: 123, y: 132.381},
  {x: 124, y: 132.786},
  {x: 125, y: 133.193},
  {x: 126, y: 133.604},
  {x: 127, y: 134.016},
  {x: 128, y: 134.433},
  {x: 129, y: 134.853},
  {x: 130, y: 135.277},
  {x: 131, y: 135.704},
  {x: 132, y: 136.137},
  {x: 133, y: 136.572},
  {x: 134, y: 137.013},
  {x: 135, y: 137.459},
  {x: 136, y: 137.911},
  {x: 137, y: 138.367},
  {x: 138, y: 138.829},
  {x: 139, y: 139.297},
  {x: 140, y: 139.771},
  {x: 141, y: 140.252},
  {x: 142, y: 140.74},
  {x: 143, y: 141.235},
  {x: 144, y: 141.737},
  {x: 145, y: 142.248},
  {x: 146, y: 142.764},
  {x: 147, y: 143.291},
  {x: 148, y: 143.825},
  {x: 149, y: 144.367},
  {x: 150, y: 144.917},
  {x: 151, y: 145.475},
  {x: 152, y: 146.038},
  {x: 153, y: 146.609},
  {x: 154, y: 147.183},
  {x: 155, y: 147.762},
  {x: 156, y: 148.344},
  {x: 157, y: 148.929},
  {x: 158, y: 149.514},
  {x: 159, y: 150.099},
  {x: 160, y: 150.683},
  {x: 161, y: 151.266},
  {x: 162, y: 151.844},
  {x: 163, y: 152.419},
  {x: 164, y: 152.991},
  {x: 165, y: 153.556},
  {x: 166, y: 154.115},
  {x: 167, y: 154.665},
  {x: 168, y: 155.209},
  {x: 169, y: 155.744},
  {x: 170, y: 156.268},
  {x: 171, y: 156.782},
  {x: 172, y: 157.284},
  {x: 173, y: 157.775},
  {x: 174, y: 158.254},
  {x: 175, y: 158.72},
  {x: 176, y: 159.173},
  {x: 177, y: 159.615},
  {x: 178, y: 160.045},
  {x: 179, y: 160.464},
  {x: 180, y: 160.869},
  {x: 181, y: 161.265},
  {x: 182, y: 161.648},
  {x: 183, y: 162.019},
  {x: 184, y: 162.378},
  {x: 185, y: 162.725},
  {x: 186, y: 163.06},
  {x: 187, y: 163.386},
  {x: 188, y: 163.698},
  {x: 189, y: 164.001},
  {x: 190, y: 164.293},
  {x: 191, y: 164.572},
  {x: 192, y: 164.842},
  {x: 193, y: 165.1},
  {x: 194, y: 165.348},
  {x: 195, y: 165.584},
  {x: 196, y: 165.809},
  {x: 197, y: 166.024},
  {x: 198, y: 166.228},
  {x: 199, y: 166.421},
  {x: 200, y: 166.604},
  {x: 201, y: 166.778},
  {x: 202, y: 166.941},
  {x: 203, y: 167.094},
  {x: 204, y: 167.238},
  {x: 205, y: 167.374},
  {x: 206, y: 167.5},
  {x: 207, y: 167.62},
  {x: 208, y: 167.73},
  {x: 209, y: 167.835},
  {x: 210, y: 167.932},
  {x: 211, y: 168.023},
  {x: 212, y: 168.108},
  {x: 213, y: 168.188},
  {x: 214, y: 168.264},
  {x: 215, y: 168.335},
  {x: 216, y: 168.402},
  {x: 217, y: 168.464},
  {x: 218, y: 168.525},
  {x: 219, y: 168.581},
  {x: 220, y: 168.634},
  {x: 221, y: 168.684},
  {x: 222, y: 168.734},
  {x: 223, y: 168.779},
  {x: 224, y: 168.823},
  {x: 225, y: 168.866},
  {x: 226, y: 168.906},
  {x: 227, y: 168.943},
  {x: 228, y: 168.979}
]
const heightBoysFifthy = [
  {x: 0, y: 49.884},
  {x: 1, y: 54.801},
  {x: 2, y: 58.546},
  {x: 3, y: 61.579},
  {x: 4, y: 64.048},
  {x: 5, y: 66.072},
  {x: 6, y: 67.802},
  {x: 7, y: 69.355},
  {x: 8, y: 70.806},
  {x: 9, y: 72.191},
  {x: 10, y: 73.518},
  {x: 11, y: 74.788},
  {x: 12, y: 76.012},
  {x: 13, y: 77.194},
  {x: 14, y: 78.336},
  {x: 15, y: 79.444},
  {x: 16, y: 80.521},
  {x: 17, y: 81.569},
  {x: 18, y: 82.589},
  {x: 19, y: 83.581},
  {x: 20, y: 84.548},
  {x: 21, y: 85.492},
  {x: 22, y: 86.413},
  {x: 23, y: 87.315},
  {x: 24, y: 87.498},
  {x: 25, y: 88.36},
  {x: 26, y: 89.2},
  {x: 27, y: 90.018},
  {x: 29, y: 90.814},
  {x: 30, y: 91.587},
  {x: 31, y: 92.34},
  {x: 32, y: 93.073},
  {x: 33, y: 93.789},
  {x: 34, y: 94.489},
  {x: 35, y: 95.176},
  {x: 36, y: 95.852},
  {x: 37, y: 96.517},
  {x: 38, y: 97.173},
  {x: 39, y: 97.82},
  {x: 40, y: 98.458},
  {x: 41, y: 99.086},
  {x: 42, y: 99.706},
  {x: 43, y: 100.316},
  {x: 44, y: 100.917},
  {x: 45, y: 101.511},
  {x: 46, y: 102.097},
  {x: 47, y: 102.678},
  {x: 48, y: 103.253},
  {x: 49, y: 103.825},
  {x: 50, y: 104.395},
  {x: 51, y: 104.962},
  {x: 52, y: 105.528},
  {x: 53, y: 106.092},
  {x: 54, y: 106.656},
  {x: 55, y: 107.218},
  {x: 56, y: 107.779},
  {x: 57, y: 108.339},
  {x: 58, y: 108.898},
  {x: 59, y: 109.456},
  {x: 60, y: 110.013},
  {x: 61, y: 110.265},
  {x: 62, y: 110.801},
  {x: 63, y: 111.334},
  {x: 64, y: 111.864},
  {x: 65, y: 112.39},
  {x: 66, y: 112.911},
  {x: 67, y: 113.428},
  {x: 68, y: 113.941},
  {x: 69, y: 114.45},
  {x: 70, y: 114.955},
  {x: 71, y: 115.455},
  {x: 72, y: 115.951},
  {x: 73, y: 116.443},
  {x: 74, y: 116.932},
  {x: 75, y: 117.42},
  {x: 76, y: 117.905},
  {x: 77, y: 118.388},
  {x: 78, y: 118.87},
  {x: 79, y: 119.351},
  {x: 80, y: 119.83},
  {x: 81, y: 120.308},
  {x: 82, y: 120.785},
  {x: 83, y: 121.26},
  {x: 84, y: 121.734},
  {x: 85, y: 122.205},
  {x: 86, y: 122.675},
  {x: 87, y: 123.143},
  {x: 88, y: 123.609},
  {x: 89, y: 124.074},
  {x: 90, y: 124.536},
  {x: 91, y: 124.996},
  {x: 92, y: 125.454},
  {x: 93, y: 125.91},
  {x: 94, y: 126.364},
  {x: 95, y: 126.816},
  {x: 96, y: 127.265},
  {x: 97, y: 127.713},
  {x: 98, y: 128.159},
  {x: 99, y: 128.603},
  {x: 100, y: 129.047},
  {x: 101, y: 129.489},
  {x: 102, y: 129.93},
  {x: 103, y: 130.37},
  {x: 104, y: 130.81},
  {x: 105, y: 131.25},
  {x: 106, y: 131.688},
  {x: 107, y: 132.127},
  {x: 108, y: 132.565},
  {x: 109, y: 133.003},
  {x: 110, y: 133.44},
  {x: 111, y: 133.877},
  {x: 112, y: 134.313},
  {x: 113, y: 134.748},
  {x: 114, y: 135.183},
  {x: 115, y: 135.617},
  {x: 116, y: 136.05},
  {x: 117, y: 136.483},
  {x: 118, y: 136.915},
  {x: 119, y: 137.347},
  {x: 120, y: 137.78},
  {x: 121, y: 138.212},
  {x: 122, y: 138.645},
  {x: 123, y: 139.08},
  {x: 124, y: 139.516},
  {x: 125, y: 139.954},
  {x: 126, y: 140.395},
  {x: 127, y: 140.839},
  {x: 128, y: 141.286},
  {x: 129, y: 141.737},
  {x: 130, y: 142.192},
  {x: 131, y: 142.65},
  {x: 132, y: 143.113},
  {x: 133, y: 143.58},
  {x: 134, y: 144.051},
  {x: 135, y: 144.528},
  {x: 136, y: 145.009},
  {x: 137, y: 145.496},
  {x: 138, y: 145.989},
  {x: 139, y: 146.488},
  {x: 140, y: 146.993},
  {x: 141, y: 147.504},
  {x: 142, y: 148.022},
  {x: 143, y: 148.548},
  {x: 144, y: 149.081},
  {x: 145, y: 149.621},
  {x: 146, y: 150.169},
  {x: 147, y: 150.726},
  {x: 148, y: 151.29},
  {x: 149, y: 151.862},
  {x: 150, y: 152.442},
  {x: 151, y: 153.03},
  {x: 152, y: 153.623},
  {x: 153, y: 154.222},
  {x: 154, y: 154.826},
  {x: 155, y: 155.433},
  {x: 156, y: 156.043},
  {x: 157, y: 156.654},
  {x: 158, y: 157.266},
  {x: 159, y: 157.878},
  {x: 160, y: 158.487},
  {x: 161, y: 159.094},
  {x: 162, y: 159.696},
  {x: 163, y: 160.294},
  {x: 164, y: 160.886},
  {x: 165, y: 161.472},
  {x: 166, y: 162.05},
  {x: 167, y: 162.621},
  {x: 168, y: 163.182},
  {x: 169, y: 163.732},
  {x: 170, y: 164.272},
  {x: 171, y: 164.799},
  {x: 172, y: 165.314},
  {x: 173, y: 165.816},
  {x: 174, y: 166.305},
  {x: 175, y: 166.78},
  {x: 176, y: 167.242},
  {x: 177, y: 167.69},
  {x: 178, y: 168.126},
  {x: 179, y: 168.548},
  {x: 180, y: 168.958},
  {x: 181, y: 169.355},
  {x: 182, y: 169.739},
  {x: 183, y: 170.11},
  {x: 184, y: 170.468},
  {x: 185, y: 170.814},
  {x: 186, y: 171.147},
  {x: 187, y: 171.468},
  {x: 188, y: 171.777},
  {x: 189, y: 172.075},
  {x: 190, y: 172.361},
  {x: 191, y: 172.634},
  {x: 192, y: 172.897},
  {x: 193, y: 173.147},
  {x: 194, y: 173.386},
  {x: 195, y: 173.613},
  {x: 196, y: 173.828},
  {x: 197, y: 174.032},
  {x: 198, y: 174.225},
  {x: 199, y: 174.407},
  {x: 200, y: 174.578},
  {x: 201, y: 174.739},
  {x: 202, y: 174.89},
  {x: 203, y: 175.03},
  {x: 204, y: 175.161},
  {x: 205, y: 175.282},
  {x: 206, y: 175.395},
  {x: 207, y: 175.5},
  {x: 208, y: 175.596},
  {x: 209, y: 175.685},
  {x: 210, y: 175.767},
  {x: 211, y: 175.843},
  {x: 212, y: 175.913},
  {x: 213, y: 175.978},
  {x: 214, y: 176.038},
  {x: 215, y: 176.094},
  {x: 216, y: 176.145},
  {x: 217, y: 176.192},
  {x: 218, y: 176.237},
  {x: 219, y: 176.278},
  {x: 220, y: 176.316},
  {x: 221, y: 176.352},
  {x: 222, y: 176.385},
  {x: 223, y: 176.416},
  {x: 224, y: 176.445},
  {x: 225, y: 176.472},
  {x: 226, y: 176.498},
  {x: 227, y: 176.521},
  {x: 228, y: 176.543}
]
const heightBoysEightyFive = [
  {x: 0, y: 51.846},
  {x: 1, y: 56.82},
  {x: 2, y: 60.622},
  {x: 3, y: 63.7},
  {x: 4, y: 66.208},
  {x: 5, y: 68.263},
  {x: 6, y: 70.024},
  {x: 7, y: 71.61},
  {x: 8, y: 73.097},
  {x: 9, y: 74.523},
  {x: 10, y: 75.894},
  {x: 11, y: 77.212},
  {x: 12, y: 78.486},
  {x: 13, y: 79.721},
  {x: 14, y: 80.918},
  {x: 15, y: 82.082},
  {x: 16, y: 83.217},
  {x: 17, y: 84.324},
  {x: 18, y: 85.404},
  {x: 19, y: 86.458},
  {x: 20, y: 87.487},
  {x: 21, y: 88.494},
  {x: 22, y: 89.48},
  {x: 23, y: 90.445},
  {x: 24, y: 90.693},
  {x: 25, y: 91.619},
  {x: 26, y: 92.521},
  {x: 27, y: 93.401},
  {x: 29, y: 94.257},
  {x: 30, y: 95.09},
  {x: 31, y: 95.9},
  {x: 32, y: 96.69},
  {x: 33, y: 97.459},
  {x: 34, y: 98.212},
  {x: 35, y: 98.951},
  {x: 36, y: 99.676},
  {x: 37, y: 100.392},
  {x: 38, y: 101.094},
  {x: 39, y: 101.787},
  {x: 40, y: 102.47},
  {x: 41, y: 103.143},
  {x: 42, y: 103.805},
  {x: 43, y: 104.457},
  {x: 44, y: 105.1},
  {x: 45, y: 105.734},
  {x: 46, y: 106.36},
  {x: 47, y: 106.98},
  {x: 48, y: 107.595},
  {x: 49, y: 108.206},
  {x: 50, y: 108.815},
  {x: 51, y: 109.421},
  {x: 52, y: 110.025},
  {x: 53, y: 110.629},
  {x: 54, y: 111.231},
  {x: 55, y: 111.831},
  {x: 56, y: 112.431},
  {x: 57, y: 113.03},
  {x: 58, y: 113.627},
  {x: 59, y: 114.224},
  {x: 60, y: 114.819},
  {x: 61, y: 115.023},
  {x: 62, y: 115.592},
  {x: 63, y: 116.157},
  {x: 64, y: 116.718},
  {x: 65, y: 117.276},
  {x: 66, y: 117.83},
  {x: 67, y: 118.378},
  {x: 68, y: 118.922},
  {x: 69, y: 119.463},
  {x: 70, y: 119.999},
  {x: 71, y: 120.53},
  {x: 72, y: 121.057},
  {x: 73, y: 121.581},
  {x: 74, y: 122.1},
  {x: 75, y: 122.619},
  {x: 76, y: 123.135},
  {x: 77, y: 123.648},
  {x: 78, y: 124.161},
  {x: 79, y: 124.674},
  {x: 80, y: 125.184},
  {x: 81, y: 125.693},
  {x: 82, y: 126.201},
  {x: 83, y: 126.707},
  {x: 84, y: 127.212},
  {x: 85, y: 127.715},
  {x: 86, y: 128.216},
  {x: 87, y: 128.715},
  {x: 88, y: 129.213},
  {x: 89, y: 129.709},
  {x: 90, y: 130.202},
  {x: 91, y: 130.694},
  {x: 92, y: 131.183},
  {x: 93, y: 131.671},
  {x: 94, y: 132.155},
  {x: 95, y: 132.638},
  {x: 96, y: 133.119},
  {x: 97, y: 133.598},
  {x: 98, y: 134.075},
  {x: 99, y: 134.551},
  {x: 100, y: 135.025},
  {x: 101, y: 135.498},
  {x: 102, y: 135.972},
  {x: 103, y: 136.444},
  {x: 104, y: 136.915},
  {x: 105, y: 137.386},
  {x: 106, y: 137.856},
  {x: 107, y: 138.326},
  {x: 108, y: 138.796},
  {x: 109, y: 139.266},
  {x: 110, y: 139.735},
  {x: 111, y: 140.203},
  {x: 112, y: 140.669},
  {x: 113, y: 141.136},
  {x: 114, y: 141.603},
  {x: 115, y: 142.067},
  {x: 116, y: 142.532},
  {x: 117, y: 142.996},
  {x: 118, y: 143.46},
  {x: 119, y: 143.923},
  {x: 120, y: 144.385},
  {x: 121, y: 144.849},
  {x: 122, y: 145.313},
  {x: 123, y: 145.778},
  {x: 124, y: 146.245},
  {x: 125, y: 146.715},
  {x: 126, y: 147.186},
  {x: 127, y: 147.661},
  {x: 128, y: 148.139},
  {x: 129, y: 148.621},
  {x: 130, y: 149.106},
  {x: 131, y: 149.596},
  {x: 132, y: 150.088},
  {x: 133, y: 150.587},
  {x: 134, y: 151.089},
  {x: 135, y: 151.596},
  {x: 136, y: 152.108},
  {x: 137, y: 152.626},
  {x: 138, y: 153.149},
  {x: 139, y: 153.678},
  {x: 140, y: 154.214},
  {x: 141, y: 154.757},
  {x: 142, y: 155.305},
  {x: 143, y: 155.861},
  {x: 144, y: 156.425},
  {x: 145, y: 156.995},
  {x: 146, y: 157.575},
  {x: 147, y: 158.16},
  {x: 148, y: 158.755},
  {x: 149, y: 159.357},
  {x: 150, y: 159.968},
  {x: 151, y: 160.584},
  {x: 152, y: 161.209},
  {x: 153, y: 161.836},
  {x: 154, y: 162.469},
  {x: 155, y: 163.104},
  {x: 156, y: 163.741},
  {x: 157, y: 164.379},
  {x: 158, y: 165.018},
  {x: 159, y: 165.656},
  {x: 160, y: 166.291},
  {x: 161, y: 166.921},
  {x: 162, y: 167.548},
  {x: 163, y: 168.169},
  {x: 164, y: 168.782},
  {x: 165, y: 169.388},
  {x: 166, y: 169.986},
  {x: 167, y: 170.576},
  {x: 168, y: 171.154},
  {x: 169, y: 171.72},
  {x: 170, y: 172.275},
  {x: 171, y: 172.817},
  {x: 172, y: 173.345},
  {x: 173, y: 173.858},
  {x: 174, y: 174.356},
  {x: 175, y: 174.84},
  {x: 176, y: 175.31},
  {x: 177, y: 175.765},
  {x: 178, y: 176.206},
  {x: 179, y: 176.633},
  {x: 180, y: 177.047},
  {x: 181, y: 177.445},
  {x: 182, y: 177.83},
  {x: 183, y: 178.201},
  {x: 184, y: 178.558},
  {x: 185, y: 178.902},
  {x: 186, y: 179.234},
  {x: 187, y: 179.55},
  {x: 188, y: 179.857},
  {x: 189, y: 180.148},
  {x: 190, y: 180.428},
  {x: 191, y: 180.697},
  {x: 192, y: 180.952},
  {x: 193, y: 181.194},
  {x: 194, y: 181.424},
  {x: 195, y: 181.641},
  {x: 196, y: 181.847},
  {x: 197, y: 182.041},
  {x: 198, y: 182.223},
  {x: 199, y: 182.393},
  {x: 200, y: 182.552},
  {x: 201, y: 182.701},
  {x: 202, y: 182.838},
  {x: 203, y: 182.967},
  {x: 204, y: 183.083},
  {x: 205, y: 183.19},
  {x: 206, y: 183.29},
  {x: 207, y: 183.379},
  {x: 208, y: 183.462},
  {x: 209, y: 183.535},
  {x: 210, y: 183.602},
  {x: 211, y: 183.664},
  {x: 212, y: 183.719},
  {x: 213, y: 183.768},
  {x: 214, y: 183.812},
  {x: 215, y: 183.852},
  {x: 216, y: 183.887},
  {x: 217, y: 183.921},
  {x: 218, y: 183.949},
  {x: 219, y: 183.975},
  {x: 220, y: 183.999},
  {x: 221, y: 184.019},
  {x: 222, y: 184.036},
  {x: 223, y: 184.054},
  {x: 224, y: 184.067},
  {x: 225, y: 184.079},
  {x: 226, y: 184.089},
  {x: 227, y: 184.099},
  {x: 228, y: 184.107}
]
const heightBoysNintySeven = [
  {x: 0, y: 53.445},
  {x: 1, y: 58.464},
  {x: 2, y: 62.312},
  {x: 3, y: 65.428},
  {x: 4, y: 67.967},
  {x: 5, y: 70.049},
  {x: 6, y: 71.834},
  {x: 7, y: 73.447},
  {x: 8, y: 74.963},
  {x: 9, y: 76.423},
  {x: 10, y: 77.83},
  {x: 11, y: 79.187},
  {x: 12, y: 80.502},
  {x: 13, y: 81.78},
  {x: 14, y: 83.022},
  {x: 15, y: 84.231},
  {x: 16, y: 85.413},
  {x: 17, y: 86.569},
  {x: 18, y: 87.698},
  {x: 19, y: 88.801},
  {x: 20, y: 89.881},
  {x: 21, y: 90.941},
  {x: 22, y: 91.978},
  {x: 23, y: 92.996},
  {x: 24, y: 93.296},
  {x: 25, y: 94.273},
  {x: 26, y: 95.226},
  {x: 27, y: 96.157},
  {x: 29, y: 97.063},
  {x: 30, y: 97.943},
  {x: 31, y: 98.801},
  {x: 32, y: 99.636},
  {x: 33, y: 100.449},
  {x: 34, y: 101.245},
  {x: 35, y: 102.026},
  {x: 36, y: 102.792},
  {x: 37, y: 103.548},
  {x: 38, y: 104.288},
  {x: 39, y: 105.019},
  {x: 40, y: 105.739},
  {x: 41, y: 106.448},
  {x: 42, y: 107.145},
  {x: 43, y: 107.83},
  {x: 44, y: 108.507},
  {x: 45, y: 109.174},
  {x: 46, y: 109.834},
  {x: 47, y: 110.485},
  {x: 48, y: 111.132},
  {x: 49, y: 111.775},
  {x: 50, y: 112.415},
  {x: 51, y: 113.054},
  {x: 52, y: 113.689},
  {x: 53, y: 114.325},
  {x: 54, y: 114.958},
  {x: 55, y: 115.59},
  {x: 56, y: 116.222},
  {x: 57, y: 116.852},
  {x: 58, y: 117.48},
  {x: 59, y: 118.109},
  {x: 60, y: 118.734},
  {x: 61, y: 118.9},
  {x: 62, y: 119.495},
  {x: 63, y: 120.087},
  {x: 64, y: 120.673},
  {x: 65, y: 121.257},
  {x: 66, y: 121.837},
  {x: 67, y: 122.412},
  {x: 68, y: 122.98},
  {x: 69, y: 123.547},
  {x: 70, y: 124.109},
  {x: 71, y: 124.664},
  {x: 72, y: 125.217},
  {x: 73, y: 125.766},
  {x: 74, y: 126.31},
  {x: 75, y: 126.854},
  {x: 76, y: 127.396},
  {x: 77, y: 127.934},
  {x: 78, y: 128.472},
  {x: 79, y: 129.01},
  {x: 80, y: 129.546},
  {x: 81, y: 130.079},
  {x: 82, y: 130.613},
  {x: 83, y: 131.145},
  {x: 84, y: 131.675},
  {x: 85, y: 132.203},
  {x: 86, y: 132.73},
  {x: 87, y: 133.255},
  {x: 88, y: 133.778},
  {x: 89, y: 134.299},
  {x: 90, y: 134.819},
  {x: 91, y: 135.336},
  {x: 92, y: 135.851},
  {x: 93, y: 136.363},
  {x: 94, y: 136.874},
  {x: 95, y: 137.382},
  {x: 96, y: 137.888},
  {x: 97, y: 138.392},
  {x: 98, y: 138.895},
  {x: 99, y: 139.396},
  {x: 100, y: 139.896},
  {x: 101, y: 140.394},
  {x: 102, y: 140.895},
  {x: 103, y: 141.392},
  {x: 104, y: 141.889},
  {x: 105, y: 142.385},
  {x: 106, y: 142.881},
  {x: 107, y: 143.377},
  {x: 108, y: 143.872},
  {x: 109, y: 144.367},
  {x: 110, y: 144.862},
  {x: 111, y: 145.356},
  {x: 112, y: 145.847},
  {x: 113, y: 146.34},
  {x: 114, y: 146.833},
  {x: 115, y: 147.322},
  {x: 116, y: 147.813},
  {x: 117, y: 148.301},
  {x: 118, y: 148.792},
  {x: 119, y: 149.279},
  {x: 120, y: 149.767},
  {x: 121, y: 150.255},
  {x: 122, y: 150.745},
  {x: 123, y: 151.235},
  {x: 124, y: 151.728},
  {x: 125, y: 152.223},
  {x: 126, y: 152.718},
  {x: 127, y: 153.22},
  {x: 128, y: 153.722},
  {x: 129, y: 154.229},
  {x: 130, y: 154.74},
  {x: 131, y: 155.255},
  {x: 132, y: 155.771},
  {x: 133, y: 156.296},
  {x: 134, y: 156.823},
  {x: 135, y: 157.355},
  {x: 136, y: 157.89},
  {x: 137, y: 158.435},
  {x: 138, y: 158.982},
  {x: 139, y: 159.536},
  {x: 140, y: 160.097},
  {x: 141, y: 160.665},
  {x: 142, y: 161.238},
  {x: 143, y: 161.819},
  {x: 144, y: 162.408},
  {x: 145, y: 163.002},
  {x: 146, y: 163.608},
  {x: 147, y: 164.217},
  {x: 148, y: 164.837},
  {x: 149, y: 165.464},
  {x: 150, y: 166.099},
  {x: 151, y: 166.739},
  {x: 152, y: 167.388},
  {x: 153, y: 168.038},
  {x: 154, y: 168.695},
  {x: 155, y: 169.354},
  {x: 156, y: 170.012},
  {x: 157, y: 170.673},
  {x: 158, y: 171.334},
  {x: 159, y: 171.994},
  {x: 160, y: 172.649},
  {x: 161, y: 173.298},
  {x: 162, y: 173.945},
  {x: 163, y: 174.584},
  {x: 164, y: 175.214},
  {x: 165, y: 175.837},
  {x: 166, y: 176.452},
  {x: 167, y: 177.057},
  {x: 168, y: 177.649},
  {x: 169, y: 178.227},
  {x: 170, y: 178.796},
  {x: 171, y: 179.349},
  {x: 172, y: 179.887},
  {x: 173, y: 180.409},
  {x: 174, y: 180.915},
  {x: 175, y: 181.407},
  {x: 176, y: 181.884},
  {x: 177, y: 182.343},
  {x: 178, y: 182.788},
  {x: 179, y: 183.219},
  {x: 180, y: 183.636},
  {x: 181, y: 184.036},
  {x: 182, y: 184.421},
  {x: 183, y: 184.792},
  {x: 184, y: 185.149},
  {x: 185, y: 185.492},
  {x: 186, y: 185.822},
  {x: 187, y: 186.135},
  {x: 188, y: 186.439},
  {x: 189, y: 186.726},
  {x: 190, y: 187},
  {x: 191, y: 187.265},
  {x: 192, y: 187.514},
  {x: 193, y: 187.749},
  {x: 194, y: 187.972},
  {x: 195, y: 188.182},
  {x: 196, y: 188.38},
  {x: 197, y: 188.565},
  {x: 198, y: 188.738},
  {x: 199, y: 188.899},
  {x: 200, y: 189.049},
  {x: 201, y: 189.187},
  {x: 202, y: 189.313},
  {x: 203, y: 189.432},
  {x: 204, y: 189.538},
  {x: 205, y: 189.633},
  {x: 206, y: 189.722},
  {x: 207, y: 189.798},
  {x: 208, y: 189.87},
  {x: 209, y: 189.93},
  {x: 210, y: 189.986},
  {x: 211, y: 190.035},
  {x: 212, y: 190.077},
  {x: 213, y: 190.114},
  {x: 214, y: 190.146},
  {x: 215, y: 190.173},
  {x: 216, y: 190.195},
  {x: 217, y: 190.217},
  {x: 218, y: 190.231},
  {x: 219, y: 190.246},
  {x: 220, y: 190.257},
  {x: 221, y: 190.266},
  {x: 222, y: 190.269},
  {x: 223, y: 190.276},
  {x: 224, y: 190.277},
  {x: 225, y: 190.276},
  {x: 226, y: 190.274},
  {x: 227, y: 190.273},
  {x: 228, y: 190.27}
]

    // GIRLS
const heightGirlsThree = [
  {x: 0, y: 45.644},
  {x: 1, y: 50.079},
  {x: 2, y: 53.343},
  {x: 3, y: 55.975},
  {x: 4, y: 58.165},
  {x: 5, y: 60.017},
  {x: 6, y: 61.637},
  {x: 7, y: 63.115},
  {x: 8, y: 64.498},
  {x: 9, y: 65.81},
  {x: 10, y: 67.064},
  {x: 11, y: 68.265},
  {x: 12, y: 69.419},
  {x: 13, y: 70.531},
  {x: 14, y: 71.602},
  {x: 15, y: 72.636},
  {x: 16, y: 73.638},
  {x: 17, y: 74.609},
  {x: 18, y: 75.552},
  {x: 19, y: 76.467},
  {x: 20, y: 77.358},
  {x: 21, y: 78.226},
  {x: 22, y: 79.069},
  {x: 23, y: 79.891},
  {x: 24, y: 79.994},
  {x: 25, y: 80.778},
  {x: 26, y: 81.541},
  {x: 27, y: 82.286},
  {x: 29, y: 83.014},
  {x: 30, y: 83.724},
  {x: 31, y: 84.416},
  {x: 32, y: 85.093},
  {x: 33, y: 85.755},
  {x: 34, y: 86.406},
  {x: 35, y: 87.044},
  {x: 36, y: 87.674},
  {x: 37, y: 88.293},
  {x: 38, y: 88.904},
  {x: 39, y: 89.506},
  {x: 40, y: 90.099},
  {x: 41, y: 90.685},
  {x: 42, y: 91.262},
  {x: 43, y: 91.831},
  {x: 44, y: 92.393},
  {x: 45, y: 92.946},
  {x: 46, y: 93.492},
  {x: 47, y: 94.031},
  {x: 48, y: 94.562},
  {x: 49, y: 95.088},
  {x: 50, y: 95.607},
  {x: 51, y: 96.122},
  {x: 52, y: 96.63},
  {x: 53, y: 97.135},
  {x: 54, y: 97.633},
  {x: 55, y: 98.127},
  {x: 56, y: 98.615},
  {x: 57, y: 99.1},
  {x: 58, y: 99.577},
  {x: 59, y: 100.051},
  {x: 60, y: 100.519},
  {x: 61, y: 100.624},
  {x: 62, y: 101.087},
  {x: 63, y: 101.545},
  {x: 64, y: 101.998},
  {x: 65, y: 102.449},
  {x: 66, y: 102.894},
  {x: 67, y: 103.337},
  {x: 68, y: 103.776},
  {x: 69, y: 104.212},
  {x: 70, y: 104.643},
  {x: 71, y: 105.071},
  {x: 72, y: 105.496},
  {x: 73, y: 105.92},
  {x: 74, y: 106.342},
  {x: 75, y: 106.76},
  {x: 76, y: 107.181},
  {x: 77, y: 107.599},
  {x: 78, y: 108.016},
  {x: 79, y: 108.435},
  {x: 80, y: 108.851},
  {x: 81, y: 109.27},
  {x: 82, y: 109.688},
  {x: 83, y: 110.107},
  {x: 84, y: 110.529},
  {x: 85, y: 110.949},
  {x: 86, y: 111.371},
  {x: 87, y: 111.792},
  {x: 88, y: 112.216},
  {x: 89, y: 112.643},
  {x: 90, y: 113.068},
  {x: 91, y: 113.494},
  {x: 92, y: 113.923},
  {x: 93, y: 114.354},
  {x: 94, y: 114.785},
  {x: 95, y: 115.218},
  {x: 96, y: 115.652},
  {x: 97, y: 116.087},
  {x: 98, y: 116.526},
  {x: 99, y: 116.966},
  {x: 100, y: 117.407},
  {x: 101, y: 117.85},
  {x: 102, y: 118.294},
  {x: 103, y: 118.742},
  {x: 104, y: 119.191},
  {x: 105, y: 119.639},
  {x: 106, y: 120.094},
  {x: 107, y: 120.547},
  {x: 108, y: 121.002},
  {x: 109, y: 121.46},
  {x: 110, y: 121.919},
  {x: 111, y: 122.38},
  {x: 112, y: 122.842},
  {x: 113, y: 123.307},
  {x: 114, y: 123.771},
  {x: 115, y: 124.239},
  {x: 116, y: 124.711},
  {x: 117, y: 125.181},
  {x: 118, y: 125.653},
  {x: 119, y: 126.128},
  {x: 120, y: 126.605},
  {x: 121, y: 127.087},
  {x: 122, y: 127.567},
  {x: 123, y: 128.051},
  {x: 124, y: 128.537},
  {x: 125, y: 129.025},
  {x: 126, y: 129.514},
  {x: 127, y: 130.008},
  {x: 128, y: 130.502},
  {x: 129, y: 130.998},
  {x: 130, y: 131.495},
  {x: 131, y: 131.992},
  {x: 132, y: 132.492},
  {x: 133, y: 132.992},
  {x: 134, y: 133.491},
  {x: 135, y: 133.992},
  {x: 136, y: 134.489},
  {x: 137, y: 134.986},
  {x: 138, y: 135.48},
  {x: 139, y: 135.971},
  {x: 140, y: 136.461},
  {x: 141, y: 136.944},
  {x: 142, y: 137.425},
  {x: 143, y: 137.899},
  {x: 144, y: 138.368},
  {x: 145, y: 138.832},
  {x: 146, y: 139.285},
  {x: 147, y: 139.733},
  {x: 148, y: 140.17},
  {x: 149, y: 140.599},
  {x: 150, y: 141.019},
  {x: 151, y: 141.428},
  {x: 152, y: 141.83},
  {x: 153, y: 142.218},
  {x: 154, y: 142.596},
  {x: 155, y: 142.965},
  {x: 156, y: 143.319},
  {x: 157, y: 143.666},
  {x: 158, y: 144.001},
  {x: 159, y: 144.324},
  {x: 160, y: 144.633},
  {x: 161, y: 144.934},
  {x: 162, y: 145.223},
  {x: 163, y: 145.502},
  {x: 164, y: 145.769},
  {x: 165, y: 146.023},
  {x: 166, y: 146.269},
  {x: 167, y: 146.505},
  {x: 168, y: 146.731},
  {x: 169, y: 146.947},
  {x: 170, y: 147.151},
  {x: 171, y: 147.348},
  {x: 172, y: 147.537},
  {x: 173, y: 147.713},
  {x: 174, y: 147.884},
  {x: 175, y: 148.043},
  {x: 176, y: 148.197},
  {x: 177, y: 148.341},
  {x: 178, y: 148.477},
  {x: 179, y: 148.606},
  {x: 180, y: 148.731},
  {x: 181, y: 148.847},
  {x: 182, y: 148.956},
  {x: 183, y: 149.056},
  {x: 184, y: 149.154},
  {x: 185, y: 149.246},
  {x: 186, y: 149.334},
  {x: 187, y: 149.413},
  {x: 188, y: 149.491},
  {x: 189, y: 149.561},
  {x: 190, y: 149.627},
  {x: 191, y: 149.693},
  {x: 192, y: 149.751},
  {x: 193, y: 149.807},
  {x: 194, y: 149.86},
  {x: 195, y: 149.91},
  {x: 196, y: 149.957},
  {x: 197, y: 150.00},
  {x: 198, y: 150.044},
  {x: 199, y: 150.083},
  {x: 200, y: 150.124},
  {x: 201, y: 150.161},
  {x: 202, y: 150.2},
  {x: 203, y: 150.235},
  {x: 204, y: 150.269},
  {x: 205, y: 150.302},
  {x: 206, y: 150.335},
  {x: 207, y: 150.368},
  {x: 208, y: 150.4},
  {x: 209, y: 150.431},
  {x: 210, y: 150.46},
  {x: 211, y: 150.49},
  {x: 212, y: 150.518},
  {x: 213, y: 150.548},
  {x: 214, y: 150.575},
  {x: 215, y: 150.601},
  {x: 216, y: 150.63},
  {x: 217, y: 150.655},
  {x: 218, y: 150.679},
  {x: 219, y: 150.702},
  {x: 220, y: 150.725},
  {x: 221, y: 150.743},
  {x: 222, y: 150.763},
  {x: 223, y: 150.783},
  {x: 224, y: 150.798},
  {x: 225, y: 150.815},
  {x: 226, y: 150.828},
  {x: 227, y: 150.842},
  {x: 228, y: 150.853}
]
const heightGirlsFiftheen = [
  {x: 0, y: 47.217},
  {x: 1, y: 51.73},
  {x: 2, y: 55.065},
  {x: 3, y: 57.755},
  {x: 4, y: 59.997},
  {x: 5, y: 61.893},
  {x: 6, y: 63.555},
  {x: 7, y: 65.075},
  {x: 8, y: 66.501},
  {x: 9, y: 67.857},
  {x: 10, y: 69.156},
  {x: 11, y: 70.403},
  {x: 12, y: 71.603},
  {x: 13, y: 72.762},
  {x: 14, y: 73.88},
  {x: 15, y: 74.962},
  {x: 16, y: 76.011},
  {x: 17, y: 77.029},
  {x: 18, y: 78.019},
  {x: 19, y: 78.981},
  {x: 20, y: 79.919},
  {x: 21, y: 80.833},
  {x: 22, y: 81.722},
  {x: 23, y: 82.59},
  {x: 24, y: 82.738},
  {x: 25, y: 83.566},
  {x: 26, y: 84.373},
  {x: 27, y: 85.162},
  {x: 29, y: 85.933},
  {x: 30, y: 86.685},
  {x: 31, y: 87.419},
  {x: 32, y: 88.137},
  {x: 33, y: 88.84},
  {x: 34, y: 89.53},
  {x: 35, y: 90.208},
  {x: 36, y: 90.876},
  {x: 37, y: 91.533},
  {x: 38, y: 92.182},
  {x: 39, y: 92.821},
  {x: 40, y: 93.451},
  {x: 41, y: 94.073},
  {x: 42, y: 94.686},
  {x: 43, y: 95.291},
  {x: 44, y: 95.888},
  {x: 45, y: 96.476},
  {x: 46, y: 97.056},
  {x: 47, y: 97.629},
  {x: 48, y: 98.194},
  {x: 49, y: 98.754},
  {x: 50, y: 99.306},
  {x: 51, y: 99.854},
  {x: 52, y: 100.395},
  {x: 53, y: 100.932},
  {x: 54, y: 101.463},
  {x: 55, y: 101.988},
  {x: 56, y: 102.509},
  {x: 57, y: 103.024},
  {x: 58, y: 103.533},
  {x: 59, y: 104.039},
  {x: 60, y: 104.538},
  {x: 61, y: 104.655},
  {x: 62, y: 105.145},
  {x: 63, y: 105.63},
  {x: 64, y: 106.111},
  {x: 65, y: 106.589},
  {x: 66, y: 107.061},
  {x: 67, y: 107.53},
  {x: 68, y: 107.995},
  {x: 69, y: 108.457},
  {x: 70, y: 108.914},
  {x: 71, y: 109.368},
  {x: 72, y: 109.818},
  {x: 73, y: 110.267},
  {x: 74, y: 110.714},
  {x: 75, y: 111.158},
  {x: 76, y: 111.603},
  {x: 77, y: 112.046},
  {x: 78, y: 112.488},
  {x: 79, y: 112.931},
  {x: 80, y: 113.372},
  {x: 81, y: 113.814},
  {x: 82, y: 114.257},
  {x: 83, y: 114.7},
  {x: 84, y: 115.145},
  {x: 85, y: 115.589},
  {x: 86, y: 116.035},
  {x: 87, y: 116.48},
  {x: 88, y: 116.927},
  {x: 89, y: 117.376},
  {x: 90, y: 117.825},
  {x: 91, y: 118.275},
  {x: 92, y: 118.727},
  {x: 93, y: 119.18},
  {x: 94, y: 119.635},
  {x: 95, y: 120.09},
  {x: 96, y: 120.547},
  {x: 97, y: 121.005},
  {x: 98, y: 121.466},
  {x: 99, y: 121.928},
  {x: 100, y: 122.392},
  {x: 101, y: 122.857},
  {x: 102, y: 123.324},
  {x: 103, y: 123.793},
  {x: 104, y: 124.264},
  {x: 105, y: 124.735},
  {x: 106, y: 125.21},
  {x: 107, y: 125.685},
  {x: 108, y: 126.161},
  {x: 109, y: 126.64},
  {x: 110, y: 127.12},
  {x: 111, y: 127.602},
  {x: 112, y: 128.085},
  {x: 113, y: 128.57},
  {x: 114, y: 129.055},
  {x: 115, y: 129.543},
  {x: 116, y: 130.033},
  {x: 117, y: 130.524},
  {x: 118, y: 131.016},
  {x: 119, y: 131.51},
  {x: 120, y: 132.007},
  {x: 121, y: 132.506},
  {x: 122, y: 133.005},
  {x: 123, y: 133.507},
  {x: 124, y: 134.012},
  {x: 125, y: 134.517},
  {x: 126, y: 135.025},
  {x: 127, y: 135.535},
  {x: 128, y: 136.047},
  {x: 129, y: 136.56},
  {x: 130, y: 137.074},
  {x: 131, y: 137.588},
  {x: 132, y: 138.104},
  {x: 133, y: 138.62},
  {x: 134, y: 139.135},
  {x: 135, y: 139.65},
  {x: 136, y: 140.162},
  {x: 137, y: 140.673},
  {x: 138, y: 141.182},
  {x: 139, y: 141.687},
  {x: 140, y: 142.189},
  {x: 141, y: 142.685},
  {x: 142, y: 143.177},
  {x: 143, y: 143.664},
  {x: 144, y: 144.143},
  {x: 145, y: 144.617},
  {x: 146, y: 145.081},
  {x: 147, y: 145.538},
  {x: 148, y: 145.984},
  {x: 149, y: 146.421},
  {x: 150, y: 146.849},
  {x: 151, y: 147.265},
  {x: 152, y: 147.672},
  {x: 153, y: 148.066},
  {x: 154, y: 148.449},
  {x: 155, y: 148.821},
  {x: 156, y: 149.18},
  {x: 157, y: 149.529},
  {x: 158, y: 149.866},
  {x: 159, y: 150.191},
  {x: 160, y: 150.503},
  {x: 161, y: 150.804},
  {x: 162, y: 151.094},
  {x: 163, y: 151.372},
  {x: 164, y: 151.638},
  {x: 165, y: 151.892},
  {x: 166, y: 152.136},
  {x: 167, y: 152.37},
  {x: 168, y: 152.593},
  {x: 169, y: 152.806},
  {x: 170, y: 153.008},
  {x: 171, y: 153.201},
  {x: 172, y: 153.385},
  {x: 173, y: 153.558},
  {x: 174, y: 153.724},
  {x: 175, y: 153.879},
  {x: 176, y: 154.028},
  {x: 177, y: 154.167},
  {x: 178, y: 154.298},
  {x: 179, y: 154.421},
  {x: 180, y: 154.54},
  {x: 181, y: 154.649},
  {x: 182, y: 154.752},
  {x: 183, y: 154.848},
  {x: 184, y: 154.939},
  {x: 185, y: 155.024},
  {x: 186, y: 155.104},
  {x: 187, y: 155.178},
  {x: 188, y: 155.248},
  {x: 189, y: 155.312},
  {x: 190, y: 155.372},
  {x: 191, y: 155.43},
  {x: 192, y: 155.482},
  {x: 193, y: 155.53},
  {x: 194, y: 155.576},
  {x: 195, y: 155.619},
  {x: 196, y: 155.66},
  {x: 197, y: 155.696},
  {x: 198, y: 155.733},
  {x: 199, y: 155.766},
  {x: 200, y: 155.8},
  {x: 201, y: 155.831},
  {x: 202, y: 155.862},
  {x: 203, y: 155.891},
  {x: 204, y: 155.919},
  {x: 205, y: 155.946},
  {x: 206, y: 155.973},
  {x: 207, y: 155.999},
  {x: 208, y: 156.025},
  {x: 209, y: 156.05},
  {x: 210, y: 156.074},
  {x: 211, y: 156.098},
  {x: 212, y: 156.121},
  {x: 213, y: 156.145},
  {x: 214, y: 156.166},
  {x: 215, y: 156.188},
  {x: 216, y: 156.21},
  {x: 217, y: 156.23},
  {x: 218, y: 156.249},
  {x: 219, y: 156.267},
  {x: 220, y: 156.285},
  {x: 221, y: 156.299},
  {x: 222, y: 156.314},
  {x: 223, y: 156.328},
  {x: 224, y: 156.339},
  {x: 225, y: 156.351},
  {x: 226, y: 156.36},
  {x: 227, y: 156.369},
  {x: 228, y: 156.376}
]
const heightGirlsFifthy = [
  {x: 0, y: 49.148},
  {x: 1, y: 53.757},
  {x: 2, y: 57.178},
  {x: 3, y: 59.94},
  {x: 4, y: 62.244},
  {x: 5, y: 64.196},
  {x: 6, y: 65.91},
  {x: 7, y: 67.481},
  {x: 8, y: 68.96},
  {x: 9, y: 70.37},
  {x: 10, y: 71.724},
  {x: 11, y: 73.027},
  {x: 12, y: 74.285},
  {x: 13, y: 75.501},
  {x: 14, y: 76.677},
  {x: 15, y: 77.817},
  {x: 16, y: 78.924},
  {x: 17, y: 80},
  {x: 18, y: 81.047},
  {x: 19, y: 82.067},
  {x: 20, y: 83.062},
  {x: 21, y: 84.032},
  {x: 22, y: 84.979},
  {x: 23, y: 85.903},
  {x: 24, y: 86.106},
  {x: 25, y: 86.988},
  {x: 26, y: 87.851},
  {x: 27, y: 88.693},
  {x: 29, y: 89.516},
  {x: 30, y: 90.32},
  {x: 31, y: 91.105},
  {x: 32, y: 91.873},
  {x: 33, y: 92.626},
  {x: 34, y: 93.365},
  {x: 35, y: 94.091},
  {x: 36, y: 94.806},
  {x: 37, y: 95.511},
  {x: 38, y: 96.205},
  {x: 39, y: 96.89},
  {x: 40, y: 97.566},
  {x: 41, y: 98.232},
  {x: 42, y: 98.89},
  {x: 43, y: 99.538},
  {x: 44, y: 100.178},
  {x: 45, y: 100.809},
  {x: 46, y: 101.432},
  {x: 47, y: 102.046},
  {x: 48, y: 102.653},
  {x: 49, y: 103.254},
  {x: 50, y: 103.847},
  {x: 51, y: 104.435},
  {x: 52, y: 105.017},
  {x: 53, y: 105.593},
  {x: 54, y: 106.163},
  {x: 55, y: 106.728},
  {x: 56, y: 107.288},
  {x: 57, y: 107.842},
  {x: 58, y: 108.39},
  {x: 59, y: 108.933},
  {x: 60, y: 109.471},
  {x: 61, y: 109.602},
  {x: 62, y: 110.126},
  {x: 63, y: 110.645},
  {x: 64, y: 111.16},
  {x: 65, y: 111.67},
  {x: 66, y: 112.175},
  {x: 67, y: 112.677},
  {x: 68, y: 113.174},
  {x: 69, y: 113.667},
  {x: 70, y: 114.156},
  {x: 71, y: 114.642},
  {x: 72, y: 115.124},
  {x: 73, y: 115.604},
  {x: 74, y: 116.081},
  {x: 75, y: 116.557},
  {x: 76, y: 117.031},
  {x: 77, y: 117.504},
  {x: 78, y: 117.977},
  {x: 79, y: 118.449},
  {x: 80, y: 118.921},
  {x: 81, y: 119.393},
  {x: 82, y: 119.865},
  {x: 83, y: 120.337},
  {x: 84, y: 120.81},
  {x: 85, y: 121.284},
  {x: 86, y: 121.759},
  {x: 87, y: 122.234},
  {x: 88, y: 122.71},
  {x: 89, y: 123.187},
  {x: 90, y: 123.665},
  {x: 91, y: 124.144},
  {x: 92, y: 124.623},
  {x: 93, y: 125.104},
  {x: 94, y: 125.587},
  {x: 95, y: 126.071},
  {x: 96, y: 126.556},
  {x: 97, y: 127.042},
  {x: 98, y: 127.53},
  {x: 99, y: 128.02},
  {x: 100, y: 128.511},
  {x: 101, y: 129.004},
  {x: 102, y: 129.498},
  {x: 103, y: 129.993},
  {x: 104, y: 130.49},
  {x: 105, y: 130.989},
  {x: 106, y: 131.49},
  {x: 107, y: 131.991},
  {x: 108, y: 132.494},
  {x: 109, y: 132.999},
  {x: 110, y: 133.505},
  {x: 111, y: 134.012},
  {x: 112, y: 134.52},
  {x: 113, y: 135.03},
  {x: 114, y: 135.541},
  {x: 115, y: 136.053},
  {x: 116, y: 136.567},
  {x: 117, y: 137.082},
  {x: 118, y: 137.599},
  {x: 119, y: 138.117},
  {x: 120, y: 138.636},
  {x: 121, y: 139.158},
  {x: 122, y: 139.68},
  {x: 123, y: 140.205},
  {x: 124, y: 140.731},
  {x: 125, y: 141.259},
  {x: 126, y: 141.789},
  {x: 127, y: 142.321},
  {x: 128, y: 142.853},
  {x: 129, y: 143.387},
  {x: 130, y: 143.922},
  {x: 131, y: 144.458},
  {x: 132, y: 144.993},
  {x: 133, y: 145.528},
  {x: 134, y: 146.062},
  {x: 135, y: 146.595},
  {x: 136, y: 147.126},
  {x: 137, y: 147.655},
  {x: 138, y: 148.18},
  {x: 139, y: 148.702},
  {x: 140, y: 149.22},
  {x: 141, y: 149.732},
  {x: 142, y: 150.239},
  {x: 143, y: 150.739},
  {x: 144, y: 151.233},
  {x: 145, y: 151.718},
  {x: 146, y: 152.195},
  {x: 147, y: 152.663},
  {x: 148, y: 153.121},
  {x: 149, y: 153.568},
  {x: 150, y: 154.004},
  {x: 151, y: 154.429},
  {x: 152, y: 154.842},
  {x: 153, y: 155.244},
  {x: 154, y: 155.633},
  {x: 155, y: 156.01},
  {x: 156, y: 156.375},
  {x: 157, y: 156.727},
  {x: 158, y: 157.067},
  {x: 159, y: 157.394},
  {x: 160, y: 157.708},
  {x: 161, y: 158.01},
  {x: 162, y: 158.3},
  {x: 163, y: 158.577},
  {x: 164, y: 158.842},
  {x: 165, y: 159.096},
  {x: 166, y: 159.338},
  {x: 167, y: 159.569},
  {x: 168, y: 159.789},
  {x: 169, y: 159.998},
  {x: 170, y: 160.197},
  {x: 171, y: 160.386},
  {x: 172, y: 160.564},
  {x: 173, y: 160.733},
  {x: 174, y: 160.893},
  {x: 175, y: 161.043},
  {x: 176, y: 161.184},
  {x: 177, y: 161.318},
  {x: 178, y: 161.442},
  {x: 179, y: 161.56},
  {x: 180, y: 161.669},
  {x: 181, y: 161.772},
  {x: 182, y: 161.867},
  {x: 183, y: 161.956},
  {x: 184, y: 162.039},
  {x: 185, y: 162.116},
  {x: 186, y: 162.188},
  {x: 187, y: 162.254},
  {x: 188, y: 162.315},
  {x: 189, y: 162.372},
  {x: 190, y: 162.424},
  {x: 191, y: 162.472},
  {x: 192, y: 162.516},
  {x: 193, y: 162.556},
  {x: 194, y: 162.593},
  {x: 195, y: 162.628},
  {x: 196, y: 162.659},
  {x: 197, y: 162.689},
  {x: 198, y: 162.716},
  {x: 199, y: 162.742},
  {x: 200, y: 162.767},
  {x: 201, y: 162.79},
  {x: 202, y: 162.813},
  {x: 203, y: 162.834},
  {x: 204, y: 162.854},
  {x: 205, y: 162.874},
  {x: 206, y: 162.894},
  {x: 207, y: 162.912},
  {x: 208, y: 162.93},
  {x: 209, y: 162.948},
  {x: 210, y: 162.965},
  {x: 211, y: 162.982},
  {x: 212, y: 162.998},
  {x: 213, y: 163.014},
  {x: 214, y: 163.03},
  {x: 215, y: 163.045},
  {x: 216, y: 163.06},
  {x: 217, y: 163.073},
  {x: 218, y: 163.086},
  {x: 219, y: 163.098},
  {x: 220, y: 163.109},
  {x: 221, y: 163.119},
  {x: 222, y: 163.128},
  {x: 223, y: 163.136},
  {x: 224, y: 163.142},
  {x: 225, y: 163.147},
  {x: 226, y: 163.151},
  {x: 227, y: 163.153},
  {x: 228, y: 163.155}
]
const heightGirlsEightyFive = [
  {x: 0, y: 51.078},
  {x: 1, y: 55.784},
  {x: 2, y: 59.291},
  {x: 3, y: 62.125},
  {x: 4, y: 64.492},
  {x: 5, y: 66.498},
  {x: 6, y: 68.264},
  {x: 7, y: 69.887},
  {x: 8, y: 71.418},
  {x: 9, y: 72.882},
  {x: 10, y: 74.291},
  {x: 11, y: 75.652},
  {x: 12, y: 76.967},
  {x: 13, y: 78.24},
  {x: 14, y: 79.473},
  {x: 15, y: 80.672},
  {x: 16, y: 81.836},
  {x: 17, y: 82.971},
  {x: 18, y: 84.075},
  {x: 19, y: 85.153},
  {x: 20, y: 86.205},
  {x: 21, y: 87.232},
  {x: 22, y: 88.236},
  {x: 23, y: 89.216},
  {x: 24, y: 89.474},
  {x: 25, y: 90.411},
  {x: 26, y: 91.328},
  {x: 27, y: 92.224},
  {x: 29, y: 93.099},
  {x: 30, y: 93.955},
  {x: 31, y: 94.791},
  {x: 32, y: 95.61},
  {x: 33, y: 96.412},
  {x: 34, y: 97.2},
  {x: 35, y: 97.974},
  {x: 36, y: 98.736},
  {x: 37, y: 99.488},
  {x: 38, y: 100.228},
  {x: 39, y: 100.959},
  {x: 40, y: 101.68},
  {x: 41, y: 102.391},
  {x: 42, y: 103.093},
  {x: 43, y: 103.785},
  {x: 44, y: 104.468},
  {x: 45, y: 105.142},
  {x: 46, y: 105.807},
  {x: 47, y: 106.463},
  {x: 48, y: 107.112},
  {x: 49, y: 107.754},
  {x: 50, y: 108.388},
  {x: 51, y: 109.016},
  {x: 52, y: 109.638},
  {x: 53, y: 110.254},
  {x: 54, y: 110.864},
  {x: 55, y: 111.468},
  {x: 56, y: 112.067},
  {x: 57, y: 112.659},
  {x: 58, y: 113.246},
  {x: 59, y: 113.827},
  {x: 60, y: 114.404},
  {x: 61, y: 114.549},
  {x: 62, y: 115.107},
  {x: 63, y: 115.66},
  {x: 64, y: 116.208},
  {x: 65, y: 116.751},
  {x: 66, y: 117.29},
  {x: 67, y: 117.823},
  {x: 68, y: 118.353},
  {x: 69, y: 118.878},
  {x: 70, y: 119.399},
  {x: 71, y: 119.916},
  {x: 72, y: 120.431},
  {x: 73, y: 120.94},
  {x: 74, y: 121.448},
  {x: 75, y: 121.956},
  {x: 76, y: 122.459},
  {x: 77, y: 122.963},
  {x: 78, y: 123.466},
  {x: 79, y: 123.967},
  {x: 80, y: 124.47},
  {x: 81, y: 124.971},
  {x: 82, y: 125.473},
  {x: 83, y: 125.975},
  {x: 84, y: 126.476},
  {x: 85, y: 126.98},
  {x: 86, y: 127.483},
  {x: 87, y: 127.988},
  {x: 88, y: 128.493},
  {x: 89, y: 128.997},
  {x: 90, y: 129.504},
  {x: 91, y: 130.012},
  {x: 92, y: 130.52},
  {x: 93, y: 131.029},
  {x: 94, y: 131.539},
  {x: 95, y: 132.051},
  {x: 96, y: 132.565},
  {x: 97, y: 133.08},
  {x: 98, y: 133.595},
  {x: 99, y: 134.111},
  {x: 100, y: 134.63},
  {x: 101, y: 135.15},
  {x: 102, y: 135.671},
  {x: 103, y: 136.193},
  {x: 104, y: 136.717},
  {x: 105, y: 137.244},
  {x: 106, y: 137.769},
  {x: 107, y: 138.298},
  {x: 108, y: 138.828},
  {x: 109, y: 139.358},
  {x: 110, y: 139.889},
  {x: 111, y: 140.422},
  {x: 112, y: 140.956},
  {x: 113, y: 141.49},
  {x: 114, y: 142.027},
  {x: 115, y: 142.564},
  {x: 116, y: 143.101},
  {x: 117, y: 143.64},
  {x: 118, y: 144.182},
  {x: 119, y: 144.723},
  {x: 120, y: 145.266},
  {x: 121, y: 145.809},
  {x: 122, y: 146.356},
  {x: 123, y: 146.902},
  {x: 124, y: 147.451},
  {x: 125, y: 148.001},
  {x: 126, y: 148.554},
  {x: 127, y: 149.106},
  {x: 128, y: 149.66},
  {x: 129, y: 150.215},
  {x: 130, y: 150.77},
  {x: 131, y: 151.327},
  {x: 132, y: 151.882},
  {x: 133, y: 152.436},
  {x: 134, y: 152.99},
  {x: 135, y: 153.54},
  {x: 136, y: 154.09},
  {x: 137, y: 154.636},
  {x: 138, y: 155.179},
  {x: 139, y: 155.718},
  {x: 140, y: 156.25},
  {x: 141, y: 156.779},
  {x: 142, y: 157.301},
  {x: 143, y: 157.815},
  {x: 144, y: 158.322},
  {x: 145, y: 158.819},
  {x: 146, y: 159.309},
  {x: 147, y: 159.788},
  {x: 148, y: 160.257},
  {x: 149, y: 160.714},
  {x: 150, y: 161.16},
  {x: 151, y: 161.593},
  {x: 152, y: 162.013},
  {x: 153, y: 162.421},
  {x: 154, y: 162.817},
  {x: 155, y: 163.199},
  {x: 156, y: 163.569},
  {x: 157, y: 163.924},
  {x: 158, y: 164.267},
  {x: 159, y: 164.596},
  {x: 160, y: 164.913},
  {x: 161, y: 165.216},
  {x: 162, y: 165.506},
  {x: 163, y: 165.782},
  {x: 164, y: 166.047},
  {x: 165, y: 166.3},
  {x: 166, y: 166.54},
  {x: 167, y: 166.768},
  {x: 168, y: 166.985},
  {x: 169, y: 167.19},
  {x: 170, y: 167.386},
  {x: 171, y: 167.57},
  {x: 172, y: 167.743},
  {x: 173, y: 167.908},
  {x: 174, y: 168.061},
  {x: 175, y: 168.207},
  {x: 176, y: 168.341},
  {x: 177, y: 168.469},
  {x: 178, y: 168.587},
  {x: 179, y: 168.698},
  {x: 180, y: 168.799},
  {x: 181, y: 168.894},
  {x: 182, y: 168.982},
  {x: 183, y: 169.065},
  {x: 184, y: 169.14},
  {x: 185, y: 169.209},
  {x: 186, y: 169.272},
  {x: 187, y: 169.331},
  {x: 188, y: 169.383},
  {x: 189, y: 169.432},
  {x: 190, y: 169.476},
  {x: 191, y: 169.514},
  {x: 192, y: 169.55},
  {x: 193, y: 169.582},
  {x: 194, y: 169.61},
  {x: 195, y: 169.636},
  {x: 196, y: 169.659},
  {x: 197, y: 169.682},
  {x: 198, y: 169.7},
  {x: 199, y: 169.719},
  {x: 200, y: 169.734},
  {x: 201, y: 169.75},
  {x: 202, y: 169.763},
  {x: 203, y: 169.777},
  {x: 204, y: 169.79},
  {x: 205, y: 169.802},
  {x: 206, y: 169.814},
  {x: 207, y: 169.825},
  {x: 208, y: 169.835},
  {x: 209, y: 169.845},
  {x: 210, y: 169.856},
  {x: 211, y: 169.865},
  {x: 212, y: 169.876},
  {x: 213, y: 169.884},
  {x: 214, y: 169.894},
  {x: 215, y: 169.903},
  {x: 216, y: 169.909},
  {x: 217, y: 169.917},
  {x: 218, y: 169.923},
  {x: 219, y: 169.929},
  {x: 220, y: 169.934},
  {x: 221, y: 169.939},
  {x: 222, y: 169.941},
  {x: 223, y: 169.943},
  {x: 224, y: 169.944},
  {x: 225, y: 169.943},
  {x: 226, y: 169.942},
  {x: 227, y: 169.938},
  {x: 228, y: 169.934}
]
const heightGirlsNintySeven = [
  {x: 0, y: 52.651},
  {x: 1, y: 57.435},
  {x: 2, y: 61.013},
  {x: 3, y: 63.905},
  {x: 4, y: 66.323},
  {x: 5, y: 68.374},
  {x: 6, y: 70.182},
  {x: 7, y: 71.847},
  {x: 8, y: 73.421},
  {x: 9, y: 74.929},
  {x: 10, y: 76.383},
  {x: 11, y: 77.789},
  {x: 12, y: 79.151},
  {x: 13, y: 80.471},
  {x: 14, y: 81.752},
  {x: 15, y: 82.998},
  {x: 16, y: 84.21},
  {x: 17, y: 85.391},
  {x: 18, y: 86.542},
  {x: 19, y: 87.667},
  {x: 20, y: 88.765},
  {x: 21, y: 89.839},
  {x: 22, y: 90.89},
  {x: 23, y: 91.915},
  {x: 24, y: 92.218},
  {x: 25, y: 93.199},
  {x: 26, y: 94.161},
  {x: 27, y: 95.101},
  {x: 29, y: 96.018},
  {x: 30, y: 96.916},
  {x: 31, y: 97.794},
  {x: 32, y: 98.654},
  {x: 33, y: 99.497},
  {x: 34, y: 100.324},
  {x: 35, y: 101.138},
  {x: 36, y: 101.938},
  {x: 37, y: 102.728},
  {x: 38, y: 103.506},
  {x: 39, y: 104.274},
  {x: 40, y: 105.032},
  {x: 41, y: 105.779},
  {x: 42, y: 106.517},
  {x: 43, y: 107.246},
  {x: 44, y: 107.963},
  {x: 45, y: 108.672},
  {x: 46, y: 109.371},
  {x: 47, y: 110.061},
  {x: 48, y: 110.745},
  {x: 49, y: 111.42},
  {x: 50, y: 112.088},
  {x: 51, y: 112.748},
  {x: 52, y: 113.403},
  {x: 53, y: 114.051},
  {x: 54, y: 114.693},
  {x: 55, y: 115.33},
  {x: 56, y: 115.961},
  {x: 57, y: 116.583},
  {x: 58, y: 117.203},
  {x: 59, y: 117.814},
  {x: 60, y: 118.423},
  {x: 61, y: 118.579},
  {x: 62, y: 119.165},
  {x: 63, y: 119.745},
  {x: 64, y: 120.321},
  {x: 65, y: 120.89},
  {x: 66, y: 121.456},
  {x: 67, y: 122.016},
  {x: 68, y: 122.572},
  {x: 69, y: 123.123},
  {x: 70, y: 123.67},
  {x: 71, y: 124.213},
  {x: 72, y: 124.753},
  {x: 73, y: 125.288},
  {x: 74, y: 125.821},
  {x: 75, y: 126.354},
  {x: 76, y: 126.881},
  {x: 77, y: 127.41},
  {x: 78, y: 127.938},
  {x: 79, y: 128.463},
  {x: 80, y: 128.99},
  {x: 81, y: 129.515},
  {x: 82, y: 130.041},
  {x: 83, y: 130.568},
  {x: 84, y: 131.092},
  {x: 85, y: 131.62},
  {x: 86, y: 132.146},
  {x: 87, y: 132.676},
  {x: 88, y: 133.204},
  {x: 89, y: 133.731},
  {x: 90, y: 134.261},
  {x: 91, y: 134.793},
  {x: 92, y: 135.323},
  {x: 93, y: 135.855},
  {x: 94, y: 136.388},
  {x: 95, y: 136.923},
  {x: 96, y: 137.46},
  {x: 97, y: 137.998},
  {x: 98, y: 138.535},
  {x: 99, y: 139.074},
  {x: 100, y: 139.615},
  {x: 101, y: 140.157},
  {x: 102, y: 140.701},
  {x: 103, y: 141.245},
  {x: 104, y: 141.79},
  {x: 105, y: 142.339},
  {x: 106, y: 142.885},
  {x: 107, y: 143.435},
  {x: 108, y: 143.987},
  {x: 109, y: 144.538},
  {x: 110, y: 145.09},
  {x: 111, y: 145.644},
  {x: 112, y: 146.199},
  {x: 113, y: 146.753},
  {x: 114, y: 147.311},
  {x: 115, y: 147.868},
  {x: 116, y: 148.423},
  {x: 117, y: 148.983},
  {x: 118, y: 149.545},
  {x: 119, y: 150.105},
  {x: 120, y: 150.667},
  {x: 121, y: 151.228},
  {x: 122, y: 151.794},
  {x: 123, y: 152.359},
  {x: 124, y: 152.925},
  {x: 125, y: 153.494},
  {x: 126, y: 154.064},
  {x: 127, y: 154.634},
  {x: 128, y: 155.205},
  {x: 129, y: 155.777},
  {x: 130, y: 156.349},
  {x: 131, y: 156.923},
  {x: 132, y: 157.494},
  {x: 133, y: 158.064},
  {x: 134, y: 158.633},
  {x: 135, y: 159.198},
  {x: 136, y: 159.764},
  {x: 137, y: 160.324},
  {x: 138, y: 160.881},
  {x: 139, y: 161.433},
  {x: 140, y: 161.978},
  {x: 141, y: 162.52},
  {x: 142, y: 163.053},
  {x: 143, y: 163.58},
  {x: 144, y: 164.098},
  {x: 145, y: 164.605},
  {x: 146, y: 165.105},
  {x: 147, y: 165.592},
  {x: 148, y: 166.071},
  {x: 149, y: 166.536},
  {x: 150, y: 166.989},
  {x: 151, y: 167.43},
  {x: 152, y: 167.854},
  {x: 153, y: 168.269},
  {x: 154, y: 168.67},
  {x: 155, y: 169.056},
  {x: 156, y: 169.43},
  {x: 157, y: 169.788},
  {x: 158, y: 170.133},
  {x: 159, y: 170.463},
  {x: 160, y: 170.783},
  {x: 161, y: 171.086},
  {x: 162, y: 171.376},
  {x: 163, y: 171.652},
  {x: 164, y: 171.916},
  {x: 165, y: 172.169},
  {x: 166, y: 172.407},
  {x: 167, y: 172.633},
  {x: 168, y: 172.847},
  {x: 169, y: 173.049},
  {x: 170, y: 173.243},
  {x: 171, y: 173.423},
  {x: 172, y: 173.592},
  {x: 173, y: 173.754},
  {x: 174, y: 173.902},
  {x: 175, y: 174.043},
  {x: 176, y: 174.172},
  {x: 177, y: 174.294},
  {x: 178, y: 174.408},
  {x: 179, y: 174.513},
  {x: 180, y: 174.607},
  {x: 181, y: 174.697},
  {x: 182, y: 174.779},
  {x: 183, y: 174.856},
  {x: 184, y: 174.925},
  {x: 185, y: 174.987},
  {x: 186, y: 175.042},
  {x: 187, y: 175.096},
  {x: 188, y: 175.14},
  {x: 189, y: 175.183},
  {x: 190, y: 175.221},
  {x: 191, y: 175.251},
  {x: 192, y: 175.28},
  {x: 193, y: 175.305},
  {x: 194, y: 175.327},
  {x: 195, y: 175.346},
  {x: 196, y: 175.362},
  {x: 197, y: 175.378},
  {x: 198, y: 175.389},
  {x: 199, y: 175.402},
  {x: 200, y: 175.41},
  {x: 201, y: 175.42},
  {x: 202, y: 175.426},
  {x: 203, y: 175.433},
  {x: 204, y: 175.44},
  {x: 205, y: 175.446},
  {x: 206, y: 175.452},
  {x: 207, y: 175.456},
  {x: 208, y: 175.46},
  {x: 209, y: 175.464},
  {x: 210, y: 175.47},
  {x: 211, y: 175.473},
  {x: 212, y: 175.479},
  {x: 213, y: 175.481},
  {x: 214, y: 175.485},
  {x: 215, y: 175.489},
  {x: 216, y: 175.489},
  {x: 217, y: 175.492},
  {x: 218, y: 175.493},
  {x: 219, y: 175.494},
  {x: 220, y: 175.494},
  {x: 221, y: 175.495},
  {x: 222, y: 175.492},
  {x: 223, y: 175.488},
  {x: 224, y: 175.486},
  {x: 225, y: 175.479},
  {x: 226, y: 175.474},
  {x: 227, y: 175.465},
  {x: 228, y: 175.457}
]

// Weight

    // Boys
const weightBoysThree = [
  {x: 0, y: 2.507},
  {x: 1, y: 3.469},
  {x: 2, y: 4.416},
  {x: 3, y: 5.126},
  {x: 4, y: 5.675},
  {x: 5, y: 6.115},
  {x: 6, y: 6.475},
  {x: 7, y: 6.779},
  {x: 8, y: 7.042},
  {x: 9, y: 7.277},
  {x: 10, y: 7.492},
  {x: 11, y: 7.694},
  {x: 12, y: 7.886},
  {x: 13, y: 8.07},
  {x: 14, y: 8.249},
  {x: 15, y: 8.422},
  {x: 16, y: 8.592},
  {x: 17, y: 8.759},
  {x: 18, y: 8.923},
  {x: 19, y: 9.085},
  {x: 20, y: 9.245},
  {x: 21, y: 9.404},
  {x: 22, y: 9.561},
  {x: 23, y: 9.717},
  {x: 24, y: 9.872},
  {x: 25, y: 10.024},
  {x: 26, y: 10.174},
  {x: 27, y: 10.321},
  {x: 29, y: 10.464},
  {x: 30, y: 10.605},
  {x: 31, y: 10.742},
  {x: 32, y: 10.877},
  {x: 33, y: 11.009},
  {x: 34, y: 11.14},
  {x: 35, y: 11.269},
  {x: 36, y: 11.396},
  {x: 37, y: 11.523},
  {x: 38, y: 11.649},
  {x: 39, y: 11.775},
  {x: 40, y: 11.901},
  {x: 41, y: 12.026},
  {x: 42, y: 12.151},
  {x: 43, y: 12.275},
  {x: 44, y: 12.399},
  {x: 45, y: 12.522},
  {x: 46, y: 12.644},
  {x: 47, y: 12.766},
  {x: 48, y: 12.887},
  {x: 49, y: 13.007},
  {x: 50, y: 13.126},
  {x: 51, y: 13.246},
  {x: 52, y: 13.364},
  {x: 53, y: 13.483},
  {x: 54, y: 13.601},
  {x: 55, y: 13.718},
  {x: 56, y: 13.835},
  {x: 57, y: 13.952},
  {x: 58, y: 14.067},
  {x: 59, y: 14.183},
  {x: 60, y: 14.298},
  {x: 61, y: 14.58},
  {x: 62, y: 14.711},
  {x: 63, y: 14.844},
  {x: 64, y: 14.978},
  {x: 65, y: 15.114},
  {x: 66, y: 15.251},
  {x: 67, y: 15.389},
  {x: 68, y: 15.53},
  {x: 69, y: 15.672},
  {x: 70, y: 15.815},
  {x: 71, y: 15.959},
  {x: 72, y: 16.105},
  {x: 73, y: 16.252},
  {x: 74, y: 16.4},
  {x: 75, y: 16.548},
  {x: 76, y: 16.697},
  {x: 77, y: 16.848},
  {x: 78, y: 16.999},
  {x: 79, y: 17.15},
  {x: 80, y: 17.303},
  {x: 81, y: 17.455},
  {x: 82, y: 17.609},
  {x: 83, y: 17.762},
  {x: 84, y: 17.916},
  {x: 85, y: 18.07},
  {x: 86, y: 18.224},
  {x: 87, y: 18.378},
  {x: 88, y: 18.532},
  {x: 89, y: 18.686},
  {x: 90, y: 18.841},
  {x: 91, y: 18.995},
  {x: 92, y: 19.148},
  {x: 93, y: 19.302},
  {x: 94, y: 19.456},
  {x: 95, y: 19.609},
  {x: 96, y: 19.763},
  {x: 97, y: 19.916},
  {x: 98, y: 20.069},
  {x: 99, y: 20.222},
  {x: 100, y: 20.375},
  {x: 101, y: 20.528},
  {x: 102, y: 20.681},
  {x: 103, y: 20.833},
  {x: 104, y: 20.986},
  {x: 105, y: 21.14},
  {x: 106, y: 21.293},
  {x: 107, y: 21.448},
  {x: 108, y: 21.603},
  {x: 109, y: 21.759},
  {x: 110, y: 21.917},
  {x: 111, y: 22.076},
  {x: 112, y: 22.236},
  {x: 113, y: 22.398},
  {x: 114, y: 22.561},
  {x: 115, y: 22.727},
  {x: 116, y: 22.894},
  {x: 117, y: 23.063},
  {x: 118, y: 23.234},
  {x: 119, y: 23.406},
  {x: 120, y: 23.581}
]
const weightBoysFiftheen = [
  {x: 0, y: 2.865},
  {x: 1, y: 3.904},
  {x: 2, y: 4.92},
  {x: 3, y: 5.675},
  {x: 4, y: 6.259},
  {x: 5, y: 6.728},
  {x: 6, y: 7.115},
  {x: 7, y: 7.444},
  {x: 8, y: 7.731},
  {x: 9, y: 7.988},
  {x: 10, y: 8.224},
  {x: 11, y: 8.446},
  {x: 12, y: 8.657},
  {x: 13, y: 8.86},
  {x: 14, y: 9.056},
  {x: 15, y: 9.249},
  {x: 16, y: 9.437},
  {x: 17, y: 9.623},
  {x: 18, y: 9.806},
  {x: 19, y: 9.987},
  {x: 20, y: 10.166},
  {x: 21, y: 10.344},
  {x: 22, y: 10.521},
  {x: 23, y: 10.697},
  {x: 24, y: 10.871},
  {x: 25, y: 11.044},
  {x: 26, y: 11.213},
  {x: 27, y: 11.38},
  {x: 29, y: 11.543},
  {x: 30, y: 11.703},
  {x: 31, y: 11.86},
  {x: 32, y: 12.014},
  {x: 33, y: 12.165},
  {x: 34, y: 12.314},
  {x: 35, y: 12.461},
  {x: 36, y: 12.607},
  {x: 37, y: 12.752},
  {x: 38, y: 12.896},
  {x: 39, y: 13.04},
  {x: 40, y: 13.184},
  {x: 41, y: 13.327},
  {x: 42, y: 13.47},
  {x: 43, y: 13.613},
  {x: 44, y: 13.756},
  {x: 45, y: 13.897},
  {x: 46, y: 14.039},
  {x: 47, y: 14.179},
  {x: 48, y: 14.32},
  {x: 49, y: 14.46},
  {x: 50, y: 14.599},
  {x: 51, y: 14.738},
  {x: 52, y: 14.877},
  {x: 53, y: 15.015},
  {x: 54, y: 15.154},
  {x: 55, y: 15.292},
  {x: 56, y: 15.429},
  {x: 57, y: 15.566},
  {x: 58, y: 15.703},
  {x: 59, y: 15.839},
  {x: 60, y: 15.975},
  {x: 61, y: 16.204},
  {x: 62, y: 16.352},
  {x: 63, y: 16.501},
  {x: 64, y: 16.652},
  {x: 65, y: 16.804},
  {x: 66, y: 16.957},
  {x: 67, y: 17.113},
  {x: 68, y: 17.27},
  {x: 69, y: 17.428},
  {x: 70, y: 17.588},
  {x: 71, y: 17.749},
  {x: 72, y: 17.912},
  {x: 73, y: 18.076},
  {x: 74, y: 18.24},
  {x: 75, y: 18.406},
  {x: 76, y: 18.572},
  {x: 77, y: 18.739},
  {x: 78, y: 18.908},
  {x: 79, y: 19.077},
  {x: 80, y: 19.247},
  {x: 81, y: 19.418},
  {x: 82, y: 19.59},
  {x: 83, y: 19.762},
  {x: 84, y: 19.935},
  {x: 85, y: 20.108},
  {x: 86, y: 20.281},
  {x: 87, y: 20.455},
  {x: 88, y: 20.629},
  {x: 89, y: 20.803},
  {x: 90, y: 20.978},
  {x: 91, y: 21.153},
  {x: 92, y: 21.328},
  {x: 93, y: 21.504},
  {x: 94, y: 21.679},
  {x: 95, y: 21.855},
  {x: 96, y: 22.031},
  {x: 97, y: 22.208},
  {x: 98, y: 22.385},
  {x: 99, y: 22.562},
  {x: 100, y: 22.74},
  {x: 101, y: 22.918},
  {x: 102, y: 23.096},
  {x: 103, y: 23.275},
  {x: 104, y: 23.454},
  {x: 105, y: 23.635},
  {x: 106, y: 23.816},
  {x: 107, y: 23.998},
  {x: 108, y: 24.182},
  {x: 109, y: 24.368},
  {x: 110, y: 24.555},
  {x: 111, y: 24.744},
  {x: 112, y: 24.936},
  {x: 113, y: 25.129},
  {x: 114, y: 25.325},
  {x: 115, y: 25.523},
  {x: 116, y: 25.724},
  {x: 117, y: 25.927},
  {x: 118, y: 26.133},
  {x: 119, y: 26.341},
  {x: 120, y: 26.551}
]
const weightBoysFifthy = [
  {x: 0, y: 3.346},
  {x: 1, y: 4.495},
  {x: 2, y: 5.602},
  {x: 3, y: 6.415},
  {x: 4, y: 7.043},
  {x: 5, y: 7.553},
  {x: 6, y: 7.977},
  {x: 7, y: 8.34},
  {x: 8, y: 8.659},
  {x: 9, y: 8.947},
  {x: 10, y: 9.212},
  {x: 11, y: 9.461},
  {x: 12, y: 9.699},
  {x: 13, y: 9.928},
  {x: 14, y: 10.152},
  {x: 15, y: 10.37},
  {x: 16, y: 10.585},
  {x: 17, y: 10.797},
  {x: 18, y: 11.007},
  {x: 19, y: 11.214},
  {x: 20, y: 11.421},
  {x: 21, y: 11.627},
  {x: 22, y: 11.832},
  {x: 23, y: 12.037},
  {x: 24, y: 12.24},
  {x: 25, y: 12.441},
  {x: 26, y: 12.64},
  {x: 27, y: 12.836},
  {x: 29, y: 13.027},
  {x: 30, y: 13.216},
  {x: 31, y: 13.4},
  {x: 32, y: 13.582},
  {x: 33, y: 13.76},
  {x: 34, y: 13.936},
  {x: 35, y: 14.11},
  {x: 36, y: 14.283},
  {x: 37, y: 14.455},
  {x: 38, y: 14.626},
  {x: 39, y: 14.797},
  {x: 40, y: 14.967},
  {x: 41, y: 15.138},
  {x: 42, y: 15.308},
  {x: 43, y: 15.478},
  {x: 44, y: 15.649},
  {x: 45, y: 15.819},
  {x: 46, y: 15.988},
  {x: 47, y: 16.158},
  {x: 48, y: 16.327},
  {x: 49, y: 16.496},
  {x: 50, y: 16.665},
  {x: 51, y: 16.835},
  {x: 52, y: 17.004},
  {x: 53, y: 17.173},
  {x: 54, y: 17.342},
  {x: 55, y: 17.511},
  {x: 56, y: 17.68},
  {x: 57, y: 17.848},
  {x: 58, y: 18.016},
  {x: 59, y: 18.184},
  {x: 60, y: 18.351},
  {x: 61, y: 18.506},
  {x: 62, y: 18.68},
  {x: 63, y: 18.856},
  {x: 64, y: 19.034},
  {x: 65, y: 19.213},
  {x: 66, y: 19.394},
  {x: 67, y: 19.576},
  {x: 68, y: 19.761},
  {x: 69, y: 19.947},
  {x: 70, y: 20.134},
  {x: 71, y: 20.324},
  {x: 72, y: 20.514},
  {x: 73, y: 20.705},
  {x: 74, y: 20.898},
  {x: 75, y: 21.092},
  {x: 76, y: 21.287},
  {x: 77, y: 21.483},
  {x: 78, y: 21.681},
  {x: 79, y: 21.88},
  {x: 80, y: 22.08},
  {x: 81, y: 22.281},
  {x: 82, y: 22.484},
  {x: 83, y: 22.687},
  {x: 84, y: 22.892},
  {x: 85, y: 23.097},
  {x: 86, y: 23.303},
  {x: 87, y: 23.51},
  {x: 88, y: 23.718},
  {x: 89, y: 23.927},
  {x: 90, y: 24.137},
  {x: 91, y: 24.348},
  {x: 92, y: 24.56},
  {x: 93, y: 24.772},
  {x: 94, y: 24.986},
  {x: 95, y: 25.2},
  {x: 96, y: 25.416},
  {x: 97, y: 25.633},
  {x: 98, y: 25.851},
  {x: 99, y: 26.071},
  {x: 100, y: 26.291},
  {x: 101, y: 26.513},
  {x: 102, y: 26.736},
  {x: 103, y: 26.96},
  {x: 104, y: 27.186},
  {x: 105, y: 27.414},
  {x: 106, y: 27.643},
  {x: 107, y: 27.875},
  {x: 108, y: 28.109},
  {x: 109, y: 28.346},
  {x: 110, y: 28.585},
  {x: 111, y: 28.828},
  {x: 112, y: 29.073},
  {x: 113, y: 29.322},
  {x: 114, y: 29.574},
  {x: 115, y: 29.829},
  {x: 116, y: 30.088},
  {x: 117, y: 30.35},
  {x: 118, y: 30.616},
  {x: 119, y: 30.885},
  {x: 120, y: 31.159}
]
const weightBoysEightyFive = [
  {x: 0, y: 3.878},
  {x: 1, y: 5.152},
  {x: 2, y: 6.357},
  {x: 3, y: 7.233},
  {x: 4, y: 7.91},
  {x: 5, y: 8.463},
  {x: 6, y: 8.929},
  {x: 7, y: 9.331},
  {x: 8, y: 9.687},
  {x: 9, y: 10.009},
  {x: 10, y: 10.307},
  {x: 11, y: 10.589},
  {x: 12, y: 10.858},
  {x: 13, y: 11.118},
  {x: 14, y: 11.372},
  {x: 15, y: 11.621},
  {x: 16, y: 11.867},
  {x: 17, y: 12.11},
  {x: 18, y: 12.351},
  {x: 19, y: 12.591},
  {x: 20, y: 12.83},
  {x: 21, y: 13.069},
  {x: 22, y: 13.308},
  {x: 23, y: 13.546},
  {x: 24, y: 13.784},
  {x: 25, y: 14.02},
  {x: 26, y: 14.254},
  {x: 27, y: 14.484},
  {x: 29, y: 14.71},
  {x: 30, y: 14.932},
  {x: 31, y: 15.151},
  {x: 32, y: 15.366},
  {x: 33, y: 15.578},
  {x: 34, y: 15.787},
  {x: 35, y: 15.994},
  {x: 36, y: 16.2},
  {x: 37, y: 16.404},
  {x: 38, y: 16.608},
  {x: 39, y: 16.812},
  {x: 40, y: 17.015},
  {x: 41, y: 17.219},
  {x: 42, y: 17.423},
  {x: 43, y: 17.627},
  {x: 44, y: 17.832},
  {x: 45, y: 18.037},
  {x: 46, y: 18.241},
  {x: 47, y: 18.447},
  {x: 48, y: 18.652},
  {x: 49, y: 18.858},
  {x: 50, y: 19.065},
  {x: 51, y: 19.272},
  {x: 52, y: 19.479},
  {x: 53, y: 19.687},
  {x: 54, y: 19.895},
  {x: 55, y: 20.103},
  {x: 56, y: 20.311},
  {x: 57, y: 20.52},
  {x: 58, y: 20.728},
  {x: 59, y: 20.936},
  {x: 60, y: 21.144},
  {x: 61, y: 21.212},
  {x: 62, y: 21.423},
  {x: 63, y: 21.636},
  {x: 64, y: 21.851},
  {x: 65, y: 22.068},
  {x: 66, y: 22.286},
  {x: 67, y: 22.507},
  {x: 68, y: 22.729},
  {x: 69, y: 22.954},
  {x: 70, y: 23.18},
  {x: 71, y: 23.408},
  {x: 72, y: 23.637},
  {x: 73, y: 23.868},
  {x: 74, y: 24.101},
  {x: 75, y: 24.335},
  {x: 76, y: 24.571},
  {x: 77, y: 24.809},
  {x: 78, y: 25.048},
  {x: 79, y: 25.29},
  {x: 80, y: 25.533},
  {x: 81, y: 25.778},
  {x: 82, y: 26.025},
  {x: 83, y: 26.273},
  {x: 84, y: 26.524},
  {x: 85, y: 26.776},
  {x: 86, y: 27.03},
  {x: 87, y: 27.286},
  {x: 88, y: 27.543},
  {x: 89, y: 27.803},
  {x: 90, y: 28.065},
  {x: 91, y: 28.328},
  {x: 92, y: 28.594},
  {x: 93, y: 28.862},
  {x: 94, y: 29.132},
  {x: 95, y: 29.405},
  {x: 96, y: 29.68},
  {x: 97, y: 29.957},
  {x: 98, y: 30.238},
  {x: 99, y: 30.52},
  {x: 100, y: 30.806},
  {x: 101, y: 31.093},
  {x: 102, y: 31.384},
  {x: 103, y: 31.678},
  {x: 104, y: 31.974},
  {x: 105, y: 32.274},
  {x: 106, y: 32.578},
  {x: 107, y: 32.885},
  {x: 108, y: 33.196},
  {x: 109, y: 33.512},
  {x: 110, y: 33.832},
  {x: 111, y: 34.155},
  {x: 112, y: 34.484},
  {x: 113, y: 34.817},
  {x: 114, y: 35.155},
  {x: 115, y: 35.497},
  {x: 116, y: 35.844},
  {x: 117, y: 36.197},
  {x: 118, y: 36.554},
  {x: 119, y: 36.916},
  {x: 120, y: 37.283}
]
const weightBoysNintySeven = [
  {x: 0, y: 4.35},
  {x: 1, y: 5.74},
  {x: 2, y: 7.031},
  {x: 3, y: 7.961},
  {x: 4, y: 8.681},
  {x: 5, y: 9.273},
  {x: 6, y: 9.776},
  {x: 7, y: 10.214},
  {x: 8, y: 10.604},
  {x: 9, y: 10.958},
  {x: 10, y: 11.287},
  {x: 11, y: 11.599},
  {x: 12, y: 11.897},
  {x: 13, y: 12.186},
  {x: 14, y: 12.469},
  {x: 15, y: 12.746},
  {x: 16, y: 13.021},
  {x: 17, y: 13.294},
  {x: 18, y: 13.565},
  {x: 19, y: 13.835},
  {x: 20, y: 14.105},
  {x: 21, y: 14.375},
  {x: 22, y: 14.646},
  {x: 23, y: 14.917},
  {x: 24, y: 15.187},
  {x: 25, y: 15.457},
  {x: 26, y: 15.724},
  {x: 27, y: 15.987},
  {x: 29, y: 16.246},
  {x: 30, y: 16.502},
  {x: 31, y: 16.753},
  {x: 32, y: 17.001},
  {x: 33, y: 17.245},
  {x: 34, y: 17.487},
  {x: 35, y: 17.726},
  {x: 36, y: 17.964},
  {x: 37, y: 18.201},
  {x: 38, y: 18.437},
  {x: 39, y: 18.673},
  {x: 40, y: 18.909},
  {x: 41, y: 19.145},
  {x: 42, y: 19.382},
  {x: 43, y: 19.62},
  {x: 44, y: 19.858},
  {x: 45, y: 20.098},
  {x: 46, y: 20.338},
  {x: 47, y: 20.579},
  {x: 48, y: 20.821},
  {x: 49, y: 21.063},
  {x: 50, y: 21.308},
  {x: 51, y: 21.552},
  {x: 52, y: 21.798},
  {x: 53, y: 22.044},
  {x: 54, y: 22.292},
  {x: 55, y: 22.54},
  {x: 56, y: 22.789},
  {x: 57, y: 23.037},
  {x: 58, y: 23.287},
  {x: 59, y: 23.536},
  {x: 60, y: 23.785},
  {x: 61, y: 23.774},
  {x: 62, y: 24.026},
  {x: 63, y: 24.279},
  {x: 64, y: 24.535},
  {x: 65, y: 24.793},
  {x: 66, y: 25.053},
  {x: 67, y: 25.315},
  {x: 68, y: 25.58},
  {x: 69, y: 25.847},
  {x: 70, y: 26.117},
  {x: 71, y: 26.388},
  {x: 72, y: 26.661},
  {x: 73, y: 26.937},
  {x: 74, y: 27.215},
  {x: 75, y: 27.494},
  {x: 76, y: 27.777},
  {x: 77, y: 28.061},
  {x: 78, y: 28.349},
  {x: 79, y: 28.639},
  {x: 80, y: 28.931},
  {x: 81, y: 29.227},
  {x: 82, y: 29.525},
  {x: 83, y: 29.826},
  {x: 84, y: 30.13},
  {x: 85, y: 30.436},
  {x: 86, y: 30.746},
  {x: 87, y: 31.059},
  {x: 88, y: 31.375},
  {x: 89, y: 31.695},
  {x: 90, y: 32.017},
  {x: 91, y: 32.343},
  {x: 92, y: 32.674},
  {x: 93, y: 33.007},
  {x: 94, y: 33.345},
  {x: 95, y: 33.687},
  {x: 96, y: 34.033},
  {x: 97, y: 34.384},
  {x: 98, y: 34.74},
  {x: 99, y: 35.099},
  {x: 100, y: 35.464},
  {x: 101, y: 35.832},
  {x: 102, y: 36.206},
  {x: 103, y: 36.585},
  {x: 104, y: 36.969},
  {x: 105, y: 37.358},
  {x: 106, y: 37.753},
  {x: 107, y: 38.155},
  {x: 108, y: 38.562},
  {x: 109, y: 38.975},
  {x: 110, y: 39.395},
  {x: 111, y: 39.82},
  {x: 112, y: 40.252},
  {x: 113, y: 40.69},
  {x: 114, y: 41.135},
  {x: 115, y: 41.587},
  {x: 116, y: 42.044},
  {x: 117, y: 42.508},
  {x: 118, y: 42.978},
  {x: 119, y: 43.455},
  {x: 120, y: 43.938}
]

    // Girls
const weightGirlsThree = [
  {x: 0, y: 2.44},
  {x: 1, y: 3.233},
  {x: 2, y: 4.029},
  {x: 3, y: 4.635},
  {x: 4, y: 5.12},
  {x: 5, y: 5.516},
  {x: 6, y: 5.845},
  {x: 7, y: 6.128},
  {x: 8, y: 6.377},
  {x: 9, y: 6.599},
  {x: 10, y: 6.804},
  {x: 11, y: 6.996},
  {x: 12, y: 7.181},
  {x: 13, y: 7.361},
  {x: 14, y: 7.538},
  {x: 15, y: 7.712},
  {x: 16, y: 7.885},
  {x: 17, y: 8.057},
  {x: 18, y: 8.228},
  {x: 19, y: 8.397},
  {x: 20, y: 8.565},
  {x: 21, y: 8.733},
  {x: 22, y: 8.9},
  {x: 23, y: 9.067},
  {x: 24, y: 9.234},
  {x: 25, y: 9.4},
  {x: 26, y: 9.565},
  {x: 27, y: 9.727},
  {x: 29, y: 9.886},
  {x: 30, y: 10.041},
  {x: 31, y: 10.193},
  {x: 32, y: 10.341},
  {x: 33, y: 10.487},
  {x: 34, y: 10.63},
  {x: 35, y: 10.772},
  {x: 36, y: 10.912},
  {x: 37, y: 11.051},
  {x: 38, y: 11.189},
  {x: 39, y: 11.326},
  {x: 40, y: 11.461},
  {x: 41, y: 11.594},
  {x: 42, y: 11.726},
  {x: 43, y: 11.857},
  {x: 44, y: 11.987},
  {x: 45, y: 12.115},
  {x: 46, y: 12.242},
  {x: 47, y: 12.369},
  {x: 48, y: 12.495},
  {x: 49, y: 12.621},
  {x: 50, y: 12.746},
  {x: 51, y: 12.871},
  {x: 52, y: 12.996},
  {x: 53, y: 13.121},
  {x: 54, y: 13.246},
  {x: 55, y: 13.369},
  {x: 56, y: 13.492},
  {x: 57, y: 13.614},
  {x: 58, y: 13.736},
  {x: 59, y: 13.856},
  {x: 60, y: 13.976},
  {x: 61, y: 14.173},
  {x: 62, y: 14.297},
  {x: 63, y: 14.421},
  {x: 64, y: 14.544},
  {x: 65, y: 14.666},
  {x: 66, y: 14.788},
  {x: 67, y: 14.909},
  {x: 68, y: 15.03},
  {x: 69, y: 15.151},
  {x: 70, y: 15.272},
  {x: 71, y: 15.392},
  {x: 72, y: 15.513},
  {x: 73, y: 15.634},
  {x: 74, y: 15.756},
  {x: 75, y: 15.878},
  {x: 76, y: 16.001},
  {x: 77, y: 16.126},
  {x: 78, y: 16.252},
  {x: 79, y: 16.38},
  {x: 80, y: 16.509},
  {x: 81, y: 16.641},
  {x: 82, y: 16.774},
  {x: 83, y: 16.91},
  {x: 84, y: 17.049},
  {x: 85, y: 17.189},
  {x: 86, y: 17.332},
  {x: 87, y: 17.477},
  {x: 88, y: 17.625},
  {x: 89, y: 17.775},
  {x: 90, y: 17.927},
  {x: 91, y: 18.082},
  {x: 92, y: 18.24},
  {x: 93, y: 18.4},
  {x: 94, y: 18.562},
  {x: 95, y: 18.728},
  {x: 96, y: 18.896},
  {x: 97, y: 19.066},
  {x: 98, y: 19.24},
  {x: 99, y: 19.416},
  {x: 100, y: 19.595},
  {x: 101, y: 19.777},
  {x: 102, y: 19.961},
  {x: 103, y: 20.147},
  {x: 104, y: 20.337},
  {x: 105, y: 20.528},
  {x: 106, y: 20.722},
  {x: 107, y: 20.918},
  {x: 108, y: 21.116},
  {x: 109, y: 21.316},
  {x: 110, y: 21.518},
  {x: 111, y: 21.723},
  {x: 112, y: 21.929},
  {x: 113, y: 22.138},
  {x: 114, y: 22.349},
  {x: 115, y: 22.563},
  {x: 116, y: 22.78},
  {x: 117, y: 22.999},
  {x: 118, y: 23.222},
  {x: 119, y: 23.447},
  {x: 120, y: 23.676}
]
const weightGirlsFiftheen = [
  {x: 0, y: 2.779},
  {x: 1, y: 3.644},
  {x: 2, y: 4.505},
  {x: 3, y: 5.159},
  {x: 4, y: 5.684},
  {x: 5, y: 6.112},
  {x: 6, y: 6.47},
  {x: 7, y: 6.778},
  {x: 8, y: 7.051},
  {x: 9, y: 7.296},
  {x: 10, y: 7.521},
  {x: 11, y: 7.733},
  {x: 12, y: 7.936},
  {x: 13, y: 8.134},
  {x: 14, y: 8.328},
  {x: 15, y: 8.52},
  {x: 16, y: 8.71},
  {x: 17, y: 8.899},
  {x: 18, y: 9.086},
  {x: 19, y: 9.272},
  {x: 20, y: 9.458},
  {x: 21, y: 9.643},
  {x: 22, y: 9.828},
  {x: 23, y: 10.014},
  {x: 24, y: 10.199},
  {x: 25, y: 10.384},
  {x: 26, y: 10.568},
  {x: 27, y: 10.749},
  {x: 29, y: 10.927},
  {x: 30, y: 11.102},
  {x: 31, y: 11.273},
  {x: 32, y: 11.441},
  {x: 33, y: 11.606},
  {x: 34, y: 11.77},
  {x: 35, y: 11.932},
  {x: 36, y: 12.093},
  {x: 37, y: 12.253},
  {x: 38, y: 12.412},
  {x: 39, y: 12.57},
  {x: 40, y: 12.727},
  {x: 41, y: 12.883},
  {x: 42, y: 13.038},
  {x: 43, y: 13.191},
  {x: 44, y: 13.344},
  {x: 45, y: 13.495},
  {x: 46, y: 13.645},
  {x: 47, y: 13.795},
  {x: 48, y: 13.944},
  {x: 49, y: 14.092},
  {x: 50, y: 14.241},
  {x: 51, y: 14.389},
  {x: 52, y: 14.537},
  {x: 53, y: 14.685},
  {x: 54, y: 14.833},
  {x: 55, y: 14.98},
  {x: 56, y: 15.126},
  {x: 57, y: 15.271},
  {x: 58, y: 15.415},
  {x: 59, y: 15.558},
  {x: 60, y: 15.7},
  {x: 61, y: 15.821},
  {x: 62, y: 15.965},
  {x: 63, y: 16.108},
  {x: 64, y: 16.25},
  {x: 65, y: 16.392},
  {x: 66, y: 16.534},
  {x: 67, y: 16.675},
  {x: 68, y: 16.815},
  {x: 69, y: 16.956},
  {x: 70, y: 17.096},
  {x: 71, y: 17.236},
  {x: 72, y: 17.377},
  {x: 73, y: 17.518},
  {x: 74, y: 17.66},
  {x: 75, y: 17.803},
  {x: 76, y: 17.947},
  {x: 77, y: 18.092},
  {x: 78, y: 18.239},
  {x: 79, y: 18.388},
  {x: 80, y: 18.539},
  {x: 81, y: 18.693},
  {x: 82, y: 18.848},
  {x: 83, y: 19.007},
  {x: 84, y: 19.168},
  {x: 85, y: 19.332},
  {x: 86, y: 19.499},
  {x: 87, y: 19.668},
  {x: 88, y: 19.84},
  {x: 89, y: 20.014},
  {x: 90, y: 20.192},
  {x: 91, y: 20.372},
  {x: 92, y: 20.556},
  {x: 93, y: 20.742},
  {x: 94, y: 20.931},
  {x: 95, y: 21.124},
  {x: 96, y: 21.319},
  {x: 97, y: 21.518},
  {x: 98, y: 21.72},
  {x: 99, y: 21.925},
  {x: 100, y: 22.133},
  {x: 101, y: 22.345},
  {x: 102, y: 22.559},
  {x: 103, y: 22.776},
  {x: 104, y: 22.996},
  {x: 105, y: 23.219},
  {x: 106, y: 23.444},
  {x: 107, y: 23.672},
  {x: 108, y: 23.902},
  {x: 109, y: 24.135},
  {x: 110, y: 24.37},
  {x: 111, y: 24.607},
  {x: 112, y: 24.847},
  {x: 113, y: 25.09},
  {x: 114, y: 25.336},
  {x: 115, y: 25.584},
  {x: 116, y: 25.836},
  {x: 117, y: 26.091},
  {x: 118, y: 26.349},
  {x: 119, y: 26.611},
  {x: 120, y: 26.877}
]
const weightGirlsFifthy = [
  {x: 0, y: 3.232},
  {x: 1, y: 4.208},
  {x: 2, y: 5.158},
  {x: 3, y: 5.881},
  {x: 4, y: 6.462},
  {x: 5, y: 6.938},
  {x: 6, y: 7.338},
  {x: 7, y: 7.684},
  {x: 8, y: 7.991},
  {x: 9, y: 8.269},
  {x: 10, y: 8.525},
  {x: 11, y: 8.766},
  {x: 12, y: 8.998},
  {x: 13, y: 9.223},
  {x: 14, y: 9.443},
  {x: 15, y: 9.66},
  {x: 16, y: 9.875},
  {x: 17, y: 10.088},
  {x: 18, y: 10.301},
  {x: 19, y: 10.512},
  {x: 20, y: 10.723},
  {x: 21, y: 10.934},
  {x: 22, y: 11.145},
  {x: 23, y: 11.358},
  {x: 24, y: 11.57},
  {x: 25, y: 11.783},
  {x: 26, y: 11.994},
  {x: 27, y: 12.204},
  {x: 29, y: 12.411},
  {x: 30, y: 12.614},
  {x: 31, y: 12.814},
  {x: 32, y: 13.011},
  {x: 33, y: 13.206},
  {x: 34, y: 13.399},
  {x: 35, y: 13.592},
  {x: 36, y: 13.784},
  {x: 37, y: 13.976},
  {x: 38, y: 14.167},
  {x: 39, y: 14.358},
  {x: 40, y: 14.549},
  {x: 41, y: 14.739},
  {x: 42, y: 14.928},
  {x: 43, y: 15.116},
  {x: 44, y: 15.303},
  {x: 45, y: 15.49},
  {x: 46, y: 15.676},
  {x: 47, y: 15.861},
  {x: 48, y: 16.046},
  {x: 49, y: 16.231},
  {x: 50, y: 16.415},
  {x: 51, y: 16.6},
  {x: 52, y: 16.784},
  {x: 53, y: 16.968},
  {x: 54, y: 17.151},
  {x: 55, y: 17.334},
  {x: 56, y: 17.517},
  {x: 57, y: 17.698},
  {x: 58, y: 17.878},
  {x: 59, y: 18.057},
  {x: 60, y: 18.235},
  {x: 61, y: 18.258},
  {x: 62, y: 18.433},
  {x: 63, y: 18.607},
  {x: 64, y: 18.781},
  {x: 65, y: 18.954},
  {x: 66, y: 19.128},
  {x: 67, y: 19.3},
  {x: 68, y: 19.473},
  {x: 69, y: 19.646},
  {x: 70, y: 19.818},
  {x: 71, y: 19.991},
  {x: 72, y: 20.164},
  {x: 73, y: 20.338},
  {x: 74, y: 20.512},
  {x: 75, y: 20.688},
  {x: 76, y: 20.866},
  {x: 77, y: 21.046},
  {x: 78, y: 21.227},
  {x: 79, y: 21.411},
  {x: 80, y: 21.598},
  {x: 81, y: 21.787},
  {x: 82, y: 21.98},
  {x: 83, y: 22.175},
  {x: 84, y: 22.374},
  {x: 85, y: 22.576},
  {x: 86, y: 22.782},
  {x: 87, y: 22.99},
  {x: 88, y: 23.202},
  {x: 89, y: 23.418},
  {x: 90, y: 23.637},
  {x: 91, y: 23.859},
  {x: 92, y: 24.085},
  {x: 93, y: 24.315},
  {x: 94, y: 24.548},
  {x: 95, y: 24.785},
  {x: 96, y: 25.026},
  {x: 97, y: 25.271},
  {x: 98, y: 25.52},
  {x: 99, y: 25.772},
  {x: 100, y: 26.028},
  {x: 101, y: 26.288},
  {x: 102, y: 26.552},
  {x: 103, y: 26.819},
  {x: 104, y: 27.09},
  {x: 105, y: 27.364},
  {x: 106, y: 27.641},
  {x: 107, y: 27.921},
  {x: 108, y: 28.204},
  {x: 109, y: 28.49},
  {x: 110, y: 28.779},
  {x: 111, y: 29.071},
  {x: 112, y: 29.366},
  {x: 113, y: 29.665},
  {x: 114, y: 29.966},
  {x: 115, y: 30.272},
  {x: 116, y: 30.58},
  {x: 117, y: 30.893},
  {x: 118, y: 31.21},
  {x: 119, y: 31.532},
  {x: 120, y: 31.858}
]
const weightGirlsEightyFive = [
  {x: 0, y: 3.729},
  {x: 1, y: 4.842},
  {x: 2, y: 5.896},
  {x: 3, y: 6.7},
  {x: 4, y: 7.348},
  {x: 5, y: 7.882},
  {x: 6, y: 8.332},
  {x: 7, y: 8.725},
  {x: 8, y: 9.076},
  {x: 9, y: 9.395},
  {x: 10, y: 9.691},
  {x: 11, y: 9.969},
  {x: 12, y: 10.236},
  {x: 13, y: 10.494},
  {x: 14, y: 10.746},
  {x: 15, y: 10.995},
  {x: 16, y: 11.241},
  {x: 17, y: 11.486},
  {x: 18, y: 11.729},
  {x: 19, y: 11.971},
  {x: 20, y: 12.213},
  {x: 21, y: 12.455},
  {x: 22, y: 12.699},
  {x: 23, y: 12.944},
  {x: 24, y: 13.19},
  {x: 25, y: 13.436},
  {x: 26, y: 13.682},
  {x: 27, y: 13.927},
  {x: 29, y: 14.169},
  {x: 30, y: 14.407},
  {x: 31, y: 14.643},
  {x: 32, y: 14.877},
  {x: 33, y: 15.108},
  {x: 34, y: 15.339},
  {x: 35, y: 15.57},
  {x: 36, y: 15.801},
  {x: 37, y: 16.033},
  {x: 38, y: 16.266},
  {x: 39, y: 16.499},
  {x: 40, y: 16.733},
  {x: 41, y: 16.966},
  {x: 42, y: 17.2},
  {x: 43, y: 17.433},
  {x: 44, y: 17.666},
  {x: 45, y: 17.898},
  {x: 46, y: 18.13},
  {x: 47, y: 18.362},
  {x: 48, y: 18.594},
  {x: 49, y: 18.826},
  {x: 50, y: 19.057},
  {x: 51, y: 19.289},
  {x: 52, y: 19.521},
  {x: 53, y: 19.753},
  {x: 54, y: 19.984},
  {x: 55, y: 20.215},
  {x: 56, y: 20.446},
  {x: 57, y: 20.675},
  {x: 58, y: 20.903},
  {x: 59, y: 21.13},
  {x: 60, y: 21.356},
  {x: 61, y: 21.288},
  {x: 62, y: 21.506},
  {x: 63, y: 21.723},
  {x: 64, y: 21.941},
  {x: 65, y: 22.158},
  {x: 66, y: 22.375},
  {x: 67, y: 22.591},
  {x: 68, y: 22.808},
  {x: 69, y: 23.026},
  {x: 70, y: 23.243},
  {x: 71, y: 23.461},
  {x: 72, y: 23.68},
  {x: 73, y: 23.9},
  {x: 74, y: 24.121},
  {x: 75, y: 24.344},
  {x: 76, y: 24.569},
  {x: 77, y: 24.797},
  {x: 78, y: 25.028},
  {x: 79, y: 25.261},
  {x: 80, y: 25.498},
  {x: 81, y: 25.738},
  {x: 82, y: 25.982},
  {x: 83, y: 26.231},
  {x: 84, y: 26.483},
  {x: 85, y: 26.74},
  {x: 86, y: 27.00},
  {x: 87, y: 27.265},
  {x: 88, y: 27.535},
  {x: 89, y: 27.808},
  {x: 90, y: 28.086},
  {x: 91, y: 28.368},
  {x: 92, y: 28.655},
  {x: 93, y: 28.946},
  {x: 94, y: 29.242},
  {x: 95, y: 29.543},
  {x: 96, y: 29.849},
  {x: 97, y: 30.159},
  {x: 98, y: 30.474},
  {x: 99, y: 30.794},
  {x: 100, y: 31.119},
  {x: 101, y: 31.448},
  {x: 102, y: 31.782},
  {x: 103, y: 32.121},
  {x: 104, y: 32.463},
  {x: 105, y: 32.81},
  {x: 106, y: 33.161},
  {x: 107, y: 33.516},
  {x: 108, y: 33.874},
  {x: 109, y: 34.237},
  {x: 110, y: 34.603},
  {x: 111, y: 34.972},
  {x: 112, y: 35.346},
  {x: 113, y: 35.723},
  {x: 114, y: 36.104},
  {x: 115, y: 36.49},
  {x: 116, y: 36.881},
  {x: 117, y: 37.275},
  {x: 118, y: 37.676},
  {x: 119, y: 38.081},
  {x: 120, y: 38.493}
]
const weightGirlsNintySeven = [
  {x: 0, y: 4.166},
  {x: 1, y: 5.415},
  {x: 2, y: 6.566},
  {x: 3, y: 7.446},
  {x: 4, y: 8.16},
  {x: 5, y: 8.749},
  {x: 6, y: 9.25},
  {x: 7, y: 9.689},
  {x: 8, y: 10.085},
  {x: 9, y: 10.445},
  {x: 10, y: 10.78},
  {x: 11, y: 11.096},
  {x: 12, y: 11.398},
  {x: 13, y: 11.69},
  {x: 14, y: 11.976},
  {x: 15, y: 12.256},
  {x: 16, y: 12.533},
  {x: 17, y: 12.808},
  {x: 18, y: 13.082},
  {x: 19, y: 13.354},
  {x: 20, y: 13.627},
  {x: 21, y: 13.901},
  {x: 22, y: 14.177},
  {x: 23, y: 14.454},
  {x: 24, y: 14.733},
  {x: 25, y: 15.013},
  {x: 26, y: 15.293},
  {x: 27, y: 15.572},
  {x: 29, y: 15.849},
  {x: 30, y: 16.123},
  {x: 31, y: 16.395},
  {x: 32, y: 16.664},
  {x: 33, y: 16.933},
  {x: 34, y: 17.202},
  {x: 35, y: 17.471},
  {x: 36, y: 17.742},
  {x: 37, y: 18.015},
  {x: 38, y: 18.29},
  {x: 39, y: 18.566},
  {x: 40, y: 18.844},
  {x: 41, y: 19.123},
  {x: 42, y: 19.402},
  {x: 43, y: 19.682},
  {x: 44, y: 19.962},
  {x: 45, y: 20.242},
  {x: 46, y: 20.523},
  {x: 47, y: 20.804},
  {x: 48, y: 21.084},
  {x: 49, y: 21.366},
  {x: 50, y: 21.647},
  {x: 51, y: 21.929},
  {x: 52, y: 22.212},
  {x: 53, y: 22.495},
  {x: 54, y: 22.777},
  {x: 55, y: 23.059},
  {x: 56, y: 23.34},
  {x: 57, y: 23.621},
  {x: 58, y: 23.9},
  {x: 59, y: 24.179},
  {x: 60, y: 24.456},
  {x: 61, y: 24.336},
  {x: 62, y: 24.601},
  {x: 63, y: 24.866},
  {x: 64, y: 25.132},
  {x: 65, y: 25.398},
  {x: 66, y: 25.664},
  {x: 67, y: 25.93},
  {x: 68, y: 26.197},
  {x: 69, y: 26.465},
  {x: 70, y: 26.733},
  {x: 71, y: 27.002},
  {x: 72, y: 27.273},
  {x: 73, y: 27.545},
  {x: 74, y: 27.819},
  {x: 75, y: 28.095},
  {x: 76, y: 28.375},
  {x: 77, y: 28.658},
  {x: 78, y: 28.945},
  {x: 79, y: 29.234},
  {x: 80, y: 29.529},
  {x: 81, y: 29.828},
  {x: 82, y: 30.132},
  {x: 83, y: 30.441},
  {x: 84, y: 30.755},
  {x: 85, y: 31.075},
  {x: 86, y: 31.399},
  {x: 87, y: 31.73},
  {x: 88, y: 32.065},
  {x: 89, y: 32.406},
  {x: 90, y: 32.752},
  {x: 91, y: 33.103},
  {x: 92, y: 33.46},
  {x: 93, y: 33.823},
  {x: 94, y: 34.192},
  {x: 95, y: 34.567},
  {x: 96, y: 34.947},
  {x: 97, y: 35.334},
  {x: 98, y: 35.727},
  {x: 99, y: 36.126},
  {x: 100, y: 36.53},
  {x: 101, y: 36.94},
  {x: 102, y: 37.355},
  {x: 103, y: 37.778},
  {x: 104, y: 38.204},
  {x: 105, y: 38.636},
  {x: 106, y: 39.073},
  {x: 107, y: 39.514},
  {x: 108, y: 39.96},
  {x: 109, y: 40.411},
  {x: 110, y: 40.867},
  {x: 111, y: 41.326},
  {x: 112, y: 41.791},
  {x: 113, y: 42.26},
  {x: 114, y: 42.734},
  {x: 115, y: 43.214},
  {x: 116, y: 43.699},
  {x: 117, y: 44.189},
  {x: 118, y: 44.687},
  {x: 119, y: 45.19},
  {x: 120, y: 45.7}
]

// Cephalic Perimeter

    // Boys
const cephalicPerimeterBoysThree = [
  {x: 0, y: 32.073},
  {x: 1, y: 35.121},
  {x: 2, y: 36.98},
  {x: 3, y: 38.357},
  {x: 4, y: 39.459},
  {x: 5, y: 40.362},
  {x: 6, y: 41.11},
  {x: 7, y: 41.734},
  {x: 8, y: 42.259},
  {x: 9, y: 42.705},
  {x: 10, y: 43.089},
  {x: 11, y: 43.42},
  {x: 12, y: 43.71},
  {x: 13, y: 43.966},
  {x: 14, y: 44.195},
  {x: 15, y: 44.402},
  {x: 16, y: 44.592},
  {x: 17, y: 44.766},
  {x: 18, y: 44.928},
  {x: 19, y: 45.082},
  {x: 20, y: 45.226},
  {x: 21, y: 45.365},
  {x: 22, y: 45.496},
  {x: 23, y: 45.622},
  {x: 24, y: 45.743},
  {x: 25, y: 45.859},
  {x: 26, y: 45.969},
  {x: 27, y: 46.075},
  {x: 29, y: 46.177},
  {x: 30, y: 46.272},
  {x: 31, y: 46.365},
  {x: 32, y: 46.453},
  {x: 33, y: 46.537},
  {x: 34, y: 46.616},
  {x: 35, y: 46.692},
  {x: 36, y: 46.765},
  {x: 37, y: 46.836},
  {x: 38, y: 46.903},
  {x: 39, y: 46.968},
  {x: 40, y: 47.03},
  {x: 41, y: 47.09},
  {x: 42, y: 47.148},
  {x: 43, y: 47.204},
  {x: 44, y: 47.257},
  {x: 45, y: 47.309},
  {x: 46, y: 47.36},
  {x: 47, y: 47.409},
  {x: 48, y: 47.455},
  {x: 49, y: 47.501},
  {x: 50, y: 47.545},
  {x: 51, y: 47.588},
  {x: 52, y: 47.63},
  {x: 53, y: 47.67},
  {x: 54, y: 47.71},
  {x: 55, y: 47.749},
  {x: 56, y: 47.786},
  {x: 57, y: 47.823},
  {x: 58, y: 47.859},
  {x: 59, y: 47.895},
  {x: 60, y: 47.93},
  {x: 61, y: 47.96}
]
const cephalicPerimeterBoysFiftheen = [
  {x: 0, y: 33.145},
  {x: 1, y: 36.107},
  {x: 2, y: 37.971},
  {x: 3, y: 39.356},
  {x: 4, y: 40.468},
  {x: 5, y: 41.382},
  {x: 6, y: 42.142},
  {x: 7, y: 42.777},
  {x: 8, y: 43.312},
  {x: 9, y: 43.768},
  {x: 10, y: 44.159},
  {x: 11, y: 44.499},
  {x: 12, y: 44.796},
  {x: 13, y: 45.059},
  {x: 14, y: 45.295},
  {x: 15, y: 45.507},
  {x: 16, y: 45.702},
  {x: 17, y: 45.882},
  {x: 18, y: 46.05},
  {x: 19, y: 46.208},
  {x: 20, y: 46.358},
  {x: 21, y: 46.501},
  {x: 22, y: 46.638},
  {x: 23, y: 46.769},
  {x: 24, y: 46.895},
  {x: 25, y: 47.015},
  {x: 26, y: 47.13},
  {x: 27, y: 47.241},
  {x: 29, y: 47.346},
  {x: 30, y: 47.447},
  {x: 31, y: 47.543},
  {x: 32, y: 47.635},
  {x: 33, y: 47.723},
  {x: 34, y: 47.806},
  {x: 35, y: 47.887},
  {x: 36, y: 47.963},
  {x: 37, y: 48.038},
  {x: 38, y: 48.108},
  {x: 39, y: 48.176},
  {x: 40, y: 48.241},
  {x: 41, y: 48.304},
  {x: 42, y: 48.365},
  {x: 43, y: 48.424},
  {x: 44, y: 48.481},
  {x: 45, y: 48.536},
  {x: 46, y: 48.589},
  {x: 47, y: 48.64},
  {x: 48, y: 48.69},
  {x: 49, y: 48.738},
  {x: 50, y: 48.784},
  {x: 51, y: 48.83},
  {x: 52, y: 48.874},
  {x: 53, y: 48.917},
  {x: 54, y: 48.959},
  {x: 55, y: 49},
  {x: 56, y: 49.039},
  {x: 57, y: 49.078},
  {x: 58, y: 49.117},
  {x: 59, y: 49.155},
  {x: 60, y: 49.192},
  {x: 61, y: 49.224}
]
const cephalicPerimeterBoysFifthy = [
  {x: 0, y: 34.462},
  {x: 1, y: 37.317},
  {x: 2, y: 39.186},
  {x: 3, y: 40.582},
  {x: 4, y: 41.706},
  {x: 5, y: 42.635},
  {x: 6, y: 43.408},
  {x: 7, y: 44.057},
  {x: 8, y: 44.604},
  {x: 9, y: 45.071},
  {x: 10, y: 45.474},
  {x: 11, y: 45.823},
  {x: 12, y: 46.13},
  {x: 13, y: 46.401},
  {x: 14, y: 46.644},
  {x: 15, y: 46.864},
  {x: 16, y: 47.066},
  {x: 17, y: 47.252},
  {x: 18, y: 47.427},
  {x: 19, y: 47.592},
  {x: 20, y: 47.748},
  {x: 21, y: 47.897},
  {x: 22, y: 48.04},
  {x: 23, y: 48.177},
  {x: 24, y: 48.308},
  {x: 25, y: 48.434},
  {x: 26, y: 48.555},
  {x: 27, y: 48.671},
  {x: 29, y: 48.782},
  {x: 30, y: 48.888},
  {x: 31, y: 48.99},
  {x: 32, y: 49.087},
  {x: 33, y: 49.179},
  {x: 34, y: 49.268},
  {x: 35, y: 49.353},
  {x: 36, y: 49.434},
  {x: 37, y: 49.512},
  {x: 38, y: 49.587},
  {x: 39, y: 49.659},
  {x: 40, y: 49.728},
  {x: 41, y: 49.795},
  {x: 42, y: 49.86},
  {x: 43, y: 49.922},
  {x: 44, y: 49.982},
  {x: 45, y: 50.041},
  {x: 46, y: 50.097},
  {x: 47, y: 50.152},
  {x: 48, y: 50.205},
  {x: 49, y: 50.256},
  {x: 50, y: 50.306},
  {x: 51, y: 50.354},
  {x: 52, y: 50.401},
  {x: 53, y: 50.447},
  {x: 54, y: 50.492},
  {x: 55, y: 50.535},
  {x: 56, y: 50.578},
  {x: 57, y: 50.62},
  {x: 58, y: 50.661},
  {x: 59, y: 50.701},
  {x: 60, y: 50.741},
  {x: 61, y: 50.775}
]
const cephalicPerimeterBoysEightyFive = [
  {x: 0, y: 35.778},
  {x: 1, y: 38.527},
  {x: 2, y: 40.402},
  {x: 3, y: 41.807},
  {x: 4, y: 42.945},
  {x: 5, y: 43.888},
  {x: 6, y: 44.675},
  {x: 7, y: 45.336},
  {x: 8, y: 45.897},
  {x: 9, y: 46.375},
  {x: 10, y: 46.788},
  {x: 11, y: 47.147},
  {x: 12, y: 47.463},
  {x: 13, y: 47.742},
  {x: 14, y: 47.993},
  {x: 15, y: 48.22},
  {x: 16, y: 48.429},
  {x: 17, y: 48.623},
  {x: 18, y: 48.804},
  {x: 19, y: 48.975},
  {x: 20, y: 49.137},
  {x: 21, y: 49.292},
  {x: 22, y: 49.441},
  {x: 23, y: 49.584},
  {x: 24, y: 49.722},
  {x: 25, y: 49.853},
  {x: 26, y: 49.98},
  {x: 27, y: 50.102},
  {x: 29, y: 50.218},
  {x: 30, y: 50.33},
  {x: 31, y: 50.436},
  {x: 32, y: 50.538},
  {x: 33, y: 50.636},
  {x: 34, y: 50.729},
  {x: 35, y: 50.819},
  {x: 36, y: 50.904},
  {x: 37, y: 50.986},
  {x: 38, y: 51.065},
  {x: 39, y: 51.141},
  {x: 40, y: 51.215},
  {x: 41, y: 51.285},
  {x: 42, y: 51.354},
  {x: 43, y: 51.42},
  {x: 44, y: 51.484},
  {x: 45, y: 51.546},
  {x: 46, y: 51.606},
  {x: 47, y: 51.663},
  {x: 48, y: 51.72},
  {x: 49, y: 51.774},
  {x: 50, y: 51.827},
  {x: 51, y: 51.879},
  {x: 52, y: 51.929},
  {x: 53, y: 51.977},
  {x: 54, y: 52.024},
  {x: 55, y: 52.071},
  {x: 56, y: 52.116},
  {x: 57, y: 52.161},
  {x: 58, y: 52.204},
  {x: 59, y: 52.248},
  {x: 60, y: 52.29},
  {x: 61, y: 52.327}
]
const cephalicPerimeterBoysNintySeven = [
  {x: 0, y: 36.851},
  {x: 1, y: 39.513},
  {x: 2, y: 41.392},
  {x: 3, y: 42.806},
  {x: 4, y: 43.954},
  {x: 5, y: 44.908},
  {x: 6, y: 45.707},
  {x: 7, y: 46.379},
  {x: 8, y: 46.95},
  {x: 9, y: 47.437},
  {x: 10, y: 47.859},
  {x: 11, y: 48.226},
  {x: 12, y: 48.549},
  {x: 13, y: 48.836},
  {x: 14, y: 49.092},
  {x: 15, y: 49.326},
  {x: 16, y: 49.54},
  {x: 17, y: 49.739},
  {x: 18, y: 49.925},
  {x: 19, y: 50.101},
  {x: 20, y: 50.269},
  {x: 21, y: 50.429},
  {x: 22, y: 50.583},
  {x: 23, y: 50.731},
  {x: 24, y: 50.873},
  {x: 25, y: 51.01},
  {x: 26, y: 51.142},
  {x: 27, y: 51.267},
  {x: 29, y: 51.388},
  {x: 30, y: 51.504},
  {x: 31, y: 51.615},
  {x: 32, y: 51.721},
  {x: 33, y: 51.822},
  {x: 34, y: 51.92},
  {x: 35, y: 52.013},
  {x: 36, y: 52.102},
  {x: 37, y: 52.187},
  {x: 38, y: 52.27},
  {x: 39, y: 52.349},
  {x: 40, y: 52.426},
  {x: 41, y: 52.5},
  {x: 42, y: 52.571},
  {x: 43, y: 52.64},
  {x: 44, y: 52.708},
  {x: 45, y: 52.772},
  {x: 46, y: 52.834},
  {x: 47, y: 52.895},
  {x: 48, y: 52.954},
  {x: 49, y: 53.011},
  {x: 50, y: 53.067},
  {x: 51, y: 53.121},
  {x: 52, y: 53.173},
  {x: 53, y: 53.224},
  {x: 54, y: 53.273},
  {x: 55, y: 53.322},
  {x: 56, y: 53.37},
  {x: 57, y: 53.417},
  {x: 58, y: 53.462},
  {x: 59, y: 53.508},
  {x: 60, y: 53.552},
  {x: 61, y: 53.59}
]

    // Girls
const cephalicPerimeterGirlsThree = [
  {x: 0, y: 31.651},
  {x: 1, y: 34.377},
  {x: 2, y: 36.023},
  {x: 3, y: 37.259},
  {x: 4, y: 38.268},
  {x: 5, y: 39.11},
  {x: 6, y: 39.821},
  {x: 7, y: 40.424},
  {x: 8, y: 40.938},
  {x: 9, y: 41.382},
  {x: 10, y: 41.766},
  {x: 11, y: 42.104},
  {x: 12, y: 42.403},
  {x: 13, y: 42.67},
  {x: 14, y: 42.912},
  {x: 15, y: 43.132},
  {x: 16, y: 43.335},
  {x: 17, y: 43.524},
  {x: 18, y: 43.701},
  {x: 19, y: 43.869},
  {x: 20, y: 44.03},
  {x: 21, y: 44.184},
  {x: 22, y: 44.334},
  {x: 23, y: 44.478},
  {x: 24, y: 44.618},
  {x: 25, y: 44.753},
  {x: 26, y: 44.882},
  {x: 27, y: 45.006},
  {x: 29, y: 45.126},
  {x: 30, y: 45.239},
  {x: 31, y: 45.348},
  {x: 32, y: 45.452},
  {x: 33, y: 45.551},
  {x: 34, y: 45.646},
  {x: 35, y: 45.736},
  {x: 36, y: 45.824},
  {x: 37, y: 45.907},
  {x: 38, y: 45.988},
  {x: 39, y: 46.065},
  {x: 40, y: 46.14},
  {x: 41, y: 46.212},
  {x: 42, y: 46.281},
  {x: 43, y: 46.349},
  {x: 44, y: 46.414},
  {x: 45, y: 46.477},
  {x: 46, y: 46.538},
  {x: 47, y: 46.597},
  {x: 48, y: 46.655},
  {x: 49, y: 46.71},
  {x: 50, y: 46.765},
  {x: 51, y: 46.819},
  {x: 52, y: 46.871},
  {x: 53, y: 46.922},
  {x: 54, y: 46.972},
  {x: 55, y: 47.021},
  {x: 56, y: 47.068},
  {x: 57, y: 47.116},
  {x: 58, y: 47.161},
  {x: 59, y: 47.206},
  {x: 60, y: 47.251},
  {x: 61, y: 47.289}
]
const cephalicPerimeterGirlsFiftheen = [
  {x: 0, y: 32.651},
  {x: 1, y: 35.368},
  {x: 2, y: 37.048},
  {x: 3, y: 38.308},
  {x: 4, y: 39.338},
  {x: 5, y: 40.198},
  {x: 6, y: 40.922},
  {x: 7, y: 41.537},
  {x: 8, y: 42.061},
  {x: 9, y: 42.512},
  {x: 10, y: 42.904},
  {x: 11, y: 43.247},
  {x: 12, y: 43.551},
  {x: 13, y: 43.823},
  {x: 14, y: 44.069},
  {x: 15, y: 44.292},
  {x: 16, y: 44.498},
  {x: 17, y: 44.689},
  {x: 18, y: 44.868},
  {x: 19, y: 45.039},
  {x: 20, y: 45.201},
  {x: 21, y: 45.358},
  {x: 22, y: 45.509},
  {x: 23, y: 45.656},
  {x: 24, y: 45.797},
  {x: 25, y: 45.933},
  {x: 26, y: 46.064},
  {x: 27, y: 46.19},
  {x: 29, y: 46.311},
  {x: 30, y: 46.426},
  {x: 31, y: 46.536},
  {x: 32, y: 46.641},
  {x: 33, y: 46.741},
  {x: 34, y: 46.837},
  {x: 35, y: 46.928},
  {x: 36, y: 47.016},
  {x: 37, y: 47.101},
  {x: 38, y: 47.182},
  {x: 39, y: 47.26},
  {x: 40, y: 47.335},
  {x: 41, y: 47.408},
  {x: 42, y: 47.478},
  {x: 43, y: 47.546},
  {x: 44, y: 47.611},
  {x: 45, y: 47.675},
  {x: 46, y: 47.736},
  {x: 47, y: 47.795},
  {x: 48, y: 47.853},
  {x: 49, y: 47.91},
  {x: 50, y: 47.965},
  {x: 51, y: 48.019},
  {x: 52, y: 48.071},
  {x: 53, y: 48.122},
  {x: 54, y: 48.172},
  {x: 55, y: 48.221},
  {x: 56, y: 48.269},
  {x: 57, y: 48.316},
  {x: 58, y: 48.362},
  {x: 59, y: 48.408},
  {x: 60, y: 48.452},
  {x: 61, y: 48.49}
]
const cephalicPerimeterGirlsFifthy = [
  {x: 0, y: 33.879},
  {x: 1, y: 36.585},
  {x: 2, y: 38.305},
  {x: 3, y: 39.596},
  {x: 4, y: 40.652},
  {x: 5, y: 41.533},
  {x: 6, y: 42.274},
  {x: 7, y: 42.903},
  {x: 8, y: 43.44},
  {x: 9, y: 43.901},
  {x: 10, y: 44.301},
  {x: 11, y: 44.651},
  {x: 12, y: 44.961},
  {x: 13, y: 45.238},
  {x: 14, y: 45.488},
  {x: 15, y: 45.715},
  {x: 16, y: 45.924},
  {x: 17, y: 46.118},
  {x: 18, y: 46.301},
  {x: 19, y: 46.474},
  {x: 20, y: 46.639},
  {x: 21, y: 46.798},
  {x: 22, y: 46.952},
  {x: 23, y: 47.101},
  {x: 24, y: 47.244},
  {x: 25, y: 47.383},
  {x: 26, y: 47.516},
  {x: 27, y: 47.644},
  {x: 29, y: 47.766},
  {x: 30, y: 47.883},
  {x: 31, y: 47.994},
  {x: 32, y: 48.1},
  {x: 33, y: 48.202},
  {x: 34, y: 48.298},
  {x: 35, y: 48.391},
  {x: 36, y: 48.48},
  {x: 37, y: 48.565},
  {x: 38, y: 48.647},
  {x: 39, y: 48.726},
  {x: 40, y: 48.802},
  {x: 41, y: 48.876},
  {x: 42, y: 48.947},
  {x: 43, y: 49.015},
  {x: 44, y: 49.081},
  {x: 45, y: 49.145},
  {x: 46, y: 49.206},
  {x: 47, y: 49.266},
  {x: 48, y: 49.325},
  {x: 49, y: 49.382},
  {x: 50, y: 49.437},
  {x: 51, y: 49.491},
  {x: 52, y: 49.544},
  {x: 53, y: 49.595},
  {x: 54, y: 49.645},
  {x: 55, y: 49.695},
  {x: 56, y: 49.743},
  {x: 57, y: 49.79},
  {x: 58, y: 49.837},
  {x: 59, y: 49.882},
  {x: 60, y: 49.927},
  {x: 61, y: 49.965}
]
const cephalicPerimeterGirlsEightyFive = [
  {x: 0, y: 35.106},
  {x: 1, y: 37.801},
  {x: 2, y: 39.562},
  {x: 3, y: 40.884},
  {x: 4, y: 41.966},
  {x: 5, y: 42.868},
  {x: 6, y: 43.627},
  {x: 7, y: 44.27},
  {x: 8, y: 44.818},
  {x: 9, y: 45.289},
  {x: 10, y: 45.697},
  {x: 11, y: 46.055},
  {x: 12, y: 46.371},
  {x: 13, y: 46.653},
  {x: 14, y: 46.907},
  {x: 15, y: 47.138},
  {x: 16, y: 47.35},
  {x: 17, y: 47.548},
  {x: 18, y: 47.734},
  {x: 19, y: 47.909},
  {x: 20, y: 48.077},
  {x: 21, y: 48.239},
  {x: 22, y: 48.395},
  {x: 23, y: 48.545},
  {x: 24, y: 48.691},
  {x: 25, y: 48.832},
  {x: 26, y: 48.967},
  {x: 27, y: 49.097},
  {x: 29, y: 49.221},
  {x: 30, y: 49.339},
  {x: 31, y: 49.452},
  {x: 32, y: 49.559},
  {x: 33, y: 49.662},
  {x: 34, y: 49.76},
  {x: 35, y: 49.854},
  {x: 36, y: 49.944},
  {x: 37, y: 50.03},
  {x: 38, y: 50.113},
  {x: 39, y: 50.193},
  {x: 40, y: 50.27},
  {x: 41, y: 50.344},
  {x: 42, y: 50.415},
  {x: 43, y: 50.484},
  {x: 44, y: 50.55},
  {x: 45, y: 50.614},
  {x: 46, y: 50.677},
  {x: 47, y: 50.737},
  {x: 48, y: 50.796},
  {x: 49, y: 50.853},
  {x: 50, y: 50.909},
  {x: 51, y: 50.963},
  {x: 52, y: 51.016},
  {x: 53, y: 51.068},
  {x: 54, y: 51.119},
  {x: 55, y: 51.168},
  {x: 56, y: 51.217},
  {x: 57, y: 51.264},
  {x: 58, y: 51.311},
  {x: 59, y: 51.356},
  {x: 60, y: 51.402},
  {x: 61, y: 51.44}
]
const cephalicPerimeterGirlsNintySeven = [
  {x: 0, y: 36.106},
  {x: 1, y: 38.793},
  {x: 2, y: 40.587},
  {x: 3, y: 41.934},
  {x: 4, y: 43.036},
  {x: 5, y: 43.955},
  {x: 6, y: 44.728},
  {x: 7, y: 45.383},
  {x: 8, y: 45.942},
  {x: 9, y: 46.42},
  {x: 10, y: 46.835},
  {x: 11, y: 47.198},
  {x: 12, y: 47.519},
  {x: 13, y: 47.806},
  {x: 14, y: 48.063},
  {x: 15, y: 48.298},
  {x: 16, y: 48.513},
  {x: 17, y: 48.713},
  {x: 18, y: 48.901},
  {x: 19, y: 49.079},
  {x: 20, y: 49.249},
  {x: 21, y: 49.413},
  {x: 22, y: 49.57},
  {x: 23, y: 49.723},
  {x: 24, y: 49.87},
  {x: 25, y: 50.012},
  {x: 26, y: 50.149},
  {x: 27, y: 50.281},
  {x: 29, y: 50.406},
  {x: 30, y: 50.526},
  {x: 31, y: 50.64},
  {x: 32, y: 50.748},
  {x: 33, y: 50.852},
  {x: 34, y: 50.951},
  {x: 35, y: 51.046},
  {x: 36, y: 51.136},
  {x: 37, y: 51.223},
  {x: 38, y: 51.307},
  {x: 39, y: 51.388},
  {x: 40, y: 51.465},
  {x: 41, y: 51.54},
  {x: 42, y: 51.612},
  {x: 43, y: 51.681},
  {x: 44, y: 51.748},
  {x: 45, y: 51.812},
  {x: 46, y: 51.875},
  {x: 47, y: 51.936},
  {x: 48, y: 51.995},
  {x: 49, y: 52.053},
  {x: 50, y: 52.108},
  {x: 51, y: 52.162},
  {x: 52, y: 52.216},
  {x: 53, y: 52.268},
  {x: 54, y: 52.319},
  {x: 55, y: 52.369},
  {x: 56, y: 52.418},
  {x: 57, y: 52.465},
  {x: 58, y: 52.512},
  {x: 59, y: 52.558},
  {x: 60, y: 52.603},
  {x: 61, y: 52.642}
]

const boyGraphics = new Map()
const girlGraphics = new Map()

girlGraphics.set('weight', [
  weightGirlsThree,
  weightGirlsFiftheen,
  weightGirlsFifthy,
  weightGirlsEightyFive,
  weightGirlsNintySeven])
girlGraphics.set('height', [
  heightGirlsThree,
  heightGirlsFiftheen,
  heightGirlsFifthy,
  heightGirlsEightyFive,
  heightGirlsNintySeven])
girlGraphics.set('bmi', [
  bmiGirlsThree,
  bmiGirlsFiftheen,
  bmiGirlsFifthy,
  bmiGirlsEightyFive,
  bmiGirlsNintySeven])
girlGraphics.set('cephalicPerimeter', [
  cephalicPerimeterGirlsThree,
  cephalicPerimeterGirlsFiftheen,
  cephalicPerimeterGirlsFifthy,
  cephalicPerimeterGirlsEightyFive,
  cephalicPerimeterGirlsNintySeven])

boyGraphics.set('weight', [
  weightBoysThree,
  weightBoysFiftheen,
  weightBoysFifthy,
  weightBoysEightyFive,
  weightBoysNintySeven])
boyGraphics.set('height', [
  heightBoysThree,
  heightBoysFiftheen,
  heightBoysFifthy,
  heightBoysEightyFive,
  heightBoysNintySeven])
boyGraphics.set('bmi', [
  bmiBoysThree,
  bmiBoysFiftheen,
  bmiBoysFifthy,
  bmiBoysEightyFive,
  bmiBoysNintySeven])
boyGraphics.set('cephalicPerimeter', [
  cephalicPerimeterBoysThree,
  cephalicPerimeterBoysFiftheen,
  cephalicPerimeterBoysFifthy,
  cephalicPerimeterBoysEightyFive,
  cephalicPerimeterBoysNintySeven])

function getColors (gender) {
  if (gender === GENDER.BOY) {
    return ['#cde6ff', '#b3d9ff', '#80c0ff', '#4da6ff', '#0080ff']
  } else {
    return ['#ffcce6', '#ff99cc', '#ff66b3', '#ff3399', '#ff0080']
  }
}

function getGraphicData (gender, type) {
  if (gender === GENDER.BOY) {
    return boyGraphics.get(type)
  } else {
    return girlGraphics.get(type)
  }
}

export function getPercentileData (gender, type) {
  const colors = getColors(gender)
  return [
    {title: 'p3',
      type: 'line',
      color: colors[0],
      noHover: true,
      ignoreX: true,
      xType: 'time',
      isDifferentScale: false,
      data: getGraphicData(gender, type)[0]
    },
    {title: 'p15',
      type: 'line',
      color: colors[1],
      noHover: true,
      ignoreX: true,
      xType: 'time',
      isDifferentScale: false,
      data: getGraphicData(gender, type)[1]
    },
    {title: 'p50',
      type: 'line',
      color: colors[2],
      noHover: true,
      ignoreX: true,
      xType: 'time',
      isDifferentScale: false,
      data: getGraphicData(gender, type)[2]
    },
    {title: 'p85',
      type: 'line',
      color: colors[3],
      noHover: true,
      ignoreX: true,
      xType: 'time',
      isDifferentScale: false,
      data: getGraphicData(gender, type)[3]
    },
    {title: 'p97',
      type: 'line',
      color: colors[4],
      noHover: true,
      ignoreX: true,
      xType: 'time',
      isDifferentScale: false,
      data: getGraphicData(gender, type)[4]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/general/Consultations/Range/Graphics/PercentileData.js